/*jshint unused:false*/
/*global fetch */
/*global console */

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);

if(ie) {
    var imgContainer = document.querySelectorAll(".img-container");

    for(var i=0; i<imgContainer.length; i++){
        var imgCtr = imgContainer[i];
        var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
        if (imgUrl) {
            imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
            imgCtr.classList.add("custom-object-fit");
        }
    }
}

function writeCookie(key, value, days) {
    let date = new Date();
    days = days || 7;
    date.setTime(+ date + (days * 86400000)); //24 * 60 * 60 * 1000
    window.document.cookie = key + "=" + value + "; expires=" + date.toGMTString() + "; path=/";
    return value;
}

// Back to top button
if(document.getElementById('back_to_top')) {
    const scrollToTopButton = document.getElementById('back_to_top');
    let smoothScrollCapture = (x) => {
        event.preventDefault();
        let id = x.currentTarget.target.getAttribute('href').split("#")[1]
        let el = document.getElementById(id);
        var x = el.getBoundingClientRect().left;
        var y = el.getBoundingClientRect().top;
        smoothScrollFunc(x, y)
    }
    let smoothScrollFunc = (x, y) => {
        event.preventDefault();
        window.scrollTo({
            top: y,
            left: x,
            behavior: 'smooth'
        });
    }
    window.addEventListener('DOMContentLoaded', () => {
        scrollToTopButton.addEventListener('click', () => {
            smoothScrollFunc(0, 0);
        })
    })
    window.addEventListener('scroll', () => {
        let pageHeight = document.body.scrollHeight;
        let currentHeight = window.scrollY;
        (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
    })
}

document.querySelectorAll('select').forEach(v => {
    v.addEventListener('change', (e) => {
        v.blur();
    })
})

// End back to top button

// Price toggles
let selected;
function priceToggles() {
    let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
    let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
    let priceSwitchForm = [].slice.call(document.querySelectorAll('.price-toggle'));
    let toggleOn = [].slice.call(document.querySelectorAll('.price-toggle .toggles-on'));
    let toggleOff = [].slice.call(document.querySelectorAll('.price-toggle .toggles-off'));
    // let priceSwitchForm = document.getElementById('price-switch');
    allSwitches.forEach((value) => {
        value.addEventListener('change', (ev) => {
            (ev.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
            if(ev.composedPath()[0].classList.contains('price-toggle-checkbox')){
                (ev.target.checked === true) ? selected = 1 : selected = 0;
            }

            (selected === 0) ? toggleOn.forEach(value => { value.classList.add('active') }) : toggleOn.forEach(value => { value.classList.remove('active') });
            (selected === 1) ? toggleOff.forEach(value => { value.classList.add('active') }) : toggleOff.forEach(value => { value.classList.remove('active') });
            toggleSwitches();
            togglePrices();
            updatePrice();
            // updateButton();
            // updateHeader();
            // ev.target.scrollIntoView();
            if (ev.target.id === 'toggle-off-top-2' || ev.target.id === 'toggle-on-top-2') {
                document.querySelector(`#quote-form`) ? document.querySelector(`#quote-form #type-${ev.target.value.toLowerCase()}`).dispatchEvent(new Event('change')) : null;
            }
        })
    })
    let toggleSwitches = () => {
        allSwitches.forEach((v) => {
            (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
            (selected === 0) ? document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = false }) : document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = true });
        })
        document.querySelector("#switch-price-type").setAttribute('value', ((selected === 0) ? 'Personal' : 'Business'));
        document.querySelectorAll(".price-title-type").forEach((v) => {
            v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
        })
    }
    let togglePrices = () => {
        priceContainers.forEach((v) => {
            (selected === 0) ? v.querySelectorAll('.price-personal').forEach(value => { value.classList.add('active') }) : v.querySelectorAll('.price-personal').forEach((value => { value.classList.remove('active') }));
            (selected === 1) ? v.querySelectorAll('.price-business').forEach(value => { value.classList.add('active') }) : v.querySelectorAll('.price-business').forEach((value => { value.classList.remove('active') }));
        })
    }
    let updatePrice = () => {
        let url = priceSwitchForm[0].getAttribute('action');
        let formData = new FormData(priceSwitchForm[0]);
        fetch(url, {
            method: 'POST',
            processData: false,
            contentType: false,
            body: formData,
            headers: {
                'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
                'X-Requested-With': 'XMLHttpRequest'
            },
        }).then(
            function(response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' + response.status);
                    return;
                }
                response.json().then(function(data) {
                    document.querySelector("#price-switch [name=_token]").value = data.token;
                });
            }
        ).catch(function(err) {
            console.log('Fetch Error :-S', err);
        });
    }
    let updateButton = () => {
        let manufacturerButton = document.querySelector('.view-all > a');
        if (manufacturerButton) {
            (selected === 0) ? manufacturerButton.setAttribute('href', '/car-leasing/manufacturers') : manufacturerButton.setAttribute('href', '/van-leasing/manufacturers');
        }
    }
    let updateHeader = () => {
        let manufacturerHeader = document.querySelector('.manufacturer-strip-intro > h2 > span');
        if (manufacturerHeader) {
            (selected === 0) ? manufacturerHeader.innerHTML = 'Car' : manufacturerHeader.innerHTML = 'Van';
        }
    }
}
priceToggles();
// END price Toggles

// Type Query
function containsQueryParam(paramName) {
    const url = new URL(window.location.href);
    return url.searchParams.has(paramName);
}
if (containsQueryParam('type')){
    let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
    let selected = 0;
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    if (params.type == 'Personal') {
        selected = 0
    } else {
        selected = 1
    }
    allSwitches.forEach((v) => {
        (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
        (selected === 0) ? document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = false }) : document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = true });
    })
    document.querySelector("#switch-price-type").setAttribute('value', ((selected === 0) ? 'Personal' : 'Business'));
    document.querySelectorAll(".price-title-type").forEach((v) => {
        v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
    })
    setTimeout(() => {
        let priceSwitchForm = [].slice.call(document.querySelectorAll('.price-toggle'));
        let url = priceSwitchForm[0].getAttribute('action');
        let formData = new FormData(priceSwitchForm[0]);
        fetch(url, {
            method: 'POST',
            processData: false,
            contentType: false,
            body: formData,
            headers: {
                'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
                'X-Requested-With': 'XMLHttpRequest'
            },
        }).then(
            function(response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' + response.status);
                    return;
                }
                response.json().then(function(data) {
                    document.querySelector("#price-switch [name=_token]").value = data.token;
                });
            }
        ).catch(function(err) {
            console.log('Fetch Error :-S', err);
        });
    }, 800)
}
// End Type Query

function rangeTable() {

// Table Sorting
    function sortTable(elem, name, direction) {
        let sortName,sortDirection;
        if (name && direction) {
            sortName = name;
            sortDirection = direction;
        } else {
            sortName = elem.composedPath()[0].dataset.sortname;
            sortDirection = elem.composedPath()[0].dataset.sortdirection;
        }
        let tableBody = document.querySelector('.model-table-body');
        let tableRows = Array.from(tableBody.children);
        tableRows.pop();

        let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
            a = a.dataset[sortName];
            b = b.dataset[sortName];
            if (sortName === 'price') {
                return (dir === 'asc') ? b.localeCompare(a, 'en', {numeric: true}) : a.localeCompare(b, 'en', {numeric: true});
            }
            return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
        });

        if (sortDirection.length && sortDirection === 'asc') {
            [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
            (name && direction) ? null : elem.composedPath()[0].setAttribute('data-sortdirection', 'desc');
            let sortTable = sortRows('desc').forEach(function (value) {
                value.remove();
                tableBody.prepend(value);
            });
        } else {
            [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
            (name && direction) ? null : elem.composedPath()[0].setAttribute('data-sortdirection', 'asc');
            let sortTable = sortRows('asc').forEach(function (value) {
                value.remove();
                tableBody.prepend(value);
            });
        }
    }

// Sort Model Table
    let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
    [...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val)));

    let sortDropdown = document.querySelector('#table-sorter');
    if (sortDropdown) {
        sortDropdown.addEventListener('change', (e) => {
            (e.target.value === 'price_asc') ? sortTable(null, 'price', 'desc') : null;
            (e.target.value === 'price_desc') ? sortTable(null, 'price', 'asc') : null;
            (e.target.value === 'offers') ? sortTable(null, 'offer', 'asc') : null;
            (e.target.value === 'stock') ? sortTable(null, 'stock', 'asc') : null;
        })
    }

// Show no results text
    const showNoResults = function() {
        if(!document.querySelectorAll('.deal-box:not([class*="hidden"]):not(.no-results)').length > 0) {
            document.querySelector('.no-results').classList.remove('hidden-no-results', 'hidden');
        } else {
            document.querySelector('.no-results').classList.add('hidden-no-results');
        }
    }

// Show stock offers only
    let checkboxStock = document.querySelector('.stock [name=stock]');
    let modelNonStockDeals = document.querySelectorAll('#model-table .deal-box[data-stock="0"]');

    let inStockNum = document.querySelectorAll('#model-table .deal-box[data-stock="1"]').length;
    let allDealsNum = document.querySelectorAll('.deal-box:not([class*="hidden"]):not(.no-results)').length;
    let dealsAvailable = document.querySelector('#filters-form h3 span');

    if(checkboxStock && modelNonStockDeals){
        checkboxStock.addEventListener('change', (ev) => {
            if (ev.target.checked === true) {
                modelNonStockDeals.forEach((value) => {
                    value.classList.add('visuallyhidden')
                    showNoResults();
                    dealsAvailable.innerHTML = '(' + `${inStockNum}` + ' deals available)';
                })
            } else {
                modelNonStockDeals.forEach((value) => {
                    value.classList.remove('visuallyhidden')
                    showNoResults();
                    dealsAvailable.innerHTML = '(' + `${allDealsNum}` + ' deals available)';
                })
            }
        })
    }

// Model Table Search
    if (document.querySelector('#filters-form')) {
        let filterFields = document.querySelectorAll('#filters-form .filters input');
        const filterTable = (field, value) => {
            let searchType = field;

            if (value !== '' && value.length > 0) {
                let elements = document.querySelectorAll('.deal-box[data-' + searchType + ']');
                if (value.includes('-')) {
                    let value_low = Number(value.split('-')[0]);
                    let value_high = Number(value.split('-')[1]);
                    elements.forEach((v) => {
                        v.classList.add('hidden-' + field + '')
                        let deal_box_value = Number(v.getAttribute('data-' + searchType + '').replace('£', ''))
                        if(deal_box_value >= value_low && deal_box_value <= value_high) {
                            v.classList.remove('hidden-' + field + '')
                        }
                    })
                } else {
                    elements.forEach((v) => {
                        v.classList.add('hidden-' + field + '')
                        if(v.getAttribute('data-' + searchType + '').includes(value)) {
                            v.classList.remove('hidden-' + field + '')
                        }
                    })
                }
            } else {
                document.querySelectorAll('.deal-box[data-' + searchType + ']').forEach((v) => {
                    v.classList.remove('hidden-' + field + '')
                });
            }
            showNoResults();
        }
        if (filterFields) {
            filterFields.forEach((value => {
                value.addEventListener('change', (event) => {
                    let val = value.value;
                    let field = value.getAttribute('name');

                    filterTable(field, val);

                    if(val===field + "-any"){
                        document.querySelectorAll('.deal-box[data-' + field + ']').forEach((v) => {
                            v.classList.remove('hidden-' + field + '')
                            showNoResults()
                        });
                    }
                })
            }))
        }
    }
// End Model Table Search

// Model Table Search Mobile
//   if (document.querySelector('#filters-form-mobile')) {
//     let filterFields = document.querySelectorAll('#filters-form-mobile .filters input');
//     const filterTable = (field, value) => {
//       let searchType = field;
//
//       if (value !== '' && value.length > 0) {
//         let elements = document.querySelectorAll('.deal-box[data-' + searchType + ']');
//         elements.forEach((v) => {
//           v.classList.add('hidden-' + field + '')
//           if(v.getAttribute('data-' + searchType + '').includes(value)) {
//             v.classList.remove('hidden-' + field + '')
//           }
//         })
//       } else {
//         document.querySelectorAll('.deal-box[data-' + searchType + ']').forEach((v) => {
//           v.classList.remove('hidden-' + field + '')
//         });
//       }
//
//       // Show no results text
//       showNoResults();
//     }
//     if (filterFields) {
//       filterFields.forEach((value => {
//         value.addEventListener('change', (event) => {
//           let val = value.value;
//           let field = value.getAttribute('name');
//
//           filterTable(field, val);
//
//           if(val===field +"-any"){
//             document.querySelectorAll('.deal-box[data-' + field + ']').forEach((v) => {
//               v.classList.remove('hidden-' + field + '')
//               showNoResults()
//             });
//           }
//         })
//       }))
//     }
//   }
// End Model Table Search Mobile

// Model Table Terms
    function loadTablePrices(vehicleType, vehicleIds) {
        let priceView = document.querySelector('#switch-price-type').value;
        let term = document.querySelector('.range-filters [name="term"]');
        let profile = document.querySelector('.range-filters [name="profile"]');
        let mileage = document.querySelector('.range-filters [name="mileage"]');

        document.querySelectorAll('.deal-box-price .price-amount p.active').forEach(element => element.classList.add('price-loader'));
        // document.querySelectorAll('.filter-form-terms').forEach(element => element.parentElement.parentElement.parentElement.classList.add('filter-loader'));
        if (vehicleType && vehicleIds && term && profile && mileage && priceView) {
            // let url = `/api/${vehicleType}/price/bulk?${vehicleIds}term=${term.value}&initial_profile=${profile.value}&mileage=${mileage.value}&price_view=${priceView}`;
            let url = `/api/${vehicleType}/price/bulk?${vehicleIds}&price_view=${priceView}`;
            fetch(url, {
                method: 'GET',
                // body: formData,
            }).then(function (response) {
                if (response.status !== 200) {
                    console.warn('Looks like there was a problem. Status Code: ' + response.status);
                    return;
                }
                return response.json();
            }).then(function (data) {
                if(data){
                    data.forEach((v, i) => {
                        if (v) {
                            if (vehicleType === 'van') {
                                if (v.monthly_rental) {
                                    let [intPart, decPart] = parseFloat(v.monthly_rental).toFixed(2).split('.');

                                    document.querySelector(`.deal-box[data-id="${v.van_id}"] .deal-box-price .price-amount > p.active > span.price`).innerHTML =
                                        `£${intPart}<span class="decimals">.${decPart}</span>`;

                                    document.querySelector(`.deal-box[data-id="${v.van_id}"]`).setAttribute('data-price', `£${v.monthly_rental.toLocaleString("en", {useGrouping: false, minimumFractionDigits: 2})}`);
                                } else {
                                    document.querySelector(`.deal-box[data-id="${v.van_id}"] .deal-box-price .price-amount > p.active > span.price`).innerHTML = 'POA';
                                    document.querySelector(`.deal-box[data-id="${v.van_id}"]`).setAttribute('data-price', 'POA');
                                }
                            } else {
                                if (v.monthly_rental) {
                                    let [intPart, decPart] = parseFloat(v.monthly_rental).toFixed(2).split('.');

                                    document.querySelector(`.deal-box[data-id="${v.car_id}"] .deal-box-price .price-amount > p.active > span.price`).innerHTML =
                                        `£${intPart}<span class="decimals">.${decPart}</span>`;

                                    document.querySelector(`.deal-box[data-id="${v.car_id}"]`).setAttribute('data-price', `£${v.monthly_rental.toLocaleString("en", {useGrouping: false, minimumFractionDigits: 2})}`);
                                } else {
                                    document.querySelector(`.deal-box[data-id="${v.car_id}"] .deal-box-price .price-amount > p.active > span.price`).innerHTML = 'POA';
                                    document.querySelector(`.deal-box[data-id="${v.car_id}"]`).setAttribute('data-price', 'POA');
                                }
                            }
                        } else {
                            document.querySelector(`.deal-box:nth-child(${i+1}) .deal-box-price .price-amount > p.active > span.price`).innerHTML = 'POA';
                        }
                    })
                    // document.querySelector('#filters-form .filters input[name="price"]:checked').dispatchEvent(new Event('change'));
                    document.querySelectorAll('.deal-box-price .price-amount p.active').forEach(element => element.classList.remove('price-loader'));
                    // document.querySelectorAll('.filter-form-terms').forEach(element => element.parentElement.parentElement.parentElement.classList.remove('filter-loader'));
                }
            }).catch(function (err) {
                console.error('Fetch Error -', err);
            });
        }
    }
    if (document.querySelector('.range-filters') && document.querySelector('.model-table-body > div')) {
        let tableRows = document.querySelectorAll('.model-table-body > div:not(.no-results)');
        let vehicleIds = '';
        let vehicleType = document.querySelector('.model-table-body > div:not(.no-results)').dataset.type;
        tableRows.forEach(v => {
            vehicleIds += `ids[]=${v.dataset.id}&`
        })

        loadTablePrices(vehicleType, vehicleIds)
        document.querySelectorAll('.range-filters .search-results-form-terms select').forEach(value => {
            value.addEventListener('change', e => {
                loadTablePrices(vehicleType, vehicleIds)
            })
        })
    }
// End Model Table Terms
}
rangeTable()

if (document.querySelector('#manufacturer_lookup')) {
    document.querySelector('#manufacturer_lookup').addEventListener('focus', (ev) => {
        if (!ev.target.classList.contains('loaded')) {
            let type = ev.target.dataset.type;
            let target = ev.target
            let url = `/api/${type}/manufacturers/ev`;
            let params = '?' + new URLSearchParams({'available': 'yes'})
            fetch(url + params).then(function(response) {
                if (response.status !== 200) {
                    console.warn('Looks like there was a problem. Status Code: ' + response.status);
                    return;
                }
                return response.json();
            }).then(function(data) {
                let keysSorted = Object.keys(data).sort(function(a, b) {
                    return data[a].localeCompare(data[b])
                });
                for (let x in keysSorted) {
                    let option = document.createElement('option');
                    option.setAttribute('data-url', `/${type}-leasing/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}`);
                    option.setAttribute('value', `${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}`);
                    option.text = `${data[keysSorted[x]].toUpperCase()}`;
                    target.appendChild(option);
                }
                ev.target.classList.add('loaded');
            }).catch(function(err) {
                console.error('Fetch Error -', err);
            });
        }
    })
}

//Nav Toggle
// function toggleNav(el) {
//     var element = el;
//     var menu = document.getElementById("site-menu");
//     var header = document.querySelectorAll(".site-header")[0];
//     menu.classList.toggle("active");
//     header.classList.toggle("active");
//
//     if(element.querySelector("span").classList.contains("more")){
//       element.innerHTML = "<span class='close'></span> Close";
//     } else {
//       element.innerHTML = "<span class='more'></span> Menu";
//     }
// }
function loadManufacturersNav($el) {
    if ($el) {
        $el.forEach(v => {
            if (!v.classList.contains('loaded')) {
                let type = v.dataset.id;
                let target = document.querySelector(`.slideout-navigation [data-dropdown=${type}]`)
                let url = `/api/${type}/manufacturers/`;
                let params = '?' + new URLSearchParams({'available': 'yes'})
                fetch(url + params).then(function(response) {
                    if (response.status !== 200) {
                        console.warn('Looks like there was a problem. Status Code: ' + response.status);
                        return;
                    }
                    return response.json();
                }).then(function(data) {
                    let keysSorted = Object.keys(data).sort(function(a, b) {
                        return data[a].localeCompare(data[b])
                    });
                    for (let x in keysSorted) {
                        let link = document.createElement('a');
                        link.setAttribute('href', `/${type}-leasing/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}`);
                        link.innerHTML = `${data[keysSorted[x]].toUpperCase()} <img src="/themes/lcvgroup/img/manufacturer/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}.svg" alt="${keysSorted[x]}" width="26" height="26" onerror="this.style.display='none'">`;
                        target.appendChild(link)
                    }
                    v ? v.classList.add('loaded') : null;
                }).catch(function(err) {
                    console.error('Fetch Error -', err);
                });
            }
        })
    }
}

// Toggle Nav Sidebar
document.querySelector('.slideout-navigation-toggle') ? document.querySelectorAll('.slideout-navigation-toggle').forEach((value) => {
    value.addEventListener('click', () => {
        document.body.classList.toggle('slideout-navigation-active');
        loadManufacturersNav(document.querySelectorAll('.slideout-navigation [data-manufacturers]'))
    })
}) : null;
// Close Nav Sidebar
document.querySelector('.slideout-navigation-close') ? document.querySelectorAll('.slideout-navigation-close').forEach((value) => {
    value.addEventListener('click', () => {
        document.body.classList.remove('slideout-navigation-active');
    })
}) : null;
document.querySelectorAll('.burger-navigation-main > a[data-id], .burger-navigation-sub-1 > a[data-id]').forEach(value => {
    value.addEventListener('click', (ev) => {
        ev.target.classList.toggle('active');
        (ev.target.nextElementSibling.dataset.dropdown === ev.target.dataset.id) ? ev.target.nextElementSibling.classList.toggle('active') : null;
    })
})
document.querySelectorAll('.burger-navigation-sub-3-open').forEach(value => {
    value.addEventListener('click', (ev) => {
        ev.target.classList.remove('active');
        document.querySelector('.burger-navigation-main').classList.remove('active');
        document.querySelector(`.burger-navigation-sub-3[data-dropdown=${value.dataset.id}]`).classList.add('active');
    })
})
document.querySelectorAll('.burger-navigation-sub-3-close').forEach(value => {
    value.addEventListener('click', (ev) => {
        ev.target.classList.remove('active');
        document.querySelector('.burger-navigation-main').classList.add('active');
        document.querySelectorAll('.burger-navigation-sub-3').forEach(v => { v.classList.remove('active'); })
    })
})

/* MOBILE MODALS */
// const navContainer = document.querySelector('.nav-container');
// const hamburger = document.querySelector('#hamburger');
// const hamburgerSearch = document.querySelector('#headerSearch');
//
// const modalMobileNav = new tingle.modal({
//   footer: false,
//   closeMethods: ['escape'],
//   cssClass: ['mobile-nav','reversed'],
//   onOpen: function () {
//     // Navigation height
//     let headerHeight = 0;
//     if (document.querySelector('.site-header').classList.contains('is-sticky')) {
//       headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight;
//     } else {
//       headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight + (document.body.getBoundingClientRect().top + window.scrollY);
//     }
//     document.querySelector('.mobile-nav.tingle-modal').setAttribute('style', `margin-top:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
//     // document.querySelector('.site-menu') ? modalMobileNav.setFooterContent(document.querySelector('#price-switch').outerHTML) : null;
//     // priceToggles();
//   }
// });
// document.querySelector('.site-menu') ? modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML) : null;
//
// // Nav modal
// const handleToggle = () => {
//   hamburger.classList.toggle('active');
//   hamburger.classList.toggle('is-active');
//   navContainer.classList.toggle('is-active');
//   // hamburger.parentElement.classList.toggle('active');
//
//   if(hamburger.classList.contains("active")) {
//     // modalMobileSearch.close();
//     modalMobileNav.open();
//   } else{
//     modalMobileNav.close();
//   }
// }
//
// hamburger.onclick = () => handleToggle();
// hamburger.addEventListener('keyup', (event) => {
//   if(event.keyCode === 13 || event.keyCode === 32) {
//     handleToggle();
//   }
// });
/* END MOBILE MODALS */

// Sticky class for navbar & modal
// window.onscroll = function() { stickyNav() };
// let page = document.querySelector('#page');
// let navbar = document.getElementById('navbar');
// let sticky = navbar.offsetTop;
// function stickyNav() {
//   if (!document.body.classList.contains('tingle-enabled')) {
//     if (window.pageYOffset >= sticky) {
//       (page) ? page.style.paddingTop = '120px' : null;
//       navbar.classList.add('is-sticky');
//     } else {
//       (page) ? page.style.paddingTop = '0' : null;
//       navbar.classList.remove('is-sticky');
//     }
//   }
// }
// window.addEventListener("orientationchange", function() {
//   (page) ? page.style.paddingTop = '0' : null;
//   navbar.classList.remove('is-sticky');
// }, false);

// Review Video Modals
const videoButton = document.querySelectorAll('.deal-gallery-main.video-trigger');
const videoModal = new tingle.modal({
    footer: false,
    closeMethods: ['overlay', 'button', 'escape'],
    closeLabel: "Close",
    cssClass: ['video-modal'],
    onClose: function() {
        this.setContent('');
    }
});
videoButton.forEach((value) => {
    value.addEventListener("click", function(e){
        const videoWrapper = document.querySelector('#review-video');
        const videoWrapperClone = videoWrapper.cloneNode(true);
        if (videoWrapperClone) {
            videoModal.setContent(videoWrapperClone);
            videoModal.open();
            videoWrapperClone.querySelector('video').play();
        }
    })
})
// END Review Video Modals


// Search Bar
var searchDropdown = function(){
    var searchRow = this.closest('.search-bar');
    searchRow.classList.toggle("active");
}

var searchBar = document.querySelectorAll(".search-bar .legend");

for(var i=0; i<searchBar.length; i++){
    searchBar[i].addEventListener('click', searchDropdown, false);
}


if(document.getElementsByClassName('toggle-search').length>0){
    document.getElementsByClassName('toggle-search')[0].addEventListener('click', function(e){
        e.preventDefault();
        if(document.querySelector('#popout-form')===null){
            window.location.href='/search';
            return false;
        }
        if(document.querySelector('#popout-form').classList.contains('hidden')){
            document.querySelector('#popout-form').classList.remove('hidden');
        } else {
            document.querySelector('#popout-form').classList.add('hidden');
        }
    });
}

const searchSorter = document.querySelector('#search-sorter');
if (searchSorter) {
    searchSorter.addEventListener('change', (e) => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('order', e.target.value);
        if ((e.target.value === 'price_asc' || e.target.value === 'price_desc') && !window.location.search.includes('initial_profile')) {
            urlParams.set('initial_profile', e.target.dataset.profile);
        }
        window.location.search = urlParams;
    })
}

// Show More
const showMoreButton = document.querySelector('#show-more');
const headerContent = document.querySelector('.header-content');
if(showMoreButton){
    if (showMoreButton.parentElement.parentElement.querySelectorAll('.header-description > *')) {
        showMoreButton.addEventListener('click', (e) => {
            // console.log('click')
            headerContent.classList.toggle('header-content--full');
            showMoreButton.classList.toggle('active');
            (showMoreButton.classList.contains('active')) ? showMoreButton.querySelector('span').innerText = 'Show less' : showMoreButton.querySelector('span').innerText = 'Read more';
        })
    } else {
        showMoreButton.classList.add('visuallyhidden')
    }
}
// END Show More


//Menu Dropdown Toggle
// var menuDropdown = function(){
//     var dropdown = this;
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }

// //Dropdown Button
// var showDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var dropdownButton = document.querySelectorAll(".dropdown > button");

// for(var i=0; i<dropdownButton.length; i++){
//   dropdownButton[i].addEventListener('click', showDropdown, false);
// }

// //Dropdown Toggle
// var showDropdown = function(){
//     var dropdown = this.querySelector('div');
//     dropdown.classList.toggle("active");
// }

// var has_dropdown = document.querySelectorAll(".has-dropdown");

// for(var i=0; i<has_dropdown.length; i++){
//   has_dropdown[i].addEventListener('click', showDropdown, false);
// }

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }


// Site Search Toggle
// var searchToggle = function(){
//   search_container = document.querySelector(".popout-form");
//   if(search_container){
//     search_container.classList.toggle("active");
//   } else {
//     var elmnt = document.querySelector(".full-header-search");
//     elmnt.scrollIntoView();
//   }
// }

// var search_toggle = document.getElementById('search-toggle');
// search_toggle.addEventListener('click', searchToggle , false);



//Site Menu Dropdown Toggle
var menuDropdown = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".menu-dropdown.active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
            activeClass[i].classList.toggle("active");
        }
    }

    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
}

var dropdownTrigger = document.querySelectorAll(".menu-dropdown > a");

for(var i=0; i<dropdownTrigger.length; i++){
    dropdownTrigger[i].addEventListener('click', menuDropdown, false);
}


// //Menu Dropdown Toggle
// var menuDropdown = function(){
//     //div inside element contains dropdown menu
//     var dropdown = this.parentNode.querySelector(".menu-dropdown");

//     //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     // //get current active class
//     // var activeClass = document.querySelectorAll(".menu-dropdown.active");
//     // // make it not active
//     // if(activeClass!=null){
//     //     for(var i=0; i<activeClass.length; i++){
//     //       activeClass[i].classList.toggle("active");
//     //     }
//     // }

//     //apply active to the div inside element that contains dropdown menu
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown > a");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }


//Dropdown Menu Toggle
var showMenu = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode.querySelector('div');
    var menuToggle = this;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        menuToggle.classList.toggle("active");
        dropdown.classList.toggle("is-active");
        menuToggle.classList.toggle("is-active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".dropdown-menu .active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
            activeClass[i].classList.toggle("active");
            activeClass[i].classList.toggle("is-active");
        }
    }

    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("active");
    menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
    menuDropdown[i].addEventListener('click', showMenu, false);
}
// Toggle Compare Nav Dropdown
document.querySelector('.compare-btn>a').addEventListener('click', (e)=>{ e.target.parentElement.classList.toggle('active') })

// Toggle class for accordions
function toggleAccordions() {
    let acc = document.getElementsByClassName('mobile-accordion-header');
    for (let i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function(ev) {

            for (let i = 0; i < acc.length; i++) {
                if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
                    continue;
                }
                acc[i].parentElement.classList.remove('active');
            }

            if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
                setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
            }
            this.parentElement.classList.toggle("active");

        });
    }
}
toggleAccordions();


//Dropdown Menu Toggle
// var mobileDropdown = function(){
//   //div inside element contains dropdown menu
//   var dropdown = this.parentNode.querySelector('div');


//   //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     //get current active class
//     var activeClass = document.querySelectorAll(".mobile-dropdown .active");
//     // make it not active
//     if(activeClass!=null){
//         for(var i=0; i<activeClass.length; i++){
//           activeClass[i].classList.toggle("active");
//         }
//     }


//   //apply active to the div inside element that contains dropdown menu
//   dropdown.classList.toggle("active");
// }

// var mobileMenu = document.querySelectorAll(".mobile-dropdown > a");

// for(var i=0; i<mobileMenu.length; i++){
//   mobileMenu[i].addEventListener('click', mobileDropdown, false);
// }


//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
    e.preventDefault();
    var element = document.getElementById("vehicle-search");
    element.classList.toggle("active");
    if(element.classList.contains('active')){
        this.innerHTML = 'Hide additional options';
    } else {
        this.innerHTML = 'Show me more options';
    }
};

for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tab-content");
    tablinks = document.getElementsByClassName("tab");

    //remove active tab
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].className = tabcontent[i].className.replace(" active", "");
    }

    //remove active from button tabs
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    //add active to tab
    document.getElementById(tabName).className += " active";

    //add active to button tabs
    e.currentTarget.className += " active";
}

function showOptions(e, tabName) {
    e.preventDefault();
    document.querySelector(tabName).classList.toggle("active");
}


// SEARCH SIDEBAR
function setUrlParams(param, value, module) {
    let searchUrl = new URL(window.location.origin + window.location.pathname);
    if (module === 'Search') {
        if (window.location.search.includes('offers=specials')) {
            searchUrl.searchParams.set('offers', 'specials');
        } else if (window.location.search.includes('offers=stock')) {
            searchUrl.searchParams.set('offers', 'stock');
        }
        searchUrl.searchParams.set('manufacturer_redirect', 'false');
        searchUrl.searchParams.set('search-type', document.querySelector('#search-type').value);
    } else if (window.location.pathname === '/car-leasing') {
        searchUrl = new URL(window.location.origin + '/search');
        searchUrl.searchParams.set('manufacturer_redirect', 'false');
        searchUrl.searchParams.set('search-type', 'car');
    } else if (window.location.pathname === '/special-offers') {
        searchUrl = new URL(window.location.origin + '/search');
        searchUrl.searchParams.set('manufacturer_redirect', 'false');
        searchUrl.searchParams.set('search-type', 'car');
        searchUrl.searchParams.set('offers', 'specials');
    } else if (window.location.pathname === '/stock') {
        searchUrl = new URL(window.location.origin + '/search');
        searchUrl.searchParams.set('manufacturer_redirect', 'false');
        searchUrl.searchParams.set('search-type', 'car');
        searchUrl.searchParams.set('offers', 'stock');
    } else if (window.location.pathname === '/van-leasing') {
        searchUrl = new URL(window.location.origin + '/search');
        searchUrl.searchParams.set('manufacturer_redirect', 'false');
        searchUrl.searchParams.set('search-type', 'van');
    } else if (window.location.pathname === '/van-leasing/special-offers') {
        searchUrl = new URL(window.location.origin + '/search');
        searchUrl.searchParams.set('manufacturer_redirect', 'false');
        searchUrl.searchParams.set('search-type', 'van');
        searchUrl.searchParams.set('offers', 'specials');
    } else if (window.location.pathname === '/van-leasing/stock') {
        searchUrl = new URL(window.location.origin + '/search');
        searchUrl.searchParams.set('manufacturer_redirect', 'false');
        searchUrl.searchParams.set('search-type', 'van');
        searchUrl.searchParams.set('offers', 'stock');
    } else if (window.location.pathname === '/pick-up-leasing') {
        searchUrl = new URL(window.location.origin + '/search');
        searchUrl.searchParams.set('manufacturer_redirect', 'false');
        searchUrl.searchParams.set('search-type', 'van');
        searchUrl.searchParams.append('body_type', 'Pick-up');
    } else {
        (value==='van') ? searchUrl = new URL(window.location.origin + '/van-leasing' + window.location.pathname) : null;
        (value==='car') ? searchUrl = new URL(window.location.origin + (window.location.pathname).replace('/van-leasing', '')) : null;
        searchUrl.searchParams.set('filter', 'true');
    }
    if(param==='type'){
        searchUrl.searchParams.set('search-type', value);
        searchUrl.searchParams.set('make', '');
        searchUrl.searchParams.set('model', '');
        searchUrl.searchParams.delete('van_size');
        searchUrl.searchParams.delete('body_type');
    } else {
        searchUrl.searchParams.set('make', param==='make' ? value : (document.querySelector('.search-aside input[name="make"]:checked') ? document.querySelector('.search-aside input[name="make"]:checked').value : ''));
        searchUrl.searchParams.set('model', param==='model' ? value : (document.querySelector('.search-aside input[name="model"]:checked') ? document.querySelector('.search-aside input[name="model"]:checked').value : ''));
        // param==='make' ? searchUrl.searchParams.set('model', '') : null;

        if(window.location.pathname !== '/pick-up-leasing'){
            searchUrl.searchParams.set('van_size', (param==='van_size') ? value : (document.querySelector('.search-aside input[name="van_size"]:checked') ? document.querySelector('.search-aside input[name="van_size"]:checked').value : ''));
            searchUrl.searchParams.set('body_type', (param==='body_type') ? value : (document.querySelector('.search-aside input[name="body_type"]:checked') ? document.querySelector('.search-aside input[name="body_type"]:checked').value : ''));
        }

        if(param==='make'){
            searchUrl.searchParams.delete('model');
            searchUrl.searchParams.delete('van_size');
            searchUrl.searchParams.delete('body_type');
        }
        if(param==='model'){
            searchUrl.searchParams.delete('van_size');
            searchUrl.searchParams.delete('body_type');
        }
    }

    let updatedMin = document.querySelector('.search-aside #budget-slider .noUi-handle-lower').getAttribute('data-value');
    let updatedMax = document.querySelector('.search-aside #budget-slider .noUi-handle-upper').getAttribute('data-value');
    if(isNaN(updatedMax) && updatedMin == '0') {
        searchUrl.searchParams.delete('budget');
    } else if(isNaN(updatedMax) && updatedMin != '0') {
        searchUrl.searchParams.set('budget', param==='budget' ? value : (updatedMin + '+'));
    } else{
        searchUrl.searchParams.set('budget', param==='budget' ? value : (updatedMin + '-' + updatedMax));
    }
    searchUrl.searchParams.set('fuel_type', param==='fuel_type' ? value : (document.querySelector('.search-aside input[name="fuel_type"]:checked') ? document.querySelector('.search-aside input[name="fuel_type"]:checked').value : ''));
    searchUrl.searchParams.set('transmission', param==='transmission' ? value : (document.querySelector('.search-aside input[name="transmission"]:checked') ? document.querySelector('.search-aside input[name="transmission"]:checked').value : ''));

    searchUrl.searchParams.set('term', param==='term' ? value : (document.querySelector('.search-filters [name="term"]') ? document.querySelector('.search-filters [name="term"]').value : ''));
    searchUrl.searchParams.set('initial_profile', param==='initial_profile' ? value : (document.querySelector('.search-filters [name="initial_profile"]') ? document.querySelector('.search-filters [name="initial_profile"]').value : ''));
    searchUrl.searchParams.set('mileage', param==='mileage' ? value : (document.querySelector('.search-filters [name="mileage"]') ? document.querySelector('.search-filters [name="mileage"]').value : ''));

    searchUrl.searchParams.set('order', param==='order' ? value : (document.querySelector('.search-filters select[name="order"]') ? document.querySelector('.search-filters select[name="order"]').value : ''));

    window.location.href = searchUrl;
}

// Show Only Filters
function updateSearchToggles() {
    let searchToggles = document.querySelectorAll('.search-form .stock input');
    if (searchToggles) {
        searchToggles.forEach(value => {
            value.addEventListener('change', (e) => {
                let searchUrl = new URL(window.location.origin + '/car-leasing');
                let vans = (window.location.pathname.includes('van-leasing') || window.location.search.includes('search-type=van')) ? '/van-leasing' : '';
                (window.location.pathname.includes('van-leasing')) ? searchUrl = new URL(window.location.origin + '/van-leasing') : null;
                (e.target.value === 'stock' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
                (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Electric.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Electric') : null;
                (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Hybrid.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Hybrid') : null;
                (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=', 'offers=stock')) : null;
                (e.target.value === 'stock' && e.target.checked && window.location.pathname==="/search" && !window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('?', '?offers=stock&')) : null;
                (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=&')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=&', 'offers=stock&')) : null;
                (e.target.value === 'stock' && !e.target.checked && window.location.search.includes('offers=stock')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=stock', 'offers=')) : null;
                document.body.classList.remove('loaded');
                window.location.href = searchUrl;
            })
        })
    }
}
// END Show Only Filters

function loadSearchTriggers() {
    // console.log("loadSearchTriggers");
    if (document.querySelector('.search-aside') && document.querySelector('.search-filters')) {

        let selectedMake = document.querySelector('.search-aside input[name="make"]:checked');

        if (document.querySelector('.search-aside #search-type')) {

            // Show Models for selected manufacturer
            if (selectedMake) {
                loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);

                let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
                (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
            }

            if(document.querySelector('.search-aside #body_type-wrapper')){
                loadBodyTypesRadio(document.querySelector('.search-aside #search-type').value);
            }
            if(document.querySelector('.search-aside #fuel_type-wrapper')){
                loadFuelTypesRadio(document.querySelector('.search-aside #search-type').value);
            }
            if(document.querySelector('.search-aside #transmission-wrapper')){
                loadTransmissionTypesRadio(document.querySelector('.search-aside #search-type').value);
            }

            (document.querySelector('.button-clear')) ? null : document.querySelector('.clear-filters').classList.add('visuallyhidden');

            document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
                v.addEventListener('change', e => {
                    document.body.classList.remove('loaded');
                    document.querySelector('.search-aside .model-wrapper [name="model"]:checked') ? document.querySelector('.search-aside .model-wrapper.show [name="model"]:checked').checked = false : null;
                    setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
                })
            })
            document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
                v.addEventListener('change', e => {
                    document.body.classList.remove('loaded');
                    setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
                })
            })
            document.querySelectorAll('.search-aside [name="van_size"]').forEach(v => {
                v.addEventListener('change', e => {
                    document.body.classList.remove('loaded');
                    //remove bodytype
                    document.querySelector('.search-aside [name="body_type"]:checked') ? document.querySelector('.search-aside [name="body_type"]:checked').checked = false : null;
                    setUrlParams('van_size', e.target.value, document.querySelector('.search-content').dataset.module);
                })
            })
            document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
                v.addEventListener('change', e => {
                    document.body.classList.remove('loaded');
                    //remove van size
                    document.querySelector('.search-aside [name="van_size"]:checked') ? document.querySelector('.search-aside [name="van_size"]:checked').checked = false : null;
                    setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
                    // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
                })
            })
            // document.querySelectorAll('.search-aside input[name="budget"]').forEach(v => {
            //   v.addEventListener('change', e => {
            //     document.body.classList.remove('loaded');
            //     setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
            //   })
            // })
            document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
                v.addEventListener('change', e => {
                    document.body.classList.remove('loaded');
                    setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
                    // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
                })
            })
            document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
                v.addEventListener('change', e => {
                    document.body.classList.remove('loaded');
                    setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
                })
            })

            document.querySelectorAll('.search-filters [name="term"]').forEach(v => {
                v.addEventListener('change', e => {
                    document.body.classList.remove('loaded');
                    setUrlParams('term', e.target.value, document.querySelector('.search-content').dataset.module);
                })
            })
            document.querySelectorAll('.search-filters [name="initial_profile"]').forEach(v => {
                v.addEventListener('change', e => {
                    document.body.classList.remove('loaded');
                    setUrlParams('initial_profile', e.target.value, document.querySelector('.search-content').dataset.module);
                })
            })
            document.querySelectorAll('.search-filters [name="mileage"]').forEach(v => {
                v.addEventListener('change', e => {
                    document.body.classList.remove('loaded');
                    setUrlParams('mileage', e.target.value, document.querySelector('.search-content').dataset.module);
                })
            })
            document.querySelector('.search-filters select[name="order"]').addEventListener('change', e => {
                document.body.classList.remove('loaded');
                setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
            })

            if (document.querySelector('.button-clear[data-type="make"]') && selectedMake) {
                document.querySelector('.button-clear[data-type="make"] > span').innerText = selectedMake.nextElementSibling.nextElementSibling.textContent;
            }

            if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
                document.querySelector('.button-clear[data-type="model"] > span').innerText = document.querySelector('.search-aside input[name="model"]:checked').nextElementSibling.nextElementSibling.textContent;
            }

            if (document.querySelector('.button-clear[data-type="van_size"]') && document.querySelector('.search-aside input[name="van_size"]:checked')) {
                document.querySelector('.button-clear[data-type="van_size"] > span').innerText = document.querySelector('.search-aside input[name="van_size"]:checked').nextElementSibling.nextElementSibling.textContent;
            }

            document.querySelectorAll('.button-clear').forEach(v => {
                v.addEventListener('click', e => {
                    document.body.classList.remove('loaded');
                    setUrlParams(e.target.dataset.type, '', document.querySelector('.search-content').dataset.module);
                })
            })

            unselectRadio('.search-form input[type=radio]');
        }
    }
}

function unselectRadio(groupSelector) {
    let currentId;
    document.querySelectorAll(groupSelector).forEach((elem) => {
        elem.addEventListener('click', allowUncheck);
        // needed if elem is already pre-checked
        if (elem.checked) {
            currentId = elem.id;
        }
    });

    function allowUncheck(e) {
        if (this.id === currentId) {
            this.checked = false;
            currentId = undefined;
            document.body.classList.remove('loaded');
            setUrlParams(e.target.dataset.type, e.target.value, document.querySelector('.search-content').dataset.module);
        } else {
            currentId = this.id;
        }
    }
}

//END Search Sidebar

// SEARCH
function searchType(elem, searchType) {
    let hiddenField, searchTab;

    //set hidden field value
    hiddenField = document.querySelector('#search-type');
    hiddenField.setAttribute('value', searchType);
    // hiddenField.dispatchEvent(new Event('change'));

    //remove active class
    searchTab = document.getElementsByClassName("search-tab");
    for (i = 0; i < searchTab.length; i++) {
        searchTab[i].className = searchTab[i].className.replace(" active", "");
    }

    //add active class to clicked
    elem.classList.toggle("active");

    let slider = document.querySelector('.vehicle-type .slider');
    slider ? slider.classList.toggle("active") : null;

    if (document.querySelector('.search-aside')) {
        document.body.classList.remove('loaded');
        setUrlParams('type', searchType, document.querySelector('.search-content').dataset.module);
    } else {
        loadManufacturers(hiddenField.value);
        loadBodyTypes(hiddenField.value);
    }

}

function loadManufacturers($type) {
    if ($type) {
        let defaultOption = document.createElement('option');
        if(document.querySelector('.search-bar-hero')){
            defaultOption.text = 'any manufacturer.';
        } else {
            defaultOption.text = 'Manufacturer';
        }
        defaultOption.value = '';
        let loadingOption = document.createElement('option');
        loadingOption.text = 'Loading...';
        loadingOption.value = '';
        let loadingError = document.createElement('option');
        loadingError.text = 'Loading Error, please check your internet connection';
        loadingError.value = '';
        document.querySelectorAll('[name="make"]').forEach((v, i) => {
            v.length = 0;
            v.add(loadingOption);
            v.selectedIndex = 0;
            let url = '/api/'+$type+'/manufacturers/available';
            fetch(url).then(function(response) {
                if (response.status !== 200) {
                    console.warn('Looks like there was a problem. Status Code: ' + response.status);
                    return;
                }
                return response.json();
            }).then(function(data) {
                let keysSorted = Object.keys(data).sort(function(a, b) {
                    return data[a].localeCompare(data[b])
                });
                v.length = 0;
                v.add(defaultOption);
                v.selectedIndex = 0;
                for (let x in keysSorted) {
                    let option = document.createElement('option');
                    option.text = data[keysSorted[x]].toUpperCase();
                    option.value = keysSorted[x];
                    (v.hasAttribute('data-img')) ? option.setAttribute('data-img', `/themes/lcvgroup/img/manufacturer/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}.svg`) : null;
                    (v.hasAttribute('data-url')) ? option.setAttribute('data-url', `/${$type}-leasing/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}`) : null;
                    v.add(option);
                }
            }).catch(function(err) {
                console.error('Fetch Error -', err);
            });
        })
    }
}

// function loadModels($type, $manufacturer) {
//   if ($type && $manufacturer) {
//     let defaultOption = document.createElement('option');
//     if(document.querySelector('.search-bar-hero')){
//       defaultOption.text = 'any model.';
//     } else {
//       defaultOption.text = 'Choose a Model';
//     }
//     defaultOption.value = '';
//     let loadingOption = document.createElement('option');
//     loadingOption.text = 'loading...';
//     loadingOption.value = '';
//     let loadingError = document.createElement('option');
//     loadingError.text = 'Loading Error, please check your internet connection';
//     loadingError.value = '';
//
//     var model_dropdowns = document.getElementsByName("model");
//     for (let i = 0; i < model_dropdowns.length; i++) {
//       var dropdown = model_dropdowns[i];
//       dropdown.length = 0;
//       dropdown.add(defaultOption);
//       dropdown.selectedIndex = 0;
//
//       if ($manufacturer) {
//         dropdown.length = 0;
//         dropdown.add(loadingOption);
//         dropdown.selectedIndex = 0;
//
//         var url = '/api/'+$type+'/models/'+$manufacturer+'/available';
//
//         fetch(url).then(function(response) {
//           if (response.status !== 200) {
//             console.warn('Looks like there was a problem. Status Code: ' +
//               response.status);
//             return;
//           }
//           return response.json();
//         }).then(function(data) {
//           dropdown.length = 0;
//           dropdown.add(defaultOption);
//           dropdown.selectedIndex = 0;
//           let keysSorted = Object.keys(data).sort(function(a, b) {
//             return data[a].localeCompare(data[b])
//           });
//           for (let x in keysSorted) {
//             let option = document.createElement('option');
//             option.text = data[keysSorted[x]];
//             option.value = keysSorted[x];
//             dropdown.add(option);
//           }
//           const urlParams = new URLSearchParams(window.location.search);
//           const makeParam = urlParams.get('make');
//           const modelParam = urlParams.get('model');
//           if (modelParam && makeParam == $manufacturer) {
//             dropdown.value = modelParam;
//           }
//         }).catch(function(err) {
//           dropdown.length = 0;
//           dropdown.add(loadingError);
//           dropdown.selectedIndex = 0;
//           console.error('Fetch Error -', err);
//         });
//       }
//     }
//   }
// }

function loadModelsRadio($type, $manufacturer) {
    const wrapper = document.querySelector(`#model-wrapper--${$manufacturer}`);
    if (wrapper && $type && $manufacturer) {
        let url = '/api/'+$type+'/models/'+$manufacturer+'/available';

        if(document.querySelector('form.search-form')){
            if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
                url += '?specials=true';
            }
            if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
                url += '?stock=true';
            }
        }

        fetch(url).then(function(response) {
            if (response.status !== 200) {
                console.warn('Looks like there was a problem. Status Code: ' +
                    response.status);
                return;
            }
            return response.json();
        }).then(function(data) {
            let keysSorted = Object.keys(data).sort(function(a, b) {
                return data[a].localeCompare(data[b])
            });
            for (let x in keysSorted) {
                let text = data[keysSorted[x]];
                let value = keysSorted[x];
                let input = document.createElement("input");
                let label = document.createElement("label");
                let spanLabelWrapper = document.createElement("span");
                let spanCheckmark = document.createElement("span");
                let spanName = document.createElement("span");
                let selectedModel = new URLSearchParams(window.location.search).get('model');
                input.setAttribute('type', 'radio');
                input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
                input.setAttribute('name', 'model');
                input.setAttribute('value', value);
                input.classList.add('form-control', 'radio-css');
                (value == selectedModel) ? input.setAttribute('checked', 'true') : null;
                label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
                label.classList.add('checkbox-label');
                spanCheckmark.classList.add('checkmark');
                spanCheckmark.classList.add('checkmark-round');
                wrapper.appendChild(label);
                label.appendChild(spanLabelWrapper);
                spanLabelWrapper.appendChild(input);
                spanLabelWrapper.appendChild(spanCheckmark);
                spanLabelWrapper.appendChild(spanName);
                spanName.innerText = text;
            }
            document.querySelectorAll('.search-aside input[name="model"]').forEach(v => {
                v.addEventListener('change', e => {
                    document.body.classList.remove('loaded');
                    setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
                })
            })
            if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
                document.querySelector('.button-clear[data-type="model"] > span').innerText = document.querySelector('.search-aside input[name="model"]:checked').id.toUpperCase();
            }
        }).catch(function(err) {
            wrapper.innerHTML = 'Please select a manufacturer';
            console.error('Fetch Error -', err);
        });
    }
}

function loadBodyTypes($type) {

    let dropdown = document.querySelector('[name=body_type]');
    if (dropdown && $type) {
        let defaultOption = document.createElement('option');
        defaultOption.text = 'any bodytype.';
        defaultOption.value = '';
        let loadingOption = document.createElement('option');
        loadingOption.text = 'Loading...';
        loadingOption.value = '';
        let loadingError = document.createElement('option');
        loadingError.text = 'Loading Error, please check your internet connection';
        loadingError.value = '';
        dropdown.length = 0;

        dropdown.length = 0;
        dropdown.add(loadingOption);
        dropdown.selectedIndex = 0;

        let url = '/api/' + $type + '/types?available';
        url += document.querySelector('.search-form [name="make"]').value != '' ? '&make=' + document.querySelector('.search-form [name="make"]').value : '';
        if (document.querySelector('.search-form [name="model"]')) {
            url += document.querySelector('.search-form [name="model"]').value!='' ? '&model='+document.querySelector('.search-form [name="model"]').value : '';
        }

        if (document.querySelector('form.search-form')) {
            if (window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')) {
                url += '&specials=true';
            }
            if (window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')) {
                url += '&stock=true';
            }
        }


        fetch(url).then(function (response) {
            if (response.status !== 200) {
                console.warn('Looks like there was a problem. Status Code: ' +
                    response.status);
                return;
            }
            return response.json();
        }).then(function (data) {

            dropdown.length = 0;

            var defaultOption = document.createElement('option');
            defaultOption.text = 'any bodytype.';
            defaultOption.value = '';

            dropdown.add(defaultOption);
            dropdown.selectedIndex = 0;

            let keysSorted = Object.keys(data).sort(function (a, b) {
                return data[a].localeCompare(data[b])
            });

            const urlParams = new URLSearchParams(window.location.search);
            const body_type = urlParams.get('body_type');

            for (let x in keysSorted) {
                let option = document.createElement('option');
                option.text = data[keysSorted[x]];
                option.value = keysSorted[x];
                dropdown.add(option);
            }
            if (body_type) {
                dropdown.value = body_type;
            }
        }).catch(function (err) {
            console.error('Fetch Error -', err);
        });
    }
}

function loadBodyTypesRadio($type) {
    const wrapper = document.querySelector('#body_type-wrapper');
    if (wrapper && $type) {
        let url = '/api/'+$type+'/types?available';
        url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
        url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';

        if(document.querySelector('form.search-form')){
            if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
                url += '&specials=true';
            }
            if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
                url += '&stock=true';
            }
        }

        // console.log('loadBodyTypesCheckbox')
        fetch(url).then(function(response) {
            if (response.status !== 200) {
                console.warn('Looks like there was a problem. Status Code: ' + response.status);
                return;
            }
            return response.json();
        }).then(function(data) {
            wrapper.innerHTML = '';
            let keysSorted = Object.keys(data).sort(function(a, b) {
                return data[a].localeCompare(data[b])
            });
            for (let x in keysSorted) {
                let text = data[keysSorted[x]];
                let value = keysSorted[x];
                let input = document.createElement("input");
                let label = document.createElement("label");
                let spanLabelWrapper = document.createElement("span");
                let spanCheckmark = document.createElement("span");
                let spanName = document.createElement("span");
                let selectedBodyType = new URLSearchParams(window.location.search).get('body_type');
                input.setAttribute('type', 'radio');
                input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
                input.setAttribute('name', 'body_type');
                input.setAttribute('value', value);
                input.classList.add('form-control', 'radio-css');
                (value == selectedBodyType) ? input.setAttribute('checked', 'true') : null;
                label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
                label.classList.add('checkbox-label');
                spanCheckmark.classList.add('checkmark');
                spanCheckmark.classList.add('checkmark-round');
                wrapper.appendChild(label);
                label.appendChild(spanLabelWrapper);
                spanLabelWrapper.appendChild(input);
                spanLabelWrapper.appendChild(spanCheckmark);
                spanLabelWrapper.appendChild(spanName);
                spanName.innerText = text;
            }

            if (document.querySelectorAll('.search-aside input[name="body_type"]')) {
                document.querySelectorAll('.search-aside input[name="body_type"]').forEach(v => {
                    v.addEventListener('change', e => {
                        document.body.classList.remove('loaded');
                        setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
                        // setUrlParams('body_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
                    })
                })
            }
        }).catch(function(err) {
            console.error('Fetch Error -', err);
        });
    }
}


function loadFuelTypesRadio($type) {
    const wrapper = document.querySelector('#fuel_type-wrapper');
    if (wrapper && $type) {

        let url = '/api/'+$type+'/fuel-types?available';
        url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
        url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';
        if (document.querySelector('#body_type-wrapper')) {
            url += document.querySelector('.search-form input[name="body_type"]:checked')!=null ? '&body_type='+document.querySelector('.search-form input[name="body_type"]:checked').value : '';
        } else {
            url += document.querySelector('.search-form [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-form [name="body_type"]').value : '';
        }

        if(document.querySelector('form.search-form')){
            if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
                url += '&specials=true';
            }
            if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
                url += '&stock=true';
            }
            (window.location.pathname === '/electric-leasing' || window.location.pathname === '/van-leasing/electric' || window.location.pathname === '/hybrid-leasing' || window.location.pathname === '/van-leasing/hybrid') ? wrapper.parentElement.classList.add('visuallyhidden') : wrapper.parentElement.classList.remove('visuallyhidden')
        }

        // console.log('loadFuelTypesRadio')
        fetch(url).then(function(response) {
            if (response.status !== 200) {
                console.warn('Looks like there was a problem. Status Code: ' + response.status);
                return;
            }
            return response.json();
        }).then(function(data) {
            delete data['B'];
            delete data['R'];
            wrapper.innerHTML = '';
            let keysSorted = Object.keys(data).sort(function(a, b) {
                return data[a].localeCompare(data[b])
            });
            for (let x in keysSorted) {
                let text = data[keysSorted[x]].replace(" ","-");
                let value = keysSorted[x].replace(" ","-");
                let input = document.createElement("input");
                let label = document.createElement("label");
                let spanLabelWrapper = document.createElement("span");
                let spanCheckmark = document.createElement("span");
                let spanName = document.createElement("span");
                let selectedFuelType = new URLSearchParams(window.location.search).get('fuel_type');
                input.setAttribute('type', 'radio');
                input.setAttribute('id', text);
                input.setAttribute('name', 'fuel_type');
                input.setAttribute('value', value);
                input.classList.add('form-control', 'radio-css');
                (value == selectedFuelType) ? input.setAttribute('checked', 'true') : null;
                label.setAttribute('for', text);
                label.classList.add('checkbox-label');
                spanCheckmark.classList.add('checkmark');
                spanCheckmark.classList.add('checkmark-round');
                wrapper.appendChild(label);
                label.appendChild(spanLabelWrapper);
                spanLabelWrapper.appendChild(input);
                spanLabelWrapper.appendChild(spanCheckmark);
                spanLabelWrapper.appendChild(spanName);
                spanName.innerText = text.replace("-"," ");
            }

            if(document.querySelectorAll('.search-aside input[name="fuel_type"]')){
                document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
                    v.addEventListener('change', e => {
                        document.body.classList.remove('loaded');
                        setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
                        // setUrlParams('fuel_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
                    })
                })
            }
        }).catch(function(err) {
            console.error('Fetch Error -', err);
        });
    }
}

function loadTransmissionTypesRadio($type) {
    const wrapper = document.querySelector('#transmission-wrapper');
    if (wrapper && $type) {
        let url = '/api/'+$type+'/transmissions?available';
        url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
        url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';
        if (document.querySelector('#body_type-wrapper')) {
            url += document.querySelector('.search-form input[name="body_type"]:checked')!=null ? '&body_type='+document.querySelector('.search-form input[name="body_type"]:checked').value : '';
        } else {
            url += document.querySelector('.search-form [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-form [name="body_type"]').value : '';
        }

        if(document.querySelector('form.search-form')){
            if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
                url += '&specials=true';
            }
            if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
                url += '&stock=true';
            }
        }

        // console.log('loadTransmissionTypesRadio')
        fetch(url).then(function(response) {
            if (response.status !== 200) {
                console.warn('Looks like there was a problem. Status Code: ' + response.status);
                return;
            }
            return response.json();
        }).then(function(data) {
            wrapper.innerHTML = '';
            let keysSorted = Object.keys(data).sort(function(a, b) {
                return data[a].localeCompare(data[b])
            });
            for (let x in keysSorted) {
                let text = data[keysSorted[x]];
                let value = keysSorted[x];
                value = (value === 'Automatic') ? 'A' : (value === 'Manual') ? 'M' : value;
                let input = document.createElement("input");
                let label = document.createElement("label");
                let spanLabelWrapper = document.createElement("span");
                let spanCheckmark = document.createElement("span");
                let spanName = document.createElement("span");
                let selectedTransmissionType = new URLSearchParams(window.location.search).get('transmission');
                input.setAttribute('type', 'radio');
                input.setAttribute('id', text);
                input.setAttribute('name', 'transmission');
                input.setAttribute('value', value);
                input.classList.add('form-control', 'radio-css');
                (value == selectedTransmissionType) ? input.setAttribute('checked', 'true') : null;
                label.setAttribute('for', text);
                label.classList.add('checkbox-label');
                spanCheckmark.classList.add('checkmark');
                spanCheckmark.classList.add('checkmark-round');
                wrapper.appendChild(label);
                label.appendChild(spanLabelWrapper);
                spanLabelWrapper.appendChild(input);
                spanLabelWrapper.appendChild(spanCheckmark);
                spanLabelWrapper.appendChild(spanName);
                spanName.innerText = text;
            }

            if(document.querySelectorAll('.search-aside input[name="transmission"]')){
                document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
                    v.addEventListener('change', e => {
                        document.body.classList.remove('loaded');
                        setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
                    })
                })
            }
        }).catch(function(err) {
            console.error('Fetch Error -', err);
        });
    }
}
// END SEARCH

document.addEventListener("DOMContentLoaded", function() {

    // WhatsApp Widget
    let wa_button = document.querySelector('#wa-btn-wrapper');
    if (wa_button) {
        setTimeout(() => { wa_button.classList.add('active'); }, 4000);
    }
    // END WhatsApp Widget

    // Pagination
    document.querySelectorAll('.pagination-holder .results-per-page select option')?.forEach(v => { (v.innerHTML = v.innerHTML.replace('Show', '<span>Results Per Page:</span>')) })
    document.querySelector('.pagination-holder .results-per-page select option[value="All"]')?.setAttribute('value', '9999')
    let url = new URL(document.URL);
    url.searchParams.has('show') ? (url.searchParams.get('show') === '9999' ? document.querySelector('.pagination-holder .results-per-page select').selectedIndex = 6 : null) : null;

    document.querySelector('.pagination-holder .results-per-page select')?.addEventListener('change', ev => {
        url.searchParams.set('show', (ev.target.value === 'All') ? '9999' : ev.target.value);
        url.searchParams.has('page') ? url.searchParams.delete('page') : null;
        window.location.href = url;
    })
    // END Pagination

    // Feefo Reviews
    // const xhttp = new XMLHttpRequest();
    // xhttp.onload = function() {
    //   let reviewsTop = document.querySelector('#feefo_top');
    //   if(this.response && reviewsTop){
    //     reviewsTop.querySelector('#reviews_text > tspan:first-child').innerHTML = `${JSON.parse(this.response).rating.rating}`;
    //     reviewsTop.querySelector('#reviews_text > tspan:last-child').innerHTML = `${JSON.parse(this.response).meta.count} Reviews`;
    //     reviewsTop.parentElement.setAttribute('href', JSON.parse(this.response).merchant.review_url)
    //     reviewsTop.classList.remove('visuallyhidden');
    //   } else {
    //     reviewsTop ? reviewsTop.classList.add('visuallyhidden') : null;
    //   }
    //
    //   let reviewsHero = document.querySelector('#feefo_hero');
    //   if(this.response && reviewsHero) {
    //     reviewsHero.querySelector('#reviews_text > tspan:first-child').innerHTML = `${JSON.parse(this.response).rating.rating}`;
    //     reviewsHero.parentElement.setAttribute('href', JSON.parse(this.response).merchant.review_url)
    //     reviewsHero.classList.remove('visuallyhidden');
    //   } else {
    //     reviewsHero ? reviewsHero.classList.add('visuallyhidden') : null;
    //   }
    //
    // }
    // xhttp.open("GET", "https://api.feefo.com/api/20/reviews/summary/all?merchant_identifier=planet-leasing");
    // xhttp.send();
    // END Feefo Reviews

    // Search Sidebar
    // let filterSwitch = document.querySelectorAll('.filter-switch');
    // if(filterSwitch){
    //   Array.prototype.slice.call(filterSwitch, 0).forEach((value) => {
    //     value.addEventListener('click', () => {
    //       document.querySelector('#page').classList.toggle('open');
    //       document.querySelector('.search-results-filters').classList.toggle('open');
    //       // document.querySelector('.search-results-filters-switch').classList.toggle('open');
    //     })
    //   })
    // }
    // let breadcrumbsSwitch = document.querySelector('.breadcrumbs-search.filter-switch');
    // if (breadcrumbsSwitch){
    //   document.querySelector('#page').classList.add('has-search');
    // }
    // let searchPage = document.querySelector('.breadcrumbs.search-page');
    // if (searchPage){
    //   document.querySelector('#page').classList.add('search-page');
    // }
    // END Search Sidebar

    // Latest Offers - Show More
    // document.querySelectorAll('.offers-strip-more').forEach(value => {
    //   value.addEventListener('click', (e) => {
    //     e.target.closest('.offers-strip').classList.toggle('show-more');
    //   })
    // })

    //Search Filters Toggle
    let filterTerms = document.querySelector('#filter-terms');
    let searchFilters = document.querySelector('.search-filters');
    if (filterTerms){
        filterTerms.addEventListener('click', (e) => {
            if (filterTerms.classList.contains('active')){
                searchFilters.classList.add('active');
            } else {
                searchFilters.classList.remove('active');
            }
        })
    }


    // document.querySelectorAll('.offers-strip-more').forEach(value => {
    //   value.addEventListener('click', (e) => {
    //     let element = e.target.closest('.offers-strip');
    //     let showMore = element.querySelector('span.show-more-btn');
    //
    //     element.classList.toggle('show-more');
    //     if(element.classList.contains('show-more')){
    //       showMore.innerHTML = 'Show less';
    //     } else {
    //       showMore.innerHTML = 'Show more';
    //     }
    //   })
    // })

    // var classname = document.querySelectorAll(".offers-strip-more");
    //
    // var showMore = function(e) {
    //   e.preventDefault();
    //   let element = classname.closest('.offers-strip');
    //   element.classList.toggle("active");
    //   if(element.classList.contains('active')){
    //     this.innerHTML = 'Hide additional options';
    //   } else {
    //     this.innerHTML = 'Show me more options';
    //   }
    // };
    //
    // for (var i = 0; i < classname.length; i++) {
    //   classname[i].addEventListener('click', showMore, false);
    // }

    // Model Table Search
    // if (document.querySelector('#model-table')) {
    //   let filterFields = document.querySelectorAll('.model-table-head select');
    //   const filterTable = (field, value) => {
    //     let searchType = field;
    //
    //     if (value !== '' && value.length > 0) {
    //       let elements = document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']');
    //       console.log(elements)
    //       elements.forEach((v) => {
    //         v.classList.add('hidden-' + field + '')
    //         if(v.getAttribute('data-' + searchType + '').includes(value)) {
    //           v.classList.remove('hidden-' + field + '')
    //         }
    //       })
    //     } else {
    //       document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']').forEach((v) => {
    //         v.classList.remove('hidden-' + field + '')
    //       });
    //     }
    //
    //     // Show no results text
    //     if(!document.querySelectorAll('.model-table-wrapper:not([class*="hidden"]):not(.no-results)').length > 0) {
    //       document.querySelector('.no-results').classList.remove('hidden-no-results', 'hidden');
    //     } else {
    //       document.querySelector('.no-results').classList.add('hidden-no-results');
    //     }
    //   }
    //   if (filterFields) {
    //     filterFields.forEach((value => {
    //       value.addEventListener('change', (event) => {
    //         let val = value.value;
    //         let field = value.getAttribute('name');
    //         filterTable(field, val);
    //       })
    //     }))
    //   }
    //   // let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
    //   // allSwitches.forEach((value) => {
    //   //   value.addEventListener('change', (val) => {
    //   //     filterTable('personal', '');
    //   //     filterTable('business', '');
    //   //     document.querySelector('#filterBudget').selectedIndex = 0;
    //   //     document.querySelector('#filterBudgetBusiness').selectedIndex = 0;
    //   //   })
    //   // })
    // }
    // End Model Table Search

    // Calculators
    if (document.querySelector('body').classList.contains('page-tools') && document.querySelector('.tools-main>div')) {
        function numberWithCommas(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
        // Next Step
        document.querySelectorAll('.next-step').forEach((value) => {
            value.addEventListener('click', (e) => {
                document.querySelectorAll('.step').forEach((value) => { value.classList.remove('active') })
                value.parentElement.parentElement.nextElementSibling.classList.add('active')
                window.scrollTo({ top: 0, behavior: 'smooth' });
            })
        })
        // Back Step
        document.querySelectorAll('.back-step').forEach((value) => {
            value.addEventListener('click', (e) => {
                document.querySelectorAll('.step').forEach((value) => { value.classList.remove('active') })
                value.parentElement.parentElement.previousElementSibling.classList.add('active')
                window.scrollTo({ top: 0, behavior: 'smooth' });
            })
        })
        // Steps Progress Bar
        document.querySelectorAll('.next-step, .back-step').forEach((value) => {
            value.addEventListener('click', (e) => {
                let percent = value.dataset.percent;
                document.querySelector('#progress-bar')?.classList.add(`step-${percent}`);
            })
        })
        // Indicative Fuel Cost
        function indicativeCost($fuel_type = false, $mpg = null, $electric_range = null, $battery_size = null, $electricity_cost = null) {
            let indicativeCost;
            if ($fuel_type === 'Electric' && $electric_range && $battery_size){
                let electricity_cost = ($electricity_cost) ? $electricity_cost : document.getElementById('average-data').dataset.averageElectricity;
                let miles_per_kwh = $electric_range / $battery_size;
                let cost_per_mile = electricity_cost / miles_per_kwh;
                indicativeCost = cost_per_mile.toFixed(1);
            } else if ($fuel_type === 'Diesel' && $mpg) {
                let cost_per_litre_input = document.getElementById('price-fuel-field');
                let cost_per_litre_diesel;
                if (cost_per_litre_input) {
                    cost_per_litre_diesel = parseFloat(cost_per_litre_input.value) * 100;
                } else {
                    cost_per_litre_diesel = document.getElementById('average-data').dataset.averageDiesel;
                }
                let miles_per_litre = $mpg / 4.54609;
                let cost_per_mile = cost_per_litre_diesel / miles_per_litre;
                indicativeCost = cost_per_mile.toFixed(1);
            } else if ($fuel_type !== false && $mpg) {
                let cost_per_litre_input = document.getElementById('price-fuel-field');
                let cost_per_litre_petrol;
                if (cost_per_litre_input) {
                    cost_per_litre_petrol = parseFloat(cost_per_litre_input.value) * 100;
                } else {
                    cost_per_litre_petrol = document.getElementById('average-data').dataset.averagePetrol;
                }
                let miles_per_litre = $mpg / 4.54609;
                let cost_per_mile = cost_per_litre_petrol / miles_per_litre;
                indicativeCost = cost_per_mile.toFixed(1);
            } else {
                indicativeCost = 'N/A';
            }
            return indicativeCost;
        }

        function equalHeight($el_1, $el_2) {
            let leftHeight = $el_1.clientHeight;
            let rightHeight = $el_2.clientHeight;
            $el_1.setAttribute('style', '');
            $el_2.setAttribute('style', '');
            setTimeout(() => {
                if (leftHeight > rightHeight) {
                    $el_1.style.height=(leftHeight+5)+'px';
                    $el_2.style.height=(leftHeight+5)+'px';
                }
                if (leftHeight < rightHeight) {
                    $el_1.style.height=(rightHeight+5)+'px';
                    $el_2.style.height=(rightHeight+5)+'px';
                }
            }, 500);
        }
        // Load Manufacturers Dropdown
        function loadManufacturersCalc($type, $ev = true, $el = '[name="calculator-make"]') {
            let make_dropdowns = document.querySelectorAll($el);
            for (i = 0; i < make_dropdowns.length; i++) {
                var dropdown = make_dropdowns[0];
                dropdown.length = 0;

                let defaultOption = document.createElement('option');
                defaultOption.text = 'Choose Make';
                defaultOption.value = '';

                dropdown.add(defaultOption);
                dropdown.selectedIndex = 0;

                let url;
                ($ev) ? url = '/api/' + $type + '/manufacturers/ev' : url = '/api/' + $type + '/manufacturers';

                fetch(url).then(function(response) {
                    if (response.status !== 200) {
                        console.warn('Looks like there was a problem. Status Code: ' +
                            response.status);
                        return;
                    }
                    return response.json();
                }).then(function(data) {
                    let keysSorted = Object.keys(data).sort(function(a, b) {
                        return data[a].localeCompare(data[b])
                    });
                    for (let x in keysSorted) {
                        let option = document.createElement('option');
                        option.text = data[keysSorted[x]];
                        option.value = keysSorted[x];
                        dropdown.add(option);
                    }
                }).catch(function(err) {
                    console.error('Fetch Error -', err);
                });
            }
        }
        // Load Models Dropdown
        function loadModelsCalc($type, $manufacturer, $ev = true, $inactive = false, $compare = false) {
            let model_dropdowns, derivative_dropdowns;
            ($compare) ? model_dropdowns = document.getElementsByName("calculator-model-compare") : model_dropdowns = document.getElementsByName("calculator-model");
            ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
            for (let i = 0; i < derivative_dropdowns.length; i++) {
                let dropdown = derivative_dropdowns[i];
                dropdown.length = 0;
                let defaultOption = document.createElement('option');
                defaultOption.text = 'Choose Variant';
                defaultOption.value = '';
                dropdown.add(defaultOption);
                dropdown.selectedIndex = 0;
            }
            for (let i = 0; i < model_dropdowns.length; i++) {
                let dropdown = model_dropdowns[i];
                dropdown.length = 0;

                let defaultOption = document.createElement('option');
                defaultOption.text = 'Choose Model';
                defaultOption.value = '';

                dropdown.add(defaultOption);
                dropdown.selectedIndex = 0;

                let url;
                ($ev) ? url = '/api/' + $type + '/models/' + $manufacturer + '/ev' : url = '/api/' + $type + '/models/' + $manufacturer;

                let params;
                ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '';

                fetch(url + params).then(function(response) {
                    if (response.status !== 200) {
                        console.warn('Looks like there was a problem. Status Code: ' +
                            response.status);
                        return;
                    }
                    return response.json();
                }).then(function(data) {
                    let keysSorted = Object.keys(data).sort(function(a, b) {
                        return data[a].localeCompare(data[b])
                    });
                    for (let x in keysSorted) {
                        let option = document.createElement('option');
                        option.text = data[keysSorted[x]];
                        option.value = keysSorted[x];
                        dropdown.add(option);
                    }
                }).catch(function(err) {
                    console.error('Fetch Error -', err);
                });
            }
        }
        // Load Derivatives Dropdown
        function loadDerivativeCalc($type, $model, $default = false, $ev = true, $inactive = false, $compare = false, $distinct = true, $non_ev = false) {
            let derivative_dropdowns;
            ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
            for (let i = 0; i < derivative_dropdowns.length; i++) {
                let dropdown = derivative_dropdowns[i];
                dropdown.length = 0;

                if ($default){
                    let defaultOption = document.createElement('option');
                    defaultOption.text = 'Choose Variant';
                    defaultOption.value = '';

                    dropdown.add(defaultOption);
                    dropdown.selectedIndex = 0;
                }

                let url;
                ($ev) ? url = '/api/' + $type + '/derivatives/' + $model + '/ev' : url = '/api/' + $type + '/derivatives/' + $model + ($non_ev ? '/nonev' : '');

                let params;
                if($compare) {
                    ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive', 'compare_ev': 'true'}) : params = '?' + new URLSearchParams({'has_deals': 'true'});
                } else {
                    ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '?' + new URLSearchParams({'has_deals': 'true'});
                }

                fetch(url + params).then(function(response) {
                    if (response.status !== 200) {
                        console.warn('Looks like there was a problem. Status Code: ' +
                            response.status);
                        return;
                    }
                    return response.json();
                }).then(function(data) {

                    if ($distinct) {
                        let distinct = []
                        for (const key in data) {
                            if (!distinct.includes(data[key])) {
                                distinct.push(data[key]);
                            } else {
                                delete data[key];
                            }
                        }
                    }

                    let keysSorted = Object.keys(data).sort(function(a, b) {
                        return data[a].localeCompare(data[b])
                    });
                    for (let x in keysSorted) {
                        if (x === '2813'){ continue }
                        let option = document.createElement('option');
                        option.text = data[keysSorted[x]];
                        option.value = keysSorted[x];
                        dropdown.add(option);
                    }
                }).catch(function(err) {
                    console.error('Fetch Error -', err);
                });
            }
        }
        // Compare Cars
        if (document.querySelector('.tools-main>div').classList.contains('car-comparison')) {
            let comparisonTable = document.getElementById('car-comparison')
            let makeField = document.querySelector('.form-first select[name=calculator-make]')
            let modelField = document.querySelector('.form-first select[name=calculator-model]')
            let derivativeField = document.querySelector('.form-first select[name=calculator-derivative]')
            let makeField2 = document.querySelector('.form-second select[name=calculator-make]')
            let modelField2 = document.querySelector('.form-second select[name=calculator-model]')
            let derivativeField2 = document.querySelector('.form-second select[name=calculator-derivative]')
            loadManufacturersCalc('car', true, '.form-first select[name=calculator-make]');
            loadManufacturersCalc('car', true, '.form-second select[name=calculator-make]');

            makeField2.addEventListener('change', e => {
                makeField.selectedIndex = makeField2.selectedIndex;
                makeField.dispatchEvent(new Event('change'));
            })
            modelField2.addEventListener('change', e => {
                modelField.selectedIndex = modelField2.selectedIndex;
                modelField.dispatchEvent(new Event('change'));
            })
            derivativeField2.addEventListener('change', e => {
                derivativeField.selectedIndex = derivativeField2.selectedIndex;
                derivativeField.dispatchEvent(new Event('change'));
            })

            function compareColumns(row, reverse = false, blue = false) {
                let largest = 0
                let smallest = 9999
                comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((value, key, parent) => {
                    if (comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).length > 1) {
                        (largest < parseInt(value.getAttribute('data-compare'))) ? largest = value.getAttribute('data-compare') : '';
                        (smallest > parseInt(value.getAttribute('data-compare'))) ? smallest = value.getAttribute('data-compare'): '';
                        comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((v) => {v.setAttribute('data-highlight', '')});
                        if(largest !== smallest) {
                            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${largest}']`).forEach((v) => {v.setAttribute('data-highlight', `up-${(blue) ? 'blue' : ((reverse) ? 'red' : 'green')}`)})
                            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${smallest}']`).forEach((v) => {v.setAttribute('data-highlight', `down-${(blue) ? 'blue' : ((reverse) ? 'green' : 'red')}`)})
                        }
                    }
                })
            }

            function loadPrice($spot, $derivative) {
                comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = 'Loading...';

                document.querySelector('input[name="car_id"]').value = $derivative;
                let url = '/api/car/price/' + $derivative;
                let formData = new FormData(document.getElementById('car-comparison'));
                fetch(url, {
                    method: 'POST',
                    body: formData,
                }).then(function (response) {
                    if (response.status !== 200) {
                        console.warn('Looks like there was a problem. Status Code: ' + response.status);
                        return;
                    }
                    return response.json();
                }).then(function (data) {
                    if (data) {
                        comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.monthly_rental).toFixed(2)) : 'N/A';
                        (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
                        (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
                        (parseInt(data.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.monthly_rental) : '';
                        compareColumns('price', true);
                        // comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.term != null) ? data.term + ' months' : 'N/A';
                        // (parseInt(data.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.term) : '';
                        // comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.initial_profile != null) ? data.initial_profile + ' months' : 'N/A';
                        // (parseInt(data.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.initial_profile) : '';
                        // comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.mileage != null) ? data.mileage + ' miles' : 'N/A';
                        // (parseInt(data.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.mileage) : '';
                    }
                }).catch(function (err) {
                    console.error('Fetch Error -', err);
                    document.getElementsByClassName('price')[0].classList.remove('hidden');
                    document.getElementsByClassName('price-fetching')[0].classList.add('hidden');
                });
            }

            function setLinks($spot, $active, $url, $fuel) {
                let params = '?' + new URLSearchParams({
                    'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
                    'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
                    'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
                });
                ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
                ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
                ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            }

            function loadVehicle($spot, $derivative) {
                if ($derivative !== 0) {
                    let url = '/api/car/' + $derivative;
                    let params = '?' + new URLSearchParams({'type': (document.querySelector('#car-comparison input[name=type]')).value});
                    fetch(url + params).then(function(response) {
                        if (response.status !== 200) {
                            console.warn('Looks like there was a problem. Status Code: ' + response.status);
                            return;
                        }
                        return response.json();
                    }).then(function(data) {
                        let getCapTechnicalData;
                        if(data.car.technical) {
                            getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
                        } else {
                            getCapTechnicalData = ($category, $term) => 'N/A';
                        }
                        comparisonTable.setAttribute(`data-car-${$spot}`, $derivative);

                        comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] .make`).innerText = data.car.range_name;
                        comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] .derivative`).innerText = data.car.name;

                        (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
                        (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');

                        comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('onerror', `this.src="${data.car.main_img}"`);
                        data.car.main_img.includes('std/') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img.replace('std/', 'big/')) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img);

                        setLinks($spot, data.car.active, data.car.full_url, data.car.fuel_type);

                        comparisonTable.querySelector(`[data-cell-content="fuel-type"] [data-car=${$spot}] span`).innerText = (data.car.fuel_type) ? data.car.fuel_type : 'N/A';
                        comparisonTable.querySelector(`[data-cell-content="p11d"] [data-car=${$spot}] span`).innerText = (data.car.base_price) ? '£' + numberWithCommas((parseFloat(data.car.base_price)).toFixed(0)) : 'N/A';
                        comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value + ' miles' : ((data.car.electric_range) ? data.car.electric_range + ' miles' : 'N/A');
                        (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) : comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range);
                        compareColumns('electric-range');
                        comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}] span`).innerText = (data.car.electric_range_real_world) ? data.car.electric_range_real_world + ' miles' : 'N/A';
                        (parseInt(data.car.electric_range_real_world) > 0) ? comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range_real_world) : '';
                        compareColumns('real-electric-range');

                        comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}] span`).innerText = (data.car.mpg_combined && parseInt(data.car.mpg_combined) > 0) ? data.car.mpg_combined + ' mpg' : 'N/A';
                        (parseInt(data.car.mpg_combined) > 0) ? comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.mpg_combined) : '';
                        compareColumns('official-mpg');
                        comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max') && getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) ? getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value + ' mpg' : 'N/A';
                        (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max')) ? comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) : '';
                        compareColumns('real-mpg');

                        let indicative_fuel_cost = indicativeCost(data.car.fuel_type, (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra), (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
                        comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}] span`).innerText = (parseInt(indicative_fuel_cost) >= 0) ? indicative_fuel_cost + ' p/mile' : 'N/A';
                        (parseInt(indicative_fuel_cost) >= 0) ? comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}]`).setAttribute('data-compare', indicative_fuel_cost) : '';
                        compareColumns('indicative-cost', true);

                        // comparisonTable.querySelector(`[data-cell-content="green-car-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
                        // comparisonTable.querySelector(`[data-cell-content="climate-air"] [data-car=${$spot}] span`).innerText = 'N/A';getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')
                        comparisonTable.querySelector(`[data-cell-content="co2-emissions"] [data-car=${$spot}] span`).innerText = (data.car.co2) ? parseInt(data.car.co2).toFixed(0) + ' g/km' : 'N/A';
                        comparisonTable.querySelector(`[data-cell-content="euro-standard"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions') && getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value) ? getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value : 'N/A';
                        // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .nox`).innerText = (getCapTechnicalData('Emissions - ICE', 'NOx')) ? getCapTechnicalData('Emissions - ICE', 'NOx').value : 'Not Available';
                        // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .particles`).innerText = (getCapTechnicalData('Emissions - ICE', 'Particles')) ? getCapTechnicalData('Emissions - ICE', 'Particles').value : 'Not Available';

                        if (data.car.tax_band) {
                            comparisonTable.querySelector(`[data-cell-content="tax-band"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.band != null) ? data.car.tax_band.band : 'N/A';
                            comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.rate != null) ? '£' + data.car.tax_band.rate : 'N/A';
                            (parseInt(data.car.tax_band.rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.rate) : '';
                            compareColumns('first-year-rate', true);
                            comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.second_rate != null) ? '£' + data.car.tax_band.second_rate : 'N/A';
                            (parseInt(data.car.tax_band.second_rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.second_rate) : '';
                            compareColumns('year-rate', true);
                        }

                        if (data.car.fuel_type === 'Petrol') {
                            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
                            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? '£12.50' : '£0') : 'N/A';
                        } else if (data.car.fuel_type === 'Diesel') {
                            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
                            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? '£12.50' : '£0') : 'N/A';
                        } else if (data.car.fuel_type === 'Electric') {
                            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = '£0';
                            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
                        } else {
                            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
                            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
                        }

                        if (data.car.tax) {
                            comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year1 != null) ? data.car.tax.Year1 + '%' : 'N/A';
                            (parseInt(data.car.tax.Year1) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year1) : '';
                            compareColumns('bik-1', true);
                            comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year2 != null) ? data.car.tax.Year2 + '%' : 'N/A';
                            (parseInt(data.car.tax.Year2) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year2) : '';
                            compareColumns('bik-2', true);
                            comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year3 != null) ? data.car.tax.Year3 + '%' : 'N/A';
                            (parseInt(data.car.tax.Year3) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year3) : '';
                            compareColumns('bik-3', true);
                        }

                        if (data.car.from_price) {
                            comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.car.from_price.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.car.from_price.monthly_rental).toFixed(2)) : 'N/A';
                            (parseInt(data.car.from_price.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.monthly_rental) : '';
                            compareColumns('price', true);
                            comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.car.from_price.term != null) ? data.car.from_price.term + ' months' : 'N/A';
                            (parseInt(data.car.from_price.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.term) : '';
                            comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.car.from_price.initial_profile != null) ? data.car.from_price.initial_profile + ' months' : 'N/A';
                            (parseInt(data.car.from_price.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.initial_profile) : '';
                            comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.car.from_price.mileage != null) ? data.car.from_price.mileage + ' miles' : 'N/A';
                            (parseInt(data.car.from_price.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.mileage) : '';
                        }

                        comparisonTable.querySelector(`[data-cell-content="vehicle-class"] [data-car=${$spot}] span`).innerText = (data.car.body_type) ? data.car.body_type : 'N/A';
                        comparisonTable.querySelector(`[data-cell-content="practicality"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Weight and Capacities', 'No. of Seats') && getCapTechnicalData('Weight and Capacities', 'No. of Seats').value) ? getCapTechnicalData('Weight and Capacities', 'No. of Seats').value + ' seats' : 'N/A';
                        // comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-cc`).innerText = (getCapTechnicalData('Engine and Drive Train', 'CC') && parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? getCapTechnicalData('Engine and Drive Train', 'CC').value + ' cc' : 'N/A';
                        // (parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Engine and Drive Train', 'CC').value) : '';
                        // compareColumns('engine-size', false, true);
                        // comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-litres`).innerText = (getCapTechnicalData('General', 'Badge Engine CC').value) ? ' (' + getCapTechnicalData('General', 'Badge Engine CC').value + ' Litre)' : '';
                        comparisonTable.querySelector(`[data-cell-content="transmission"] [data-car=${$spot}] span`).innerText = (data.car.transmission) ? data.car.transmission : 'N/A';
                        comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Engine Power - BHP') && getCapTechnicalData('Performance', 'Engine Power - BHP').value) ? getCapTechnicalData('Performance', 'Engine Power - BHP').value + ' BHP' : 'N/A';
                        (parseInt(getCapTechnicalData('Performance', 'Engine Power - BHP').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Engine Power - BHP').value) : '';
                        compareColumns('engine-power', false, true);
                        comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}] span`).innerText = (data.car.zero_to_60) ? data.car.zero_to_60 + ' Seconds' : 'N/A';
                        (parseInt(data.car.zero_to_60) > 1) ? comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.zero_to_60) : '';
                        compareColumns('acceleration', false, true);
                        // comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Top Speed') && getCapTechnicalData('Performance', 'Top Speed').value) ? getCapTechnicalData('Performance', 'Top Speed').value + ' mph' : 'N/A';
                        // (getCapTechnicalData('Performance', 'Top Speed')) ? comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Top Speed').value) : '';
                        // compareColumns('top-speed', false, true);
                        if(getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating').value !== 'Not Available'){
                            comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = '';
                            for (let step = 0; step < parseInt(getCapTechnicalData('General', 'NCAP Overall Rating').value); step++) {
                                let star = document.createElement("img");
                                star.setAttribute('src', '/themes/lcvgroup/img/icons/general/star-gold.svg');
                                comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).appendChild(star);
                            }
                        } else {
                            comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
                        }
                        comparisonTable.querySelector(`[data-cell-content="insurance-group"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('General', 'Insurance Group') && getCapTechnicalData('General', 'Insurance Group').value) ? getCapTechnicalData('General', 'Insurance Group').value : 'N/A';

                        (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).classList.add('visuallyhidden');

                        ($spot === 'third') ? comparisonTable.setAttribute('data-car-form', '0') : comparisonTable.setAttribute('data-car-form', '1');

                        // loadModelsCalc('car', 0, true, false)
                        loadModelsCalc('car', 0, false, true)

                        loadPrice($spot, $derivative)

                        comparisonTable.reset();
                    }).catch(function(err) {
                        console.error('Fetch Error -', err);
                    });
                }
            }

            function updateParams() {
                let params = '?' + new URLSearchParams({
                    'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
                    'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
                    'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
                });
                comparisonTable.querySelectorAll(`[data-cell-content="img"] a, [data-cell-content="model"] a, [data-cell-content="cta"] a`).forEach((value) => {
                    let url;
                    (value.getAttribute('href').split('?')[0].includes('/car-leasing/')) ? url = value.getAttribute('href').split('?')[0] + params : url = value.getAttribute('href').split('?')[0];
                    value.setAttribute('href', url);
                })
            }


            document.querySelectorAll('.quote-terms').forEach((value) => {
                value.addEventListener('change', (ev) => {
                    loadPrice('first', document.querySelector('#car-comparison').dataset.carFirst);
                    loadPrice('second', document.querySelector('#car-comparison').dataset.carSecond);
                    loadPrice('third', document.querySelector('#car-comparison').dataset.carThird);
                    updateParams();
                    ev.target.classList.add('visuallyhidden');
                    ev.composedPath()[1].querySelector('button').classList.remove('visuallyhidden');
                })
            })

            document.querySelectorAll('#toggle-term, #toggle-profile, #toggle-mileage').forEach((value) => {
                value.addEventListener('click', (ev) => {
                    ev.target.classList.add('visuallyhidden');
                    ev.composedPath()[1].querySelector('select').classList.remove('visuallyhidden');
                })
            })

            makeField.addEventListener('change', () => {
                (makeField.value > 0) ? loadModelsCalc('car', makeField.value, false, false) : false;
            })

            modelField.addEventListener('change', () => {
                (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, true, false, true, false) : false;
                derivativeField.dataset.range = makeField.options[makeField.selectedIndex].text + ' ' + modelField.options[modelField.selectedIndex].text;
            });

            setTimeout(() => {
                (comparisonTable.dataset.carFirst > 1) ? loadVehicle('first', comparisonTable.dataset.carFirst) : null;
            }, 200);
            setTimeout(() => {
                (comparisonTable.dataset.carSecond > 1) ? loadVehicle('second', comparisonTable.dataset.carSecond) : null;
            }, 400);
            setTimeout(() => {
                if (comparisonTable.dataset.carThird > 1) {
                    loadVehicle('third', comparisonTable.dataset.carThird);
                    comparisonTable.setAttribute('data-car-form', '0');
                }
            }, 1000);

            derivativeField.addEventListener('change', (event) => {
                document.querySelectorAll('.show-form').forEach(v => { v.classList.remove('hide') })
                document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.add('hide') })
                if(event.target.value > 0) {
                    document.querySelectorAll('.share-button > a').forEach(value => { value.setAttribute('href', value.getAttribute('href').replace('car[]=&', `car[]=${event.target.value}&`)); })
                    if(parseInt(comparisonTable.dataset.carFirst) < 1) {
                        loadVehicle('first', event.target.value)
                    } else if (parseInt(comparisonTable.dataset.carSecond) < 1) {
                        loadVehicle('second', event.target.value)
                    } else if (parseInt(comparisonTable.dataset.carThird) < 1) {
                        loadVehicle('third', event.target.value)
                    }

                    let cookie = Cookies.get('compare_list')
                    let range_name = derivativeField.dataset.range
                    if (cookie) {
                        let cookie_obj = JSON.parse(cookie);
                        if (Object.keys(cookie_obj).length < 3) {
                            if (cookie_obj[event.target.value] === undefined) {
                                cookie_obj = {...cookie_obj, [event.target.value] : range_name};
                                let cookie_string = JSON.stringify(cookie_obj)
                                Cookies.set('compare_list', cookie_string)
                            }
                        }
                    } else {
                        let cookie_obj = JSON.parse(`{"${event.target.value}":"${range_name}"}`);
                        let cookie_string = JSON.stringify(cookie_obj)
                        Cookies.set('compare_list', cookie_string)
                    }

                }
            })

            function resetSlot($slot, $id) {
                comparisonTable.setAttribute('data-car-form', '1');
                document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-highlight', '') })
                document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-compare', '') })
                if ($slot === 'first') {
                    comparisonTable.setAttribute('data-car-first', '-1');
                } else if ($slot === 'second') {
                    comparisonTable.setAttribute('data-car-second', '-1');
                } else {
                    comparisonTable.setAttribute('data-car-third', '-1');
                }
                document.querySelectorAll('.share-button > a').forEach(value => { value.setAttribute('href', (value.getAttribute('href').replace(`car[]=${$id}&`, 'car[]=&'))); });

                let selectedVehicles = [parseInt(comparisonTable.dataset.carFirst), parseInt(comparisonTable.dataset.carSecond), parseInt(comparisonTable.dataset.carThird)];
                [...selectedVehicles].filter(val => val !== -1).forEach((value, index, array) => {
                    if (index === 0) {
                        (array[0]) ? loadVehicle('first', array[0]) : comparisonTable.setAttribute('data-car-first', '0');
                        (array[1]) ? loadVehicle('second', array[1]) : comparisonTable.setAttribute('data-car-second', '0');
                        (array[2]) ? loadVehicle('third', array[2]) : comparisonTable.setAttribute('data-car-third', '0');
                        let cookie = Cookies.get('compare_list');
                        let cookie_obj = JSON.parse(cookie);
                        delete cookie_obj[$id];
                        (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
                    }
                })

            }
            document.querySelectorAll('div[data-car] .reset').forEach(value => {
                value.addEventListener('click', evt => {
                    document.querySelectorAll('.show-form').forEach(v => { v.classList.remove('hide') })
                    document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.add('hide') })
                    comparisonTable.querySelectorAll('a.view-range-button').forEach((v) => { v.classList.remove('visuallyhidden') });
                    (evt.target.classList.contains('first')) ? resetSlot('first', comparisonTable.dataset.carFirst) : null;
                    (evt.target.classList.contains('second')) ? resetSlot('second', comparisonTable.dataset.carSecond) : null;
                    (evt.target.classList.contains('third')) ? resetSlot('third', comparisonTable.dataset.carThird) : null;
                })
            })

            document.querySelectorAll('.show-form').forEach(v => {
                v.addEventListener('click', e => {
                    document.querySelectorAll('.show-form').forEach(v => { v.classList.add('hide') })
                    document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.remove('hide') })
                })
            })

        }
        // Compare Vans
        if (document.querySelector('.tools-main>div').classList.contains('van-comparison')) {
            let comparisonTable = document.getElementById('van-comparison')
            let makeField = document.querySelector('.form-first select[name=calculator-make]')
            let modelField = document.querySelector('.form-first select[name=calculator-model]')
            let derivativeField = document.querySelector('.form-first select[name=calculator-derivative]')
            let makeField2 = document.querySelector('.form-second select[name=calculator-make]')
            let modelField2 = document.querySelector('.form-second select[name=calculator-model]')
            let derivativeField2 = document.querySelector('.form-second select[name=calculator-derivative]')
            loadManufacturersCalc('van', true, '.form-first select[name=calculator-make]');
            loadManufacturersCalc('van', true, '.form-second select[name=calculator-make]');

            makeField2.addEventListener('change', e => {
                makeField.selectedIndex = makeField2.selectedIndex;
                makeField.dispatchEvent(new Event('change'));
            })
            modelField2.addEventListener('change', e => {
                modelField.selectedIndex = modelField2.selectedIndex;
                modelField.dispatchEvent(new Event('change'));
            })
            derivativeField2.addEventListener('change', e => {
                derivativeField.selectedIndex = derivativeField2.selectedIndex;
                derivativeField.dispatchEvent(new Event('change'));
            })

            function compareColumns(row, reverse = false, blue = false) {
                let largest = 0
                let smallest = 9999
                comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((value, key, parent) => {
                    if (comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).length > 1) {
                        (largest < parseInt(value.getAttribute('data-compare'))) ? largest = value.getAttribute('data-compare') : '';
                        (smallest > parseInt(value.getAttribute('data-compare'))) ? smallest = value.getAttribute('data-compare'): '';
                        comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((v) => {v.setAttribute('data-highlight', '')});
                        if(largest !== smallest) {
                            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${largest}']`).forEach((v) => {v.setAttribute('data-highlight', `up-${(blue) ? 'blue' : ((reverse) ? 'red' : 'green')}`)})
                            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${smallest}']`).forEach((v) => {v.setAttribute('data-highlight', `down-${(blue) ? 'blue' : ((reverse) ? 'green' : 'red')}`)})
                        }
                    }
                })
            }

            function loadPrice($spot, $derivative) {
                comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
                comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = 'Loading...';

                document.querySelector('input[name="van_id"]').value = $derivative;
                let url = '/api/van/price/' + $derivative;
                let formData = new FormData(document.getElementById('van-comparison'));
                fetch(url, {
                    method: 'POST',
                    body: formData,
                }).then(function (response) {
                    if (response.status !== 200) {
                        console.warn('Looks like there was a problem. Status Code: ' + response.status);
                        return;
                    }
                    return response.json();
                }).then(function (data) {
                    if (data) {
                        comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.monthly_rental).toFixed(2)) : 'N/A';
                        (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
                        (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
                        (parseInt(data.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.monthly_rental) : '';
                        compareColumns('price', true);
                        // comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.term != null) ? data.term + ' months' : 'N/A';
                        // (parseInt(data.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.term) : '';
                        // comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.initial_profile != null) ? data.initial_profile + ' months' : 'N/A';
                        // (parseInt(data.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.initial_profile) : '';
                        // comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.mileage != null) ? data.mileage + ' miles' : 'N/A';
                        // (parseInt(data.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.mileage) : '';
                    }
                }).catch(function (err) {
                    console.error('Fetch Error -', err);
                    document.getElementsByClassName('price')[0].classList.remove('hidden');
                    document.getElementsByClassName('price-fetching')[0].classList.add('hidden');
                });
            }

            function setLinks($spot, $active, $url, $fuel) {
                let params = '?' + new URLSearchParams({
                    'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
                    'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
                    'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
                });
                ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
                ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
                ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            }

            function loadVehicle($spot, $derivative) {
                if ($derivative !== 0) {
                    let url = '/api/van/' + $derivative;
                    let params = '?' + new URLSearchParams({'type': (document.querySelector('#van-comparison input[name=type]')).value});
                    fetch(url + params).then(function(response) {
                        if (response.status !== 200) {
                            console.warn('Looks like there was a problem. Status Code: ' + response.status);
                            return;
                        }
                        return response.json();
                    }).then(function(data) {
                        let getCapTechnicalData;
                        if(data.car.technical) {
                            getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
                        } else {
                            getCapTechnicalData = ($category, $term) => 'N/A';
                        }
                        comparisonTable.setAttribute(`data-car-${$spot}`, $derivative);

                        comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] .make`).innerText = data.car.range_name;
                        comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] .derivative`).innerText = data.car.name;

                        (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
                        (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');

                        comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('onerror', `this.src="${data.car.main_img}"`);
                        data.car.main_img.includes('std/') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img.replace('std/', 'big/')) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img);

                        setLinks($spot, data.car.active, data.car.full_url, data.car.fuel_type);

                        comparisonTable.querySelector(`[data-cell-content="fuel-type"] [data-car=${$spot}] span`).innerText = (data.car.fuel_type) ? data.car.fuel_type : 'N/A';
                        // comparisonTable.querySelector(`[data-cell-content="p11d"] [data-car=${$spot}] span`).innerText = (data.car.base_price) ? '£' + numberWithCommas((parseFloat(data.car.base_price)).toFixed(0)) : 'N/A';
                        comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value + ' miles' : ((data.car.electric_range) ? data.car.electric_range + ' miles' : 'N/A');
                        (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) : comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range);
                        compareColumns('electric-range');
                        comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}] span`).innerText = (data.car.electric_range_real_world) ? data.car.electric_range_real_world + ' miles' : 'N/A';
                        (parseInt(data.car.electric_range_real_world) > 0) ? comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range_real_world) : '';
                        compareColumns('real-electric-range');

                        comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}] span`).innerText = (data.car.mpg_combined && parseInt(data.car.mpg_combined) > 0) ? data.car.mpg_combined + ' mpg' : 'N/A';
                        (parseInt(data.car.mpg_combined) > 0) ? comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.mpg_combined) : '';
                        compareColumns('official-mpg');
                        comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max') && getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) ? getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value + ' mpg' : 'N/A';
                        (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max')) ? comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) : '';
                        compareColumns('real-mpg');

                        let indicative_fuel_cost = indicativeCost(data.car.fuel_type, (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra), (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
                        comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}] span`).innerText = (parseInt(indicative_fuel_cost) >= 0) ? indicative_fuel_cost + ' p/mile' : 'N/A';
                        (parseInt(indicative_fuel_cost) >= 0) ? comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}]`).setAttribute('data-compare', indicative_fuel_cost) : '';
                        compareColumns('indicative-cost', true);

                        // comparisonTable.querySelector(`[data-cell-content="green-car-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
                        // comparisonTable.querySelector(`[data-cell-content="climate-air"] [data-car=${$spot}] span`).innerText = 'N/A';getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')
                        comparisonTable.querySelector(`[data-cell-content="co2-emissions"] [data-car=${$spot}] span`).innerText = (data.car.co2) ? parseInt(data.car.co2).toFixed(0) + ' g/km' : 'N/A';
                        comparisonTable.querySelector(`[data-cell-content="euro-standard"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions') && getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value) ? getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value : 'N/A';
                        // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .nox`).innerText = (getCapTechnicalData('Emissions - ICE', 'NOx')) ? getCapTechnicalData('Emissions - ICE', 'NOx').value : 'Not Available';
                        // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .particles`).innerText = (getCapTechnicalData('Emissions - ICE', 'Particles')) ? getCapTechnicalData('Emissions - ICE', 'Particles').value : 'Not Available';

                        // if (data.car.tax_band) {
                        //   comparisonTable.querySelector(`[data-cell-content="tax-band"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.band != null) ? data.car.tax_band.band : 'N/A';
                        //   comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.rate != null) ? '£' + data.car.tax_band.rate : 'N/A';
                        //   (parseInt(data.car.tax_band.rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.rate) : '';
                        //   compareColumns('first-year-rate', true);
                        //   comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.second_rate != null) ? '£' + data.car.tax_band.second_rate : 'N/A';
                        //   (parseInt(data.car.tax_band.second_rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.second_rate) : '';
                        //   compareColumns('year-rate', true);
                        // }

                        comparisonTable.querySelector(`[data-cell-content="van-height"] [data-car=${$spot}] span`).innerText = (data.car.height) ? parseInt(data.car.height).toFixed(0) + ' mm' : 'N/A';
                        (parseInt(data.car.height) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-height"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.height) : '';
                        compareColumns('van-height');
                        comparisonTable.querySelector(`[data-cell-content="van-length"] [data-car=${$spot}] span`).innerText = (data.car.length) ? parseInt(data.car.length).toFixed(0) + ' mm' : 'N/A';
                        (parseInt(data.car.length) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.length) : '';
                        compareColumns('van-length');
                        comparisonTable.querySelector(`[data-cell-content="van-wheel_base"] [data-car=${$spot}] span`).innerText = (data.car.wheel_base) ? parseInt(data.car.wheel_base).toFixed(0) + ' mm' : 'N/A';
                        (parseInt(data.car.wheel_base) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-wheel_base"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.wheel_base) : '';
                        compareColumns('van-wheel_base');
                        comparisonTable.querySelector(`[data-cell-content="van-load_width"] [data-car=${$spot}] span`).innerText = (data.car.load_width) ? parseInt(data.car.load_width).toFixed(0) + ' mm' : 'N/A';
                        (parseInt(data.car.load_width) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_width"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_width) : '';
                        compareColumns('van-load_width');
                        comparisonTable.querySelector(`[data-cell-content="van-load_height"] [data-car=${$spot}] span`).innerText = (data.car.load_height) ? parseInt(data.car.load_height).toFixed(0) + ' mm' : 'N/A';
                        (parseInt(data.car.load_height) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_height"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_height) : '';
                        compareColumns('van-load_height');
                        comparisonTable.querySelector(`[data-cell-content="van-load_length"] [data-car=${$spot}] span`).innerText = (data.car.load_length) ? parseInt(data.car.load_length).toFixed(0) + ' mm' : 'N/A';
                        (parseInt(data.car.load_length) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_length) : '';
                        compareColumns('van-load_length');
                        comparisonTable.querySelector(`[data-cell-content="van-payload"] [data-car=${$spot}] span`).innerText = (data.car.payload) ? parseInt(data.car.payload).toFixed(0) + ' kg' : 'N/A';
                        (parseInt(data.car.payload) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-payload"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.payload) : '';
                        compareColumns('van-payload');
                        comparisonTable.querySelector(`[data-cell-content="van-load_space"] [data-car=${$spot}] span`).innerText = (data.car.load_space) ? parseInt(data.car.load_space).toFixed(0) + ' m3' : 'N/A';
                        (parseInt(data.car.load_space) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_space"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_space) : '';
                        compareColumns('van-load_space');
                        // if (data.car.fuel_type === 'Petrol') {
                        //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
                        //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? '£12.50' : '£0') : 'N/A';
                        // } else if (data.car.fuel_type === 'Diesel') {
                        //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
                        //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? '£12.50' : '£0') : 'N/A';
                        // } else if (data.car.fuel_type === 'Electric') {
                        //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = '£0';
                        //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
                        // } else {
                        //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
                        //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
                        // }

                        // if (data.car.tax) {
                        //   comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year1 != null) ? data.car.tax.Year1 + '%' : 'N/A';
                        //   (parseInt(data.car.tax.Year1) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year1) : '';
                        //   compareColumns('bik-1', true);
                        //   comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year2 != null) ? data.car.tax.Year2 + '%' : 'N/A';
                        //   (parseInt(data.car.tax.Year2) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year2) : '';
                        //   compareColumns('bik-2', true);
                        //   comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year3 != null) ? data.car.tax.Year3 + '%' : 'N/A';
                        //   (parseInt(data.car.tax.Year3) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year3) : '';
                        //   compareColumns('bik-3', true);
                        // }

                        if (data.car.from_price) {
                            comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.car.from_price.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.car.from_price.monthly_rental).toFixed(2)) : 'N/A';
                            (parseInt(data.car.from_price.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.monthly_rental) : '';
                            compareColumns('price', true);
                            comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.car.from_price.term != null) ? data.car.from_price.term + ' months' : 'N/A';
                            (parseInt(data.car.from_price.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.term) : '';
                            comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.car.from_price.initial_profile != null) ? data.car.from_price.initial_profile + ' months' : 'N/A';
                            (parseInt(data.car.from_price.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.initial_profile) : '';
                            comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.car.from_price.mileage != null) ? data.car.from_price.mileage + ' miles' : 'N/A';
                            (parseInt(data.car.from_price.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.mileage) : '';
                        }

                        comparisonTable.querySelector(`[data-cell-content="vehicle-class"] [data-car=${$spot}] span`).innerText = (data.car.body_type) ? data.car.body_type : 'N/A';
                        comparisonTable.querySelector(`[data-cell-content="practicality"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Weight and Capacities', 'No. of Seats') && getCapTechnicalData('Weight and Capacities', 'No. of Seats').value) ? getCapTechnicalData('Weight and Capacities', 'No. of Seats').value + ' seats' : 'N/A';
                        // comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-cc`).innerText = (getCapTechnicalData('Engine and Drive Train', 'CC') && parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? getCapTechnicalData('Engine and Drive Train', 'CC').value + ' cc' : 'N/A';
                        // (parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Engine and Drive Train', 'CC').value) : '';
                        // compareColumns('engine-size', false, true);
                        // comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-litres`).innerText = (getCapTechnicalData('General', 'Badge Engine CC').value) ? ' (' + getCapTechnicalData('General', 'Badge Engine CC').value + ' Litre)' : '';
                        comparisonTable.querySelector(`[data-cell-content="transmission"] [data-car=${$spot}] span`).innerText = (data.car.transmission) ? data.car.transmission : 'N/A';
                        comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Engine Power - BHP') && getCapTechnicalData('Performance', 'Engine Power - BHP').value) ? getCapTechnicalData('Performance', 'Engine Power - BHP').value + ' BHP' : 'N/A';
                        (getCapTechnicalData('Performance', 'Engine Power - BHP')) ? comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Engine Power - BHP').value) : '';
                        compareColumns('engine-power', false, true);
                        comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}] span`).innerText = (data.car.zero_to_60) ? data.car.zero_to_60 + ' Seconds' : 'N/A';
                        (parseInt(data.car.zero_to_60) > 1) ? comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.zero_to_60) : '';
                        compareColumns('acceleration', false, true);
                        // comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Top Speed') && getCapTechnicalData('Performance', 'Top Speed').value) ? getCapTechnicalData('Performance', 'Top Speed').value + ' mph' : 'N/A';
                        // (getCapTechnicalData('Performance', 'Top Speed')) ? comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Top Speed').value) : '';
                        // compareColumns('top-speed', false, true);
                        if(getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating').value !== 'Not Available'){
                            comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = '';
                            for (let step = 0; step < parseInt(getCapTechnicalData('General', 'NCAP Overall Rating').value); step++) {
                                let star = document.createElement("img");
                                star.setAttribute('src', '/themes/lcvgroup/img/icons/general/star-gold.svg');
                                comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).appendChild(star);
                            }
                        } else {
                            comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
                        }
                        comparisonTable.querySelector(`[data-cell-content="insurance-group"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('General', 'Insurance Group') && getCapTechnicalData('General', 'Insurance Group').value) ? getCapTechnicalData('General', 'Insurance Group').value : 'N/A';

                        (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).classList.add('visuallyhidden');

                        ($spot === 'third') ? comparisonTable.setAttribute('data-car-form', '0') : comparisonTable.setAttribute('data-car-form', '1');

                        // loadModelsCalc('car', 0, true, false)
                        loadModelsCalc('van', 0, false, true)

                        loadPrice($spot, $derivative)

                        comparisonTable.reset();
                    }).catch(function(err) {
                        console.error('Fetch Error -', err);
                    });
                }
            }

            function updateParams() {
                let params = '?' + new URLSearchParams({
                    'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
                    'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
                    'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
                });
                comparisonTable.querySelectorAll(`[data-cell-content="img"] a, [data-cell-content="model"] a, [data-cell-content="cta"] a`).forEach((value) => {
                    let url;
                    (value.getAttribute('href').split('?')[0].includes('/van-leasing/')) ? url = value.getAttribute('href').split('?')[0] + params : url = value.getAttribute('href').split('?')[0];
                    value.setAttribute('href', url);
                })
            }


            document.querySelectorAll('.quote-terms').forEach((value) => {
                value.addEventListener('change', (ev) => {
                    loadPrice('first', document.querySelector('#van-comparison').dataset.carFirst);
                    loadPrice('second', document.querySelector('#van-comparison').dataset.carSecond);
                    loadPrice('third', document.querySelector('#van-comparison').dataset.carThird);
                    updateParams();
                    ev.target.classList.add('visuallyhidden');
                    ev.composedPath()[1].querySelector('button').classList.remove('visuallyhidden');
                })
            })

            document.querySelectorAll('#toggle-term, #toggle-profile, #toggle-mileage').forEach((value) => {
                value.addEventListener('click', (ev) => {
                    ev.target.classList.add('visuallyhidden');
                    ev.composedPath()[1].querySelector('select').classList.remove('visuallyhidden');
                })
            })

            makeField.addEventListener('change', () => {
                (makeField.value > 0) ? loadModelsCalc('van', makeField.value, false, false) : false;
            })

            modelField.addEventListener('change', () => {
                (modelField.value > 0) ? loadDerivativeCalc('van', modelField.value, true, false, true, false) : false;
                derivativeField.dataset.range = makeField.options[makeField.selectedIndex].text + ' ' + modelField.options[modelField.selectedIndex].text;
            });

            setTimeout(() => {
                (comparisonTable.dataset.carFirst > 1) ? loadVehicle('first', comparisonTable.dataset.carFirst) : null;
            }, 200);
            setTimeout(() => {
                (comparisonTable.dataset.carSecond > 1) ? loadVehicle('second', comparisonTable.dataset.carSecond) : null;
            }, 400);
            setTimeout(() => {
                if (comparisonTable.dataset.carThird > 1) {
                    loadVehicle('third', comparisonTable.dataset.carThird);
                    comparisonTable.setAttribute('data-car-form', '0');
                }
            }, 1000);

            derivativeField.addEventListener('change', (event) => {
                document.querySelectorAll('.show-form').forEach(v => { v.classList.remove('hide') })
                document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.add('hide') })
                if(event.target.value > 0) {
                    document.querySelectorAll('.share-button > a').forEach(value => { value.setAttribute('href', value.getAttribute('href').replace('car[]=&', `car[]=${event.target.value}&`)); })
                    if(parseInt(comparisonTable.dataset.carFirst) < 1) {
                        loadVehicle('first', event.target.value)
                    } else if (parseInt(comparisonTable.dataset.carSecond) < 1) {
                        loadVehicle('second', event.target.value)
                    } else if (parseInt(comparisonTable.dataset.carThird) < 1) {
                        loadVehicle('third', event.target.value)
                    }

                    let cookie = Cookies.get('compare_list_vans')
                    let range_name = derivativeField.dataset.range
                    if (cookie) {
                        let cookie_obj = JSON.parse(cookie);
                        if (Object.keys(cookie_obj).length < 3) {
                            if (cookie_obj[event.target.value] === undefined) {
                                cookie_obj = {...cookie_obj, [event.target.value] : range_name};
                                let cookie_string = JSON.stringify(cookie_obj)
                                Cookies.set('compare_list_vans', cookie_string)
                            }
                        }
                    } else {
                        let cookie_obj = JSON.parse(`{"${event.target.value}":"${range_name}"}`);
                        let cookie_string = JSON.stringify(cookie_obj)
                        Cookies.set('compare_list_vans', cookie_string)
                    }

                }
            })

            function resetSlot($slot, $id) {
                comparisonTable.setAttribute('data-car-form', '1');
                document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-highlight', '') })
                document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-compare', '') })
                if ($slot === 'first') {
                    comparisonTable.setAttribute('data-car-first', '-1');
                } else if ($slot === 'second') {
                    comparisonTable.setAttribute('data-car-second', '-1');
                } else {
                    comparisonTable.setAttribute('data-car-third', '-1');
                }
                document.querySelectorAll('.share-button > a').forEach(value => { value.setAttribute('href', (value.getAttribute('href').replace(`car[]=${$id}&`, 'car[]=&'))); });

                let selectedVehicles = [parseInt(comparisonTable.dataset.carFirst), parseInt(comparisonTable.dataset.carSecond), parseInt(comparisonTable.dataset.carThird)];
                [...selectedVehicles].filter(val => val !== -1).forEach((value, index, array) => {
                    if (index === 0) {
                        (array[0]) ? loadVehicle('first', array[0]) : comparisonTable.setAttribute('data-car-first', '0');
                        (array[1]) ? loadVehicle('second', array[1]) : comparisonTable.setAttribute('data-car-second', '0');
                        (array[2]) ? loadVehicle('third', array[2]) : comparisonTable.setAttribute('data-car-third', '0');
                        let cookie = Cookies.get('compare_list_vans');
                        let cookie_obj = JSON.parse(cookie);
                        delete cookie_obj[$id];
                        (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans');
                    }
                })

            }
            document.querySelectorAll('div[data-car] .reset').forEach(value => {
                value.addEventListener('click', evt => {
                    document.querySelectorAll('.show-form').forEach(v => { v.classList.remove('hide') })
                    document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.add('hide') })
                    comparisonTable.querySelectorAll('a.view-range-button').forEach((v) => { v.classList.remove('visuallyhidden') });
                    (evt.target.classList.contains('first')) ? resetSlot('first', comparisonTable.dataset.carFirst) : null;
                    (evt.target.classList.contains('second')) ? resetSlot('second', comparisonTable.dataset.carSecond) : null;
                    (evt.target.classList.contains('third')) ? resetSlot('third', comparisonTable.dataset.carThird) : null;
                })
            })

            document.querySelectorAll('.show-form').forEach(v => {
                v.addEventListener('click', e => {
                    document.querySelectorAll('.show-form').forEach(v => { v.classList.add('hide') })
                    document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.remove('hide') })
                })
            })

        }
        // Journey Cost Calculator
        if (document.querySelector('.tools-main>div').classList.contains('journey-calculator')) {
            loadManufacturersCalc('car', true);
            let makeField = document.querySelector('select[name=calculator-make]')
            let modelField = document.querySelector('select[name=calculator-model]')
            let derivativeField = document.querySelector('select[name=calculator-derivative]')
            let makeFieldCompare = document.querySelector('select[name=calculator-make-compare]')
            let modelFieldCompare = document.querySelector('select[name=calculator-model-compare]')
            let derivativeFieldCompare = document.querySelector('select[name=calculator-derivative-compare]')
            let milesField = document.querySelector('input[name=journey-calculator-miles]')
            let electricityField = document.querySelector('input[name=journey-calculator-electricity]')
            let electricityLabel = document.querySelector('.electricity-cost-label')
            let makeText = document.querySelectorAll('.step-four-make')
            let modelText = document.querySelectorAll('.step-four-model')
            let stepOneNext = document.querySelector('#step-one-next')
            let stepTwoNext = document.querySelector('#step-two-next')
            let electricityCost = parseInt(document.querySelector('#average-data').dataset.averageElectricity);
            let petrolCost = parseInt(document.querySelector('#average-data').dataset.averagePetrol);
            let dieselCost = parseInt(document.querySelector('#average-data').dataset.averageDiesel);
            let averageValue, charger_rate, journey_distance, journey_cost, annual_journey_cost, co2, img_url, electric_range, battery_capacity;
            let comparable_london, comparable_ulez, comparable_journey_cost, comparable_annual_journey_cost, comparable_co2, comparable_img_url, comparable_mpg, comparable_type;
            let ev_loaded, ice_loaded = false;

            function loadVehicle($derivative, $ev = false) {
                let url = '/api/car/' + $derivative;
                fetch(url).then(function(response) {
                    if (response.status !== 200) {
                        console.warn('Looks like there was a problem. Status Code: ' + response.status);
                        return;
                    }
                    return response.json();
                }).then(function(data) {
                    // console.log(data)
                    let getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : null;
                    if ($ev) {
                        // nox = ((getCapTechnicalData('Emissions - ICE', 'NOx') != null && isNaN(getCapTechnicalData('Emissions - ICE', 'NOx') != 'Not Available'))) ? 'Not Available': getCapTechnicalData('Emissions - ICE', 'NOx').value + 'mg';
                        electric_range = (data.car.electric_range != null) ? data.car.electric_range : ((data.car.technical) ? ((getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)')) ? parseFloat(getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)').value) : null) : null);
                        battery_capacity = data.car.battery_capacity;
                        // miles_per_kWh = (getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (miles/kWh) - Comb')) ? getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (miles/kWh) - Comb').value : ( (getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (kWh/100km) - Comb')) ? ( 100 / 1.609344 / parseFloat(getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (kWh/100km) - Comb').value)) : null);
                        co2 = (data.car.co2) ? data.car.co2 : 0;
                        img_url = data.car.main_img;
                        // comparable_car = data.car.non_ev_comparable_car;
                        // setTimeout(() => { loadVehicle(data.car.non_ev_comparable_car, false) }, 500);
                        setTimeout(() => {
                            if (electric_range && battery_capacity) {
                                ev_loaded = true;
                                document.getElementById('no-data').classList.add('visuallyhidden');
                                (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ice_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
                            } else {
                                ev_loaded = false;
                                stepOneNext.classList.add('disabled');
                                document.getElementById('no-data').classList.remove('visuallyhidden');
                            }
                        }, 1000);

                        let compareButton = document.querySelector('button[data-compare]');
                        if (compareButton) {
                            compareButton.dataset.compare = data.car.id;
                            compareButton.dataset.name = data.car.model_name;
                            compareButton.setAttribute('title', `Compare ${data.car.model_name} deal`);
                            compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/lcvgroup/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
                            compareButton.dataset.compareAdded = 'false';
                            let cookie = Cookies.get('compare_list');
                            if (cookie) {
                                let cookie_obj = JSON.parse(cookie);
                                if (cookie_obj[compareButton.dataset.compare] !== undefined) {
                                    compareButton.innerHTML = `<svg width="9.8" height="9.8"><use xlink:href="/themes/lcvgroup/img/minus.svg#minus"></use></svg>&nbsp;Remove`;
                                    compareButton.dataset.compareAdded = 'true';
                                }
                            }
                        }

                        document.querySelectorAll('.step-four-derivative').forEach(v => { v.innerHTML = derivativeField.options[derivativeField.selectedIndex].text });
                    } else {
                        comparable_type = data.car.fuel_type;
                        if (comparable_type === 'Electric') {
                            setTimeout(() => {
                                ice_loaded = false;
                                stepOneNext.classList.add('disabled');
                                document.getElementById('no-ice-two').classList.remove('visuallyhidden');
                            }, 500);
                        } else {
                            // comparable_nox = ((getCapTechnicalData('Emissions - ICE', 'NOx') != null && isNaN(getCapTechnicalData('Emissions - ICE', 'NOx') != 'Not Available'))) ? 'Not Available': getCapTechnicalData('Emissions - ICE', 'NOx').value + 'mg';
                            comparable_img_url = data.car.main_img;
                            comparable_co2 = (data.car.co2) ? data.car.co2 : 0;
                            comparable_mpg = (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra);
                            if (comparable_type === 'Petrol') {
                                comparable_london = (data.car.tax_band.london != null) ? data.car.tax_band.london : 0;
                                comparable_ulez = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? 12.50 : 0) : 0;
                            } else if (comparable_type === 'Diesel') {
                                comparable_london = (data.car.tax_band.london != null) ? data.car.tax_band.london : 0;
                                comparable_ulez = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? 12.50 : 0) : 0;
                            } else {
                                comparable_london = (data.car.tax_band.london != null) ? data.car.tax_band.london : 0;
                                comparable_ulez = 0;
                            }
                            setTimeout(() => {
                                if (comparable_mpg && comparable_mpg != '0.00' && comparable_co2) {
                                    ice_loaded = true;
                                    document.getElementById('no-data-two').classList.add('visuallyhidden');
                                    document.getElementById('no-ice-two').classList.add('visuallyhidden');
                                    (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ev_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
                                } else {
                                    ice_loaded = false;
                                    stepOneNext.classList.add('disabled');
                                    document.getElementById('no-data-two').classList.remove('visuallyhidden');
                                }
                            }, 1000);
                        }
                        document.querySelectorAll('.step-four-derivative-second').forEach(v => { v.innerHTML = derivativeFieldCompare.options[derivativeFieldCompare.selectedIndex].text });
                    }
                }).catch(function(err) {
                    console.error('Fetch Error -', err);
                });
            }

            // First Step
            makeField.addEventListener('change', () => {
                (makeField.value > 0) ? loadModelsCalc('car', makeField.value) : null;
                (modelField.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
                // derivativeField.classList.add('visuallyhidden')
                Array.prototype.slice.call(makeText, 0).forEach((value) => {
                    value.innerHTML = makeField.options[makeField.selectedIndex].text
                })
                let buttonUrl = '/cars/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
                document.querySelector('.view-range-button').setAttribute('href', buttonUrl)

                document.getElementById('no-data').classList.add('visuallyhidden')
                stepOneNext.classList.add('disabled')
            })
            modelField.addEventListener('change', () => {
                (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, true, true, false, false) : null; // inactive reversed

                Array.prototype.slice.call(modelText, 0).forEach((value) => {
                    value.innerHTML = modelField.options[modelField.selectedIndex].text
                })
                let buttonUrl = '/cars/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelField.options[modelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
                document.querySelector('.view-range-button').setAttribute('href', buttonUrl)
                // derivativeField.classList.remove('visuallyhidden')

                document.getElementById('no-data').classList.add('visuallyhidden')
                stepOneNext.classList.add('disabled')

                setTimeout(() => { (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null }, 500);
            })
            derivativeField.addEventListener('change', () => {
                stepOneNext.classList.add('disabled');
                document.getElementById('no-data').classList.add('visuallyhidden');
                (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null;
            })

            // Second Step
            makeFieldCompare.addEventListener('change', () => {
                (makeFieldCompare.value > 0) ? loadModelsCalc('car', makeFieldCompare.value, false, false, true) : null;
                (modelFieldCompare.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
                // derivativeFieldCompare.classList.add('visuallyhidden')
                document.querySelector('.step-four-make-second').innerHTML = makeFieldCompare.options[makeFieldCompare.selectedIndex].text;
                let buttonUrlSecond = '/cars/' + makeFieldCompare.options[makeFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase();
                document.querySelector('.view-range-button-second').setAttribute('href', buttonUrlSecond);
                document.getElementById('no-data-two').classList.add('visuallyhidden')
                stepOneNext.classList.add('disabled')
            })
            modelFieldCompare.addEventListener('change', () => {
                (modelFieldCompare.value > 0) ? loadDerivativeCalc('car', modelFieldCompare.value, true, false, true, true, true) : null;
                document.querySelector('.step-four-model-second').innerHTML = modelFieldCompare.options[modelFieldCompare.selectedIndex].text;

                let buttonUrlSecond = '/cars/' + makeFieldCompare.options[makeFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelFieldCompare.options[modelFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
                document.querySelector('.view-range-button-second').setAttribute('href', buttonUrlSecond)

                // derivativeFieldCompare.classList.remove('visuallyhidden')

                document.getElementById('no-data-two').classList.add('visuallyhidden')
                stepOneNext.classList.add('disabled')

                setTimeout(() => { (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null }, 500);
            })
            derivativeFieldCompare.addEventListener('change', () => {
                stepOneNext.classList.add('disabled');
                document.getElementById('no-data-two').classList.add('visuallyhidden');
                (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null;
            })

            // Third Step
            milesField.addEventListener('input', () => {
                (milesField.value >= milesField.getAttribute('min') && milesField.value <= milesField.getAttribute('max')) ? stepTwoNext.classList.remove('disabled') : stepTwoNext.classList.add('disabled')
            })
            // document.querySelector('#route-button-auto').addEventListener('click', (e) => {
            //   document.querySelector('#route-button-auto').classList.remove('button-outline')
            //   document.querySelector('#route-button-manual').classList.add('button-outline')
            //   document.querySelector('.route-auto').classList.remove('visuallyhidden')
            //   document.querySelector('.route-manual').classList.add('visuallyhidden')
            // })
            // document.querySelector('#route-button-manual').addEventListener('click', (e) => {
            //   document.querySelector('#route-button-auto').classList.add('button-outline')
            //   document.querySelector('#route-button-manual').classList.remove('button-outline')
            //   document.querySelector('.route-auto').classList.add('visuallyhidden')
            //   document.querySelector('.route-manual').classList.remove('visuallyhidden')
            // })

            // Fourth Step
            document.querySelector('#electric-difference').addEventListener('change', evt => {
                electricityCost = parseInt(document.querySelector('#average-data').dataset.averageElectricity) + parseInt(evt.target.value);
                document.querySelector('#average-data').dataset.averageElectricity = electricityCost;
            })
            document.querySelector('#petrol-difference').addEventListener('change', evt => {
                petrolCost = parseInt(document.querySelector('#average-data').dataset.averagePetrol) + parseInt(evt.target.value);
                document.querySelector('#average-data').dataset.averagePetrol = petrolCost;
            })
            document.querySelector('#diesel-difference').addEventListener('change', evt => {
                dieselCost = parseInt(document.querySelector('#average-data').dataset.averageDiesel) + parseInt(evt.target.value);
                document.querySelector('#average-data').dataset.averageDiesel = dieselCost;
            })

            // electricityField.addEventListener('input', () => {
            //   if(electricityField.value > 0 && electricityField.value <= 50){
            //     document.querySelector('#step-three-next').classList.remove('disabled')
            //   } else {
            //     document.querySelector('#step-three-next').classList.add('disabled')
            //   }
            // })
            // document.querySelector('#electricity-cost-button-auto').addEventListener('click', (e) => {
            // document.querySelector('#electricity-cost-button-auto').classList.remove('button-outline')
            // document.querySelector('#electricity-cost-button-manual').classList.add('button-outline')
            // document.querySelector('#electricity-cost-average').classList.remove('visuallyhidden')
            // electricityField.classList.add('visuallyhidden')
            // electricityLabel.classList.add('visuallyhidden')
            // electricityField.value = document.querySelector('#electricity-cost').getAttribute('data-average')
            // electricityField.dispatchEvent(new Event('input'))
            // (charger_rate == '150') ? averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity-ultra') : ( (charger_rate == '50') ? averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity-rapid') : averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity') );
            // document.querySelector('#electricity-cost').setAttribute('data-average', averageValue);
            // electricityField.value = averageValue
            // electricityField.dispatchEvent(new Event('input'))
            // })

            // document.querySelector('#electricity-cost-button-manual').addEventListener('click', (e) => {
            //   document.querySelector('#electricity-cost-button-auto').classList.add('button-outline')
            //   document.querySelector('#electricity-cost-button-manual').classList.remove('button-outline')
            //   document.querySelector('#electricity-cost-average').classList.add('visuallyhidden')
            //   electricityField.classList.remove('visuallyhidden')
            //   electricityLabel.classList.remove('visuallyhidden')
            //   electricityField.dispatchEvent(new Event('input'))
            // })

            // Reset Form
            function resetForm() {
                let compareButton = document.querySelector('button[data-compare]');
                if (compareButton) {
                    compareButton.dataset.compare = '';
                    compareButton.dataset.name = '';
                    compareButton.setAttribute('title', `Compare deal`);
                    compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/lcvgroup/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
                    compareButton.dataset.compareAdded = 'false';
                }

                // document.querySelector('#progress').value = 1;
                // document.querySelector('#progress-text').innerHTML = '0';

                document.getElementById('car-image').setAttribute('src', '/themes/lcvgroup/img/placeholder-sm.webp');
                document.getElementById("journey-calculator-form").reset();
                // derivativeField.classList.add('visuallyhidden')
                // derivativeFieldCompare.classList.add('visuallyhidden')
                document.querySelectorAll('.journey-calculator-form > .step').forEach((value) => {
                    value.classList.remove('active')
                    value.classList.contains('step-zero') ? value.classList.add('active') : null;
                })
                document.querySelector('#step-one-next').classList.add('disabled');
                document.querySelector('#step-two-next').classList.add('disabled');
                document.getElementById('journey-calculator-route-text').innerText = '';
            }
            setTimeout(resetForm, 500);
            document.querySelectorAll('.start-again').forEach((value) => {
                value.addEventListener('click', resetForm)
            })

            // Calculate
            document.querySelector('#step-three-next').addEventListener('click', (e) => {
                const arrowRed = `<svg xmlns="http://www.w3.org/2000/svg" width="12.732" height="14.461" viewBox="0 0 12.732 14.461" class="arrow-red"><g id="Group_7590" data-name="Group 7590" transform="translate(-410.534 -4.77)"><path id="Path_10214" data-name="Path 10214" d="M2780.589,936.836l4.6,4.961,4.6-4.961" transform="translate(3202.088 947.816) rotate(180)" fill="none" stroke="#de5151" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"/><line id="Line_23" data-name="Line 23" y1="11" transform="translate(416.926 17.98) rotate(180)" fill="none" stroke="#de5151" stroke-linecap="round" stroke-width="2.5"/></g></svg>`;
                const arrowGreen = `<svg xmlns="http://www.w3.org/2000/svg" width="12.732" height="14.461" viewBox="0 0 12.732 14.461" class="arrow-green"><g id="Group_7590" data-name="Group 7590" transform="translate(423.266 19.23) rotate(180)"><path id="Path_10214" data-name="Path 10214" d="M2780.589,936.836l4.6,4.961,4.6-4.961" transform="translate(3202.088 947.816) rotate(180)" fill="none" stroke="#3de184" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"/><line id="Line_23" data-name="Line 23" y1="11" transform="translate(416.926 17.98) rotate(180)" fill="none" stroke="#3de184" stroke-linecap="round" stroke-width="2.5"/></g></svg>`;

                let journey_frequency = parseInt(document.querySelector('input[name="frequency"]:checked').value);
                // let london_frequency = parseInt(document.querySelector('input[name="london"]:checked').value);
                // let ulez_frequency = parseInt(document.querySelector('input[name="ulez"]:checked').value);
                let pence_per_kwh = electricityCost;
                journey_distance = parseInt(milesField.value);

                // First Car
                document.getElementById('car-image').setAttribute('onerror', `this.src="${img_url}"`);
                img_url.includes('/std/') ? img_url = img_url.replace('/std/', '/big/') : null;
                document.getElementById('car-image').setAttribute('src', img_url);
                document.getElementById('summary-co2').innerHTML = parseInt(co2).toFixed(0) + 'g/km';
                // document.getElementById('summary-nox').innerText = nox;

                let indicative_fuel_cost = indicativeCost('Electric', null, electric_range, battery_capacity, pence_per_kwh);
                let comparable_indicative_fuel_cost = indicativeCost(comparable_type, comparable_mpg, false, false, pence_per_kwh);
                let evArrow = '';
                let nonEvArrow = '';
                if (indicative_fuel_cost > comparable_indicative_fuel_cost) {
                    evArrow = arrowRed;
                    nonEvArrow = arrowGreen;
                } else if (indicative_fuel_cost < comparable_indicative_fuel_cost) {
                    evArrow = arrowGreen;
                    nonEvArrow = arrowRed;
                }

                document.getElementById('summary-per-mile').innerHTML = parseFloat(indicative_fuel_cost).toFixed(1) + 'p' + evArrow;

                journey_cost = (journey_distance * indicative_fuel_cost) / 100; // journey cost (pound)
                document.getElementById('summary-journey').innerHTML = '£' + numberWithCommas(journey_cost.toFixed(2)) + evArrow;

                annual_journey_cost = journey_frequency * journey_cost;
                document.getElementById('summary-weekly').innerHTML = '£' + numberWithCommas((annual_journey_cost/52.14).toFixed(2)) + evArrow;
                document.getElementById('summary-monthly').innerHTML = '£' + numberWithCommas((annual_journey_cost/12).toFixed(2)) + evArrow;

                // Second Car
                document.getElementById('car-image-second').setAttribute('onerror', `this.src="${comparable_img_url}"`);
                comparable_img_url.includes('/std/') ? comparable_img_url = comparable_img_url.replace('/std/', '/big/') : null;
                document.getElementById('car-image-second').setAttribute('src', comparable_img_url);
                document.getElementById('summary-co2-second').innerHTML = parseInt(comparable_co2).toFixed(0) + 'g/km';
                // document.getElementById('summary-nox-second').innerText = comparable_nox;

                document.getElementById('summary-per-mile-second').innerHTML = parseFloat(comparable_indicative_fuel_cost).toFixed(1) + 'p' + nonEvArrow;

                comparable_journey_cost = (journey_distance * comparable_indicative_fuel_cost) / 100; // journey cost (pound)
                document.getElementById('summary-journey-second').innerHTML = '£' + numberWithCommas(comparable_journey_cost.toFixed(2)) + nonEvArrow;

                comparable_annual_journey_cost = journey_frequency * comparable_journey_cost;
                document.getElementById('summary-weekly-second').innerHTML = '£' + numberWithCommas((comparable_annual_journey_cost/52.14).toFixed(2)) + nonEvArrow;
                document.getElementById('summary-monthly-second').innerHTML = '£' + numberWithCommas((comparable_annual_journey_cost/12).toFixed(2)) + nonEvArrow;

                document.querySelector('#summary-total-three').innerHTML = '£' + numberWithCommas((journey_cost*3).toFixed(2)) + evArrow;
                document.querySelector('#summary-total-three-second').innerHTML = '£' + numberWithCommas((comparable_journey_cost*3).toFixed(2)) + nonEvArrow;
                document.querySelector('#summary-total-five').innerHTML = '£' + numberWithCommas((journey_cost*5).toFixed(2)) + evArrow;
                document.querySelector('#summary-total-five-second').innerHTML = '£' + numberWithCommas((comparable_journey_cost*5).toFixed(2)) + nonEvArrow;

                // document.getElementById('summary-london-daily-second').innerText = '£' + numberWithCommas(((london_frequency == 0) ? 0 : comparable_london).toFixed(2));
                // document.getElementById('summary-ulez-daily-second').innerText = '£' + numberWithCommas(((ulez_frequency == 0) ? 0 : comparable_ulez).toFixed(2));
                // document.getElementById('summary-london-annual-second').innerText = '£' + numberWithCommas((london_frequency * comparable_london).toFixed(2));
                // document.getElementById('summary-ulez-annual-second').innerText = '£' + numberWithCommas((ulez_frequency * comparable_ulez).toFixed(2));
                // let comparable_journey_cost = (journey_distance * comparable_indicative_cost) / 100; // journey cost (pound)
                // let comparable_annual_journey_cost = journey_frequency * comparable_journey_cost;
                // let comparable_three_year_saving = (comparable_annual_journey_cost - annual_journey_cost) * 3;
                // document.getElementById('summary-estimated-saving').innerText = '£' + comparable_three_year_saving.toFixed(0)

                // let total_journey_saving = ((comparable_journey_cost - journey_cost) + ((london_frequency == 0) ? 0 : comparable_london) + ((ulez_frequency == 0) ? 0 : comparable_ulez));
                // let total_annual_saving = (total_journey_saving * journey_frequency);
                // let total_co2_saving = numberWithCommas((comparable_co2 * journey_frequency).toFixed(0)) + 'g/km';
                // let total_three_year_saving = (((comparable_journey_cost - journey_cost) * journey_frequency) * 3);

                // document.getElementById('summary-savings-total').innerText = '£' + numberWithCommas(total_journey_saving.toFixed(2));
                // document.getElementById('summary-savings-annual').innerText = '£' + numberWithCommas(total_annual_saving.toFixed(2));
                // document.getElementById('summary-savings-co2').innerText = total_co2_saving;
                // document.getElementById('summary-estimated-saving').innerText = '£' + total_three_year_saving.toFixed(2);

                equalHeight(document.querySelector('.journey-calculator-table > .journey-calculator-column:first-of-type > .journey-calculator-header'), document.querySelector('.journey-calculator-table > .journey-calculator-column:last-of-type > .journey-calculator-header'))
                let left = document.querySelectorAll('.journey-calculator-table > .journey-calculator-column:first-of-type > .journey-calculator-body > div > p');
                let right = document.querySelectorAll('.journey-calculator-table > .journey-calculator-column:last-of-type > .journey-calculator-body > div > p');
                for (let i = 0; i < left.length; i++){ equalHeight(left[i], right[i]) }
            })
            window.addEventListener('resize', function(event) {
                equalHeight(document.querySelector('.journey-calculator-table > .journey-calculator-column:first-of-type > .journey-calculator-header'), document.querySelector('.journey-calculator-table > .journey-calculator-column:last-of-type > .journey-calculator-header'))
                let left = document.querySelectorAll('.journey-calculator-table > .journey-calculator-column:first-of-type > .journey-calculator-body > div > p');
                let right = document.querySelectorAll('.journey-calculator-table > .journey-calculator-column:last-of-type > .journey-calculator-body > div > p');
                for (let i = 0; i < left.length; i++){ equalHeight(left[i], right[i]) }
            }, true);
        }
        // Tax Calculator
        if (document.querySelector('.tools-main>div').classList.contains('tax-calculator')) {
            loadManufacturersCalc('car', true);
            let makeField = document.querySelector('select[name=calculator-make]')
            let modelField = document.querySelector('select[name=calculator-model]')
            let derivativeField = document.querySelector('select[name=calculator-derivative]')
            let makeFieldCompare = document.querySelector('select[name=calculator-make-compare]')
            let modelFieldCompare = document.querySelector('select[name=calculator-model-compare]')
            let derivativeFieldCompare = document.querySelector('select[name=calculator-derivative-compare]')
            let stepOneNext = document.querySelector('#step-one-next')
            let stepTwoNext = document.querySelector('#step-two-next')
            let tax_band = 20;
            let ev_loaded, ice_loaded = false;
            let fuel_type, img_url, p11d, bik1, bik2, bik3, indicative_fuel_cost, co2;
            let comparable_value, comparable_type, comparable_img_url, comparable_mpg, comparable_p11d, comparable_bik1, comparable_bik2, comparable_bik3, comparable_indicative_fuel_cost, comparable_co2;

            function loadVehicle($derivative, $ev = false) {
                let url = '/api/car/' + $derivative;
                fetch(url).then(function(response) {
                    if (response.status !== 200) {
                        console.warn('Looks like there was a problem. Status Code: ' + response.status);
                        return;
                    }
                    return response.json();
                }).then(function(data) {
                    if ($ev) {
                        co2 = (data.car.co2) ? data.car.co2 : null;
                        bik1 = (data.car.tax) ? (data.car.tax.Year1 ? data.car.tax.Year1 : null) : null;
                        bik2 = (data.car.tax) ? (data.car.tax.Year2 ? data.car.tax.Year2 : null) : null;
                        bik3 = (data.car.tax) ? (data.car.tax.Year3 ? data.car.tax.Year3 : null) : null;
                        p11d = (data.car.base_price) ? data.car.base_price : null;
                        img_url = (data.car.main_img) ? data.car.main_img : null;
                        fuel_type = (data.car.fuel_type) ? data.car.fuel_type : null;
                        // ved_first = data.car.tax_band.rate;
                        // ved_annual = data.car.tax_band.second_rate;
                        indicative_fuel_cost = indicativeCost(fuel_type, null, (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
                        setTimeout(() => {
                            if (co2 && img_url && fuel_type && bik1 != null && data.car.electric_range && data.car.battery_capacity) {
                                ev_loaded = true;
                                document.getElementById('no-data').classList.add('visuallyhidden');
                                (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ice_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
                            } else {
                                ev_loaded = false;
                                document.getElementById('no-data').classList.remove('visuallyhidden');
                            }
                        }, 1000);

                        let compareButton = document.querySelector('button[data-compare]');
                        if (compareButton) {
                            compareButton.dataset.compare = data.car.id;
                            compareButton.dataset.name = data.car.model_name;
                            compareButton.setAttribute('title', `Compare ${data.car.model_name} deal`);
                            compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/lcvgroup/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
                            compareButton.dataset.compareAdded = 'false';
                            let cookie = Cookies.get('compare_list');
                            if (cookie) {
                                let cookie_obj = JSON.parse(cookie);
                                if (cookie_obj[compareButton.dataset.compare] !== undefined) {
                                    compareButton.innerHTML = `<svg width="9.8" height="9.8"><use xlink:href="/themes/lcvgroup/img/minus.svg#minus"></use></svg>&nbsp;Remove`;
                                    compareButton.dataset.compareAdded = 'true';
                                }
                            }
                        }
                        document.querySelectorAll('.step-four-derivative').forEach(v => { v.innerHTML = derivativeField.options[derivativeField.selectedIndex].text });
                    } else {
                        comparable_type = data.car.fuel_type;
                        if (comparable_type === 'Electric') {
                            setTimeout(() => {
                                ice_loaded = false;
                                stepOneNext.classList.add('disabled');
                                document.getElementById('no-ice-two').classList.remove('visuallyhidden');
                            }, 500);
                        } else {
                            comparable_co2 = data.car.co2;
                            comparable_img_url = data.car.main_img;
                            comparable_p11d = data.car.base_price;
                            // comparable_ved_first = data.car.tax_band.rate;
                            // comparable_ved_annual = data.car.tax_band.second_rate;
                            comparable_value = data.car.base_price;
                            comparable_bik1 = (data.car.tax) ? (data.car.tax.Year1 ? data.car.tax.Year1 : null) : null;
                            comparable_bik2 = (data.car.tax) ? (data.car.tax.Year2 ? data.car.tax.Year2 : null) : null;
                            comparable_bik3 = (data.car.tax) ? (data.car.tax.Year3 ? data.car.tax.Year3 : null) : null;
                            comparable_mpg = (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra);
                            comparable_indicative_fuel_cost = indicativeCost(comparable_type, comparable_mpg, null, null);
                            setTimeout(() => {
                                if (comparable_value && comparable_bik1 != null && comparable_mpg && comparable_co2) {
                                    ice_loaded = true;
                                    document.getElementById('no-data-two').classList.add('visuallyhidden');
                                    document.getElementById('no-ice-two').classList.add('visuallyhidden');
                                    (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ev_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
                                } else {
                                    ice_loaded = false;
                                    document.getElementById('no-data-two').classList.remove('visuallyhidden');
                                }
                            }, 1000);
                            document.querySelectorAll('.step-four-derivative-second').forEach(v => { v.innerHTML = derivativeFieldCompare.options[derivativeFieldCompare.selectedIndex].text });
                        }
                    }
                }).catch(function(err) {
                    console.error('Fetch Error -', err);
                });
            }

            // First Step
            makeField.addEventListener('change', () => {
                (makeField.value > 0) ? loadModelsCalc('car', makeField.value) : null;
                (modelField.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
                Array.prototype.slice.call(document.querySelectorAll('.step-three-make'), 0).forEach((value) => {
                    value.innerHTML = makeField.options[makeField.selectedIndex].text
                })
                // derivativeField.classList.add('visuallyhidden')
                let buttonUrl = '/cars/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase();
                document.querySelector('.view-range-button').setAttribute('href', buttonUrl)
                document.querySelector('.view-range-button span').innerHTML = makeField.options[makeField.selectedIndex].text;
            })
            modelField.addEventListener('change', () => {
                (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, true, true, true, false) : null; // inactive reversed
                Array.prototype.slice.call(document.querySelectorAll('.step-three-model'), 0).forEach((value) => {
                    value.innerHTML = modelField.options[modelField.selectedIndex].text
                })
                let buttonUrl = '/cars/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelField.options[modelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
                document.querySelector('.view-range-button').setAttribute('href', buttonUrl)
                document.querySelector('.view-range-button span').innerHTML = makeField.options[makeField.selectedIndex].text + ' ' + modelField.options[modelField.selectedIndex].text;
                // derivativeField.classList.remove('visuallyhidden')

                document.getElementById('no-data').classList.add('visuallyhidden')
                stepOneNext.classList.add('disabled')

                setTimeout(() => { (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null }, 800);
            })
            derivativeField.addEventListener('change', () => {
                stepOneNext.classList.add('disabled');
                document.getElementById('no-data').classList.add('visuallyhidden');
                (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null;
            })

            // Second Step
            makeFieldCompare.addEventListener('change', () => {
                (makeFieldCompare.value > 0) ? loadModelsCalc('car', makeFieldCompare.value, false, false, true) : null;
                (modelFieldCompare.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
                // derivativeFieldCompare.classList.add('visuallyhidden')
                // let buttonUrlSecond = '/cars/' + makeFieldCompare.options[makeFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase();
                // document.querySelector('.view-range-button-second').setAttribute('href', buttonUrlSecond)
                document.querySelectorAll('.step-four-make-second').forEach(v => { v.innerHTML = makeFieldCompare.options[makeFieldCompare.selectedIndex].text });
                document.getElementById('no-data-two').classList.add('visuallyhidden')
                stepOneNext.classList.add('disabled')
            })
            modelFieldCompare.addEventListener('change', () => {
                (modelFieldCompare.value > 0) ? loadDerivativeCalc('car', modelFieldCompare.value, true, false, true, true, true) : null;
                document.querySelectorAll('.step-four-model-second').forEach(v => { v.innerHTML = modelFieldCompare.options[modelFieldCompare.selectedIndex].text });
                // let buttonUrlSecond = '/cars/' + makeFieldCompare.options[makeFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelFieldCompare.options[modelFieldCompare.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
                // document.querySelector('.view-range-button-second').setAttribute('href', buttonUrlSecond)
                // derivativeFieldCompare.classList.remove('visuallyhidden')

                document.getElementById('no-data-two').classList.add('visuallyhidden')
                stepOneNext.classList.add('disabled')

                setTimeout(() => { (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null }, 800);
            })
            derivativeFieldCompare.addEventListener('change', () => {
                stepOneNext.classList.add('disabled');
                document.getElementById('no-data-two').classList.add('visuallyhidden');
                (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null;
            })

            // Third Step - Company Switch
            // document.querySelectorAll('input[name=company]').forEach((value) => {
            //   value.addEventListener('change', (e) => {
            //     (e.target.value === 'yes') ? company_car = true : company_car = false;
            //     (e.target.value === 'yes') ? tax_band = 20 : tax_band = 0;
            //     (e.target.value === 'yes') ? taxBand.classList.remove('visuallyhidden') : taxBand.classList.add('visuallyhidden');
            //     (e.target.value === 'yes') ? stepThreeNext.classList.add('disabled') : stepThreeNext.classList.remove('disabled')
            //   })
            // })

            // Third Step - Tax Band Switch
            document.querySelectorAll('[name=calculator-tax-band]').forEach(v => {
                v.addEventListener('change', (e) => {
                    stepTwoNext.classList.remove('disabled');
                    // (e.target.value > 0) ? stepTwoNext.classList.remove('disabled') : stepTwoNext.classList.add('disabled');
                    (e.target.value === '20') ? tax_band = 20 : tax_band = 40;
                    document.querySelectorAll('.tax-payable').forEach((value => {value.innerHTML = e.target.value}))
                })
            })

            // Fourth Step - Frequency Switch
            // document.querySelectorAll('input[name=frequency]').forEach((value) => {
            //   value.addEventListener('change', (e) => {
            //     congestion_charge_freq = e.target.value
            //   })
            // })

            function calculateBIK($p11d, $bik_rate) {
                return ($p11d * ($bik_rate / 100));
            }
            function calculateTAX($p11d, $bik_rate, $tax_rate = 0) {
                return ($p11d * ($bik_rate / 100)) * ($tax_rate / 100);
            }
            // function calculateNIC($p11d, $bik_rate, $nic_rate = 13.80) {
            //   return ($p11d * ($bik_rate / 100)) * ($nic_rate / 100);
            // }

            // Calculate
            stepTwoNext.addEventListener('click', (e) => {
                // let ved_total = (ved_first + (2 * ved_annual));
                let bik_total = (calculateBIK(p11d, bik1, tax_band) + calculateBIK(p11d, bik2, tax_band) + calculateBIK(p11d, bik3, tax_band)).toFixed(0);
                let tax_total = (calculateTAX(p11d, bik1, tax_band) + calculateTAX(p11d, bik2, tax_band) + calculateTAX(p11d, bik3, tax_band)).toFixed(0);

                document.getElementById('car-image').setAttribute('onerror', `this.src="${img_url}"`);
                img_url.includes('/std/') ? img_url = img_url.replace('/std/', '/big/') : null;
                document.getElementById('car-image').setAttribute('src', img_url)
                document.getElementById('summary-type').innerText = fuel_type
                // document.getElementById('summary-ved-first').innerText = '£' + ved_first
                // document.getElementById('summary-ved-annual').innerText = '£' + ved_annual
                // document.getElementById('summary-ved-total').innerText = '£' + ved_total
                document.getElementById('summary-p11d').innerText = '£' + numberWithCommas((p11d))
                document.getElementById('summary-co2').innerText = parseInt(co2).toFixed(0) + 'g/km'
                document.getElementById('summary-bik1').innerText = '£' + numberWithCommas((calculateBIK(p11d, bik1)).toFixed(0))
                document.getElementById('summary-bik2').innerText = '£' + numberWithCommas((calculateBIK(p11d, bik2)).toFixed(0))
                document.getElementById('summary-bik3').innerText = '£' + numberWithCommas((calculateBIK(p11d, bik3)).toFixed(0))
                document.getElementById('summary-bik1tax').innerText = '£' + numberWithCommas((calculateTAX(p11d, bik1, tax_band)).toFixed(0))
                document.getElementById('summary-bik2tax').innerText = '£' + numberWithCommas((calculateTAX(p11d, bik2, tax_band)).toFixed(0))
                document.getElementById('summary-bik3tax').innerText = '£' + numberWithCommas((calculateTAX(p11d, bik3, tax_band)).toFixed(0))
                document.getElementById('summary-bik1rate').innerText = (bik1) + '%'
                document.getElementById('summary-bik2rate').innerText = (bik2) + '%'
                document.getElementById('summary-bik3rate').innerText = (bik3) + '%'
                document.getElementById('summary-bik4').innerText = '£' + numberWithCommas(bik_total)
                document.getElementById('summary-fuel').innerText = (indicative_fuel_cost) + 'p/mile'

                // let comparable_ved_total = (comparable_ved_first + (2 * comparable_ved_annual));
                let comparable_bik_total = (calculateBIK(comparable_p11d, comparable_bik1, tax_band) + calculateBIK(comparable_p11d, comparable_bik2, tax_band) + calculateBIK(comparable_p11d, comparable_bik3, tax_band)).toFixed(0);
                let comparable_tax_total = (calculateTAX(comparable_p11d, comparable_bik1, tax_band) + calculateTAX(comparable_p11d, comparable_bik2, tax_band) + calculateTAX(comparable_p11d, comparable_bik3, tax_band)).toFixed(0);

                document.getElementById('car-image-second').setAttribute('onerror', `this.src="${comparable_img_url}"`);
                comparable_img_url.includes('/std/') ? comparable_img_url = comparable_img_url.replace('/std/', '/big/') : null;
                document.getElementById('car-image-second').setAttribute('src', comparable_img_url);
                document.getElementById('summary-type-second').innerText = comparable_type
                // document.getElementById('summary-ved-first-second').innerText = '£' + comparable_ved_first
                // document.getElementById('summary-ved-annual-second').innerText = '£' + comparable_ved_annual
                // document.getElementById('summary-ved-total-second').innerText = '£' + comparable_ved_total
                document.getElementById('summary-p11d-second').innerText = '£' + numberWithCommas((comparable_p11d))
                document.getElementById('summary-co2-second').innerText = parseInt(comparable_co2).toFixed(0) + 'g/km'
                document.getElementById('summary-bik1-second').innerText = '£' + numberWithCommas((calculateBIK(comparable_p11d, comparable_bik1)).toFixed(0))
                document.getElementById('summary-bik2-second').innerText = '£' + numberWithCommas((calculateBIK(comparable_p11d, comparable_bik2)).toFixed(0))
                document.getElementById('summary-bik3-second').innerText = '£' + numberWithCommas((calculateBIK(comparable_p11d, comparable_bik3)).toFixed(0))
                document.getElementById('summary-bik1tax-second').innerText = '£' + numberWithCommas((calculateTAX(comparable_p11d, comparable_bik1, tax_band)).toFixed(0))
                document.getElementById('summary-bik2tax-second').innerText = '£' + numberWithCommas((calculateTAX(comparable_p11d, comparable_bik2, tax_band)).toFixed(0))
                document.getElementById('summary-bik3tax-second').innerText = '£' + numberWithCommas((calculateTAX(comparable_p11d, comparable_bik3, tax_band)).toFixed(0))
                document.getElementById('summary-bik1rate-second').innerText = (comparable_bik1) + '%'
                document.getElementById('summary-bik2rate-second').innerText = (comparable_bik2) + '%'
                document.getElementById('summary-bik3rate-second').innerText = (comparable_bik3) + '%'
                document.getElementById('summary-bik4-second').innerText = '£' + numberWithCommas(comparable_bik_total)
                document.getElementById('summary-fuel-second').innerText = (comparable_indicative_fuel_cost) + 'p/mile'

                // document.getElementById('summary-total-tax').innerText = '£' + numberWithCommas((tax_total));
                // document.getElementById('summary-total-tax-second').innerText = '£' + numberWithCommas((comparable_tax_total));
                document.getElementById('summary-total-savings').innerText = '£' + numberWithCommas(((parseFloat(comparable_tax_total)) - (parseFloat(tax_total))));

                // let comparable_tax_amount;
                // let comparable_bik_rate = (comparable_bik / 100) * comparable_value;
                // (tax_band === 0) ? comparable_tax_amount = comparable_bik_rate : comparable_tax_amount = (tax_band / 100) * comparable_bik_rate;
                // document.getElementById('summary-total-tax').innerText = '£' + (ved_total + ((fuel_type === 'Electric') ? 0 : ((congestion_charge * congestion_charge_freq) * 3)))
                // document.getElementById('summary-total-savings').innerText = '£' + ((fuel_type !== 'Electric') ? 0 : (((parseFloat(congestion_charge) * parseFloat(congestion_charge_freq)) + parseFloat(comparable_tax_amount)) * 3)).toFixed(0)

                equalHeight(document.querySelector('.tax-calculator-table > .tax-calculator-column:first-of-type > .tax-calculator-header'), document.querySelector('.tax-calculator-table > .tax-calculator-column:last-of-type > .tax-calculator-header'))
                let left = document.querySelectorAll('.tax-calculator-table > .tax-calculator-column:first-of-type > .tax-calculator-body > div > p');
                let right = document.querySelectorAll('.tax-calculator-table > .tax-calculator-column:last-of-type > .tax-calculator-body > div > p');
                for (let i = 0; i < left.length; i++){ equalHeight(left[i], right[i]) }
            })

            // Reset Form
            function resetForm() {
                let compareButton = document.querySelector('button[data-compare]');
                if (compareButton) {
                    compareButton.dataset.compare = '';
                    compareButton.dataset.name = '';
                    compareButton.setAttribute('title', `Compare deal`);
                    compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/lcvgroup/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
                    compareButton.dataset.compareAdded = 'false';
                }

                // document.querySelector('#progress').value = 1;
                // document.querySelector('#progress-text').innerHTML = '0';

                document.querySelector('.view-range-button span').innerHTML = '';
                document.getElementById('car-image').setAttribute('src', '/themes/lcvgroup/img/placeholder-sm.webp');
                stepOneNext.classList.add('disabled')
                // derivativeField.classList.add('visuallyhidden')
                // derivativeFieldCompare.classList.add('visuallyhidden')
                document.getElementById("tax-calculator-form").reset()
                document.querySelectorAll('.tax-calculator-form > .step').forEach((value) => {
                    value.classList.remove('active')
                    value.classList.contains('step-zero') ? value.classList.add('active') : null
                })
                document.querySelector('#step-one-next').classList.add('disabled')
                document.querySelector('#step-two-next').classList.add('disabled')
                document.querySelector('#progress-bar').className = `progress-bar`;
            }
            setTimeout(resetForm, 500);
            document.querySelectorAll('.start-again').forEach((value) => {
                value.addEventListener('click', resetForm);
            })

            window.addEventListener('resize', function(event) {
                equalHeight(document.querySelector('.tax-calculator-table > .tax-calculator-column:first-of-type > .tax-calculator-header'), document.querySelector('.tax-calculator-table > .tax-calculator-column:last-of-type > .tax-calculator-header'))
                let left = document.querySelectorAll('.tax-calculator-table > .tax-calculator-column:first-of-type > .tax-calculator-body > div > p');
                let right = document.querySelectorAll('.tax-calculator-table > .tax-calculator-column:last-of-type > .tax-calculator-body > div > p');
                for (let i = 0; i < left.length; i++){ equalHeight(left[i], right[i]) }
            }, true);

        }
        // Charging Time & Cost Calculator
        if (document.querySelector('.tools-main>div').classList.contains('charging-calculator')) {
            loadManufacturersCalc('car', true);
            let makeField = document.querySelector('select[name=calculator-make]')
            let modelField = document.querySelector('select[name=calculator-model]')
            let derivativeField = document.querySelector('select[name=calculator-derivative]')
            let electricityField = document.querySelector('input[name=charging-calculator-electricity]')
            // let electricityLabel = document.querySelector('.electricity-cost-label')
            let rateSwitch = document.querySelectorAll('input[name=speed]')
            let stepOneNext = document.querySelector('#step-one-next')
            let slider = document.getElementById('chargePercentage');
            let output = document.getElementById('chargePercentageNumber');
            let button_url, electric_range, averageValue, charger_speed, charging_time, slow_kw, fast_kw, rapid_kw, ultra_kw, slow_time, fast_time, rapid_time, ultra_time, img_url, charger_rate, battery_capacity;

            function loadVehicle($derivative) {
                let url = '/api/car/' + $derivative;
                fetch(url).then(function(response) {
                    if (response.status !== 200) {
                        console.warn('Looks like there was a problem. Status Code: ' + response.status);
                        return;
                    }
                    return response.json();
                }).then(function(data) {
                    let getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
                    img_url = data.car.main_img;
                    battery_capacity = data.car.battery_capacity;
                    electric_range = (data.car.electric_range != null) ? data.car.electric_range : ((data.car.technical) ? ((getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)')) ? parseFloat(getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)').value) : null) : null);
                    // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow kW')) ? slow_kw = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow kW').value : slow_kw = null;
                    // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast kW')) ? fast_kw = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast kW').value : fast_kw = null;
                    // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow Time')) ? slow_time = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow Time').value : slow_time = null;
                    // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast Time')) ? fast_time = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast Time').value : fast_time = null;
                    // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid kW')) ? rapid_kw = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid kW').value : rapid_kw = null;
                    // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid Time')) ? rapid_time = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid Time').value : rapid_time = null;
                    slow_kw = 7;
                    fast_kw = 22;
                    rapid_kw = 60;
                    ultra_kw = 350;
                    slow_time = (battery_capacity / slow_kw)*60;
                    fast_time = (battery_capacity / fast_kw)*60;
                    rapid_time = (battery_capacity / rapid_kw)*60;
                    ultra_time = (battery_capacity / ultra_kw)*60;

                    setTimeout(() => {
                        if (electric_range && slow_kw && battery_capacity && slow_time) {
                            document.getElementById('car-image').setAttribute('onerror', `this.src="${img_url}"`);
                            img_url.includes('/std/') ? img_url = img_url.replace('/std/', '/big/') : null;
                            document.getElementById('car-image').setAttribute('src', img_url);
                            document.getElementById('no-data').classList.add('visuallyhidden');
                            document.getElementById('speed-slow').setAttribute('value', slow_kw);
                            document.querySelector('#speed-slow-label > span').innerText = slow_kw;
                            (derivativeField.childElementCount > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
                            // button_url = '/cars/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelField.options[modelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
                            button_url = data.car.full_url
                            document.querySelector('.view-range-button').setAttribute('href', button_url)
                            // document.querySelector('button[data-compare]').setAttribute('data-compare', data.car.id)

                            Array.prototype.slice.call(document.querySelectorAll('.step-four-make'), 0).forEach((value) => {
                                value.innerHTML = makeField.options[makeField.selectedIndex].text
                            })
                            Array.prototype.slice.call(document.querySelectorAll('.step-four-model'), 0).forEach((value) => {
                                value.innerHTML = modelField.options[modelField.selectedIndex].text
                            })

                            if (fast_kw && fast_time && parseFloat(fast_time) > 1 && parseFloat(fast_kw) > 1) {
                                document.getElementById('speed-fast-label').style.display = 'block';
                                document.getElementById('speed-fast').setAttribute('value', fast_kw);
                                document.querySelector('#speed-fast-label > span').innerText = fast_kw;
                            } else {
                                document.getElementById('speed-fast-label').style.display = 'none';
                            }
                            if (rapid_kw && rapid_time && parseFloat(rapid_time) > 1 && parseFloat(rapid_kw) > 1) {
                                document.getElementById('speed-rapid-label').style.display = 'block';
                                document.getElementById('speed-rapid').setAttribute('value', rapid_kw);
                                document.querySelector('#speed-rapid-label > span').innerText = rapid_kw;
                            } else {
                                document.getElementById('speed-rapid-label').style.display = 'none';
                            }
                        } else {
                            document.getElementById('no-data').classList.remove('visuallyhidden');
                        }
                    }, 1000);

                    let compareButton = document.querySelector('button[data-compare]');
                    if (compareButton) {
                        compareButton.dataset.compare = data.car.id;
                        compareButton.dataset.name = data.car.model_name;
                        compareButton.setAttribute('title', `Compare ${data.car.model_name} deal`);
                        compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/lcvgroup/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
                        compareButton.dataset.compareAdded = 'false';
                        let cookie = Cookies.get('compare_list');
                        if (cookie) {
                            let cookie_obj = JSON.parse(cookie);
                            if (cookie_obj[compareButton.dataset.compare] !== undefined) {
                                compareButton.innerHTML = `<svg width="9.8" height="9.8"><use xlink:href="/themes/lcvgroup/img/minus.svg#minus"></use></svg>&nbsp;Remove`;
                                compareButton.dataset.compareAdded = 'true';
                            }
                        }
                    }
                    document.querySelectorAll('.step-four-derivative').forEach(v => { v.innerHTML = derivativeField.options[derivativeField.selectedIndex].text });
                }).catch(function(err) {
                    console.error('Fetch Error -', err);
                });
            }

            makeField.addEventListener('change', () => {
                (makeField.value > 0) ? loadModelsCalc('car', makeField.value) : false;
                (modelField.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
                derivativeField.classList.add('visuallyhidden')

                document.getElementById('no-data').classList.add('visuallyhidden')
                stepOneNext.classList.add('disabled')
            })

            modelField.addEventListener('change', () => {
                (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, false, true, true, false) : false; // inactive reversed

                derivativeField.classList.remove('visuallyhidden')

                document.getElementById('no-data').classList.add('visuallyhidden')
                stepOneNext.classList.add('disabled')

                setTimeout(() => { (derivativeField.value > 0) ? loadVehicle(derivativeField.value) : false }, 500);
            })

            derivativeField.addEventListener('change', () => {
                stepOneNext.classList.add('disabled');
                document.getElementById('no-data').classList.add('visuallyhidden');
                (derivativeField.value > 0) ? loadVehicle(derivativeField.value) : false;
            })

            electricityField.addEventListener('input', () => {
                if(electricityField.value > 0 && electricityField.value <= 50){
                    document.querySelector('#step-three-next').classList.remove('disabled')
                } else {
                    document.querySelector('#step-three-next').classList.add('disabled')
                }
            })

            document.querySelector('#electricity-cost-button-auto').addEventListener('click', (e) => {
                // document.querySelector('#electricity-cost-button-auto').classList.remove('button-outline');
                // document.querySelector('#electricity-cost-button-manual').classList.add('button-outline');
                // document.querySelector('#electricity-cost-average').classList.remove('visuallyhidden');
                (charger_rate == '350') ? averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity-ultra') : ( (charger_rate == '60') ? averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity-rapid') : averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity') );
                // document.querySelector('#electricity-cost-average span').innerHTML = averageValue;
                document.querySelector('#electricity-cost').setAttribute('data-average', averageValue);
                // electricityField.classList.add('visuallyhidden')
                // electricityLabel.classList.add('visuallyhidden')
                electricityField.value = averageValue
                electricityField.dispatchEvent(new Event('input'))
            })

            // document.querySelector('#electricity-cost-button-manual').addEventListener('click', (e) => {
            //   document.querySelector('#electricity-cost-button-auto').classList.add('button-outline')
            //   document.querySelector('#electricity-cost-button-manual').classList.remove('button-outline')
            //   document.querySelector('#electricity-cost-average').classList.add('visuallyhidden')
            //   electricityField.classList.remove('visuallyhidden')
            //   electricityLabel.classList.remove('visuallyhidden')
            //   electricityField.dispatchEvent(new Event('input'))
            // })

            // Calculate
            function calculate($percentage, $charger_rate, $electricity_cost, $electric_range, $battery_capacity, $charging_time) {
                function percentage(num, per){ return (num/100)*per }
                let indicative_cost = indicativeCost('Electric', null, $electric_range, $battery_capacity, $electricity_cost);
                let charge_cost = (parseFloat(indicative_cost) * parseFloat(percentage($electric_range, $percentage)))/100;
                document.getElementById('summary-miles').innerText = parseFloat(percentage($electric_range, $percentage)).toFixed(2) + ' miles';
                document.getElementById('summary-estimate').innerText = parseFloat(indicative_cost).toFixed(1) + 'p';
                document.getElementById('summary-cost').innerText = '£' + numberWithCommas(charge_cost.toFixed(2));
                document.getElementById('summary-time').innerText = (parseFloat(percentage($charging_time, $percentage))/60 < 1) ? parseFloat(percentage($charging_time, $percentage)).toFixed(0) + 'min' : (parseFloat(percentage($charging_time, $percentage))/60).toFixed(1) + 'h';
                document.getElementById('summary-kwh').innerText = parseFloat(percentage($battery_capacity, $percentage)).toFixed(0) + 'kWh';
            }

            rateSwitch.forEach((value) => {
                value.addEventListener('change', (e) => {
                    charger_rate = e.target.value;
                    (e.target.dataset.speed === 'fast') ? charging_time = fast_time : ((e.target.dataset.speed === 'slow') ? charging_time = slow_time : charging_time = rapid_time);
                    document.querySelector('#step-two-next').classList.remove('disabled');
                })
            })

            document.querySelector('#step-three-next').addEventListener('click', (e) => {
                calculate(slider.value, charger_rate, electricityField.value, electric_range, battery_capacity, charging_time)
            })

            output.innerHTML = slider.value;
            slider.oninput = function() {
                output.innerHTML = this.value
                calculate(this.value, charger_rate, electricityField.value, electric_range, battery_capacity, charging_time)
            }

            // Reset Form
            function resetForm() {
                let compareButton = document.querySelector('button[data-compare]');
                if (compareButton) {
                    compareButton.dataset.compare = '';
                    compareButton.dataset.name = '';
                    compareButton.setAttribute('title', `Compare deal`);
                    compareButton.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/lcvgroup/img/plus.svg#plus"></use></svg>&nbsp;Compare`;
                    compareButton.dataset.compareAdded = 'false';
                }

                document.querySelector('#progress').value = 1;
                document.querySelector('#progress-text').innerHTML = '0';
                output.innerHTML = '80';

                document.getElementById('car-image').setAttribute('src', '/themes/lcvgroup/img/placeholder-sm.webp');
                document.getElementById("charging-calculator-form").reset();
                derivativeField.classList.add('visuallyhidden');
                document.querySelectorAll('.charging-calculator-form > .step').forEach((value) => {
                    value.classList.remove('active')
                    value.classList.contains('step-one') ? value.classList.add('active') : false;
                })
                document.querySelectorAll('.next-step').forEach((value) => { value.classList.add('disabled') })

                // document.querySelector('#electricity-cost-button-auto').classList.add('button-outline')
                // document.querySelector('#electricity-cost-button-manual').classList.remove('button-outline')
                // document.querySelector('#electricity-cost-average').classList.add('visuallyhidden')
                // electricityField.classList.remove('visuallyhidden')
                // electricityLabel.classList.remove('visuallyhidden')
            }
            setTimeout(resetForm, 500);
            document.querySelectorAll('.start-again').forEach((value) => {
                value.addEventListener('click', resetForm);
            })
        }
    }

    // Add To Compare - Car
    document.querySelectorAll('button[data-compare][data-type="car"]').forEach((value) => {
        value.addEventListener('click', (e) => {
            e.preventDefault();
            let cookie = Cookies.get('compare_list')
            if (cookie) {
                let cookie_obj = JSON.parse(cookie);
                if (cookie_obj[e.target.dataset.compare] === undefined) {
                    if (Object.keys(cookie_obj).length < 3) {
                        cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
                        let cookie_string = JSON.stringify(cookie_obj)
                        Cookies.set('compare_list', cookie_string)
                        e.target.innerHTML = `<svg width="11" height="11"><use xlink:href="/themes/lcvgroup/img/icons/compare-remove.svg#compare"></use></svg>`;
                        e.target.dataset.compareAdded = 'true';
                        alertify.confirm('Car Comparison')
                            .setting({
                                'title': 'Car Comparison',
                                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/tools/car-comparison" },
                                'onclose': comparisonCount
                            });
                    } else {
                        alertify.confirm('Car Comparison')
                            .setting({
                                'title': 'Car Comparison',
                                'message': `
                  <span class="semi-bold">Car comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                  </ul>
                `,
                                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/tools/car-comparison" },
                                'onclose': comparisonCount
                            });
                    }
                } else {
                    delete cookie_obj[e.target.dataset.compare];
                    (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
                    e.target.innerHTML = `<svg width="11" height="11"><use xlink:href="/themes/lcvgroup/img/icons/compare.svg#compare"></use></svg>`;
                    e.target.dataset.compareAdded = 'false';
                    alertify.confirm('Car Comparison')
                        .setting({
                            'title': 'Car Comparison',
                            'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
                            'labels': { ok: 'Go To Compare', cancel: 'Close' },
                            'onok': function(){ window.location.href = "/tools/car-comparison" },
                            'onclose': comparisonCount
                        });
                }
            } else {
                let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('compare_list', cookie_string)
                e.target.innerHTML = `<svg width="11" height="11"><use xlink:href="/themes/lcvgroup/img/icons/compare-remove.svg#compare"></use></svg>`;
                e.target.dataset.compareAdded = 'true';

                alertify.confirm('Car Comparison')
                    .setting({
                        'title': 'Car Comparison',
                        'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
                        'labels': { ok: 'Go To Compare', cancel: 'Close' },
                        'onok': function(){ window.location.href = "/tools/car-comparison" },
                        'onclose': comparisonCount
                    });
            }
        })
    })
    // Add To Compare - Van
    document.querySelectorAll('button[data-compare][data-type="van"]').forEach((value) => {
        value.addEventListener('click', (e) => {
            e.preventDefault();
            let cookie = Cookies.get('compare_list_vans')
            if (cookie) {
                let cookie_obj = JSON.parse(cookie);
                if (cookie_obj[e.target.dataset.compare] === undefined) {
                    if (Object.keys(cookie_obj).length < 3) {
                        cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
                        let cookie_string = JSON.stringify(cookie_obj)
                        Cookies.set('compare_list_vans', cookie_string)
                        e.target.innerHTML = `<svg width="11" height="11"><use xlink:href="/themes/lcvgroup/img/icons/compare-remove.svg#compare"></use></svg>`;
                        e.target.dataset.compareAdded = 'true';
                        alertify.confirm('Van Comparison')
                            .setting({
                                'title': 'Van Comparison',
                                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/tools/van-comparison" },
                                'onclose': comparisonCount
                            });
                    } else {
                        alertify.confirm('Car Comparison')
                            .setting({
                                'title': 'Van Comparison',
                                'message': `
                  <span class="semi-bold">Van comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/lcvgroup/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                  </ul>
                `,
                                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/tools/van-comparison" },
                                'onclose': comparisonCount
                            });
                    }
                } else {
                    delete cookie_obj[e.target.dataset.compare];
                    (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans');
                    e.target.innerHTML = `<svg width="11" height="11"><use xlink:href="/themes/lcvgroup/img/icons/compare.svg#compare"></use></svg>`;
                    e.target.dataset.compareAdded = 'false';
                    alertify.confirm('Van Comparison')
                        .setting({
                            'title': 'Van Comparison',
                            'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
                            'labels': { ok: 'Go To Compare', cancel: 'Close' },
                            'onok': function(){ window.location.href = "/tools/van-comparison" },
                            'onclose': comparisonCount
                        });
                }
            } else {
                let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('compare_list_vans', cookie_string)
                e.target.innerHTML = `<svg width="11" height="11"><use xlink:href="/themes/lcvgroup/img/icons/compare-remove.svg#compare"></use></svg>`;
                e.target.dataset.compareAdded = 'true';

                alertify.confirm('Van Comparison')
                    .setting({
                        'title': 'Van Comparison',
                        'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
                        'labels': { ok: 'Go To Compare', cancel: 'Close' },
                        'onok': function(){ window.location.href = "/tools/van-comparison" },
                        'onclose': comparisonCount
                    });
            }
        })
    })
    // Add To Favourites - Car
    document.querySelectorAll('button[data-favourite][data-type="car"]').forEach((value) => {
        value.addEventListener('click', (e) => {
            e.preventDefault();
            let cookie = Cookies.get('favourite_list')
            if (cookie) {
                let cookie_obj = JSON.parse(cookie);
                if (cookie_obj[e.target.dataset.favourite] === undefined) {
                    if (Object.keys(cookie_obj).length < 30) {
                        cookie_obj = {...cookie_obj, [e.target.dataset.favourite] : e.target.dataset.name};
                        let cookie_string = JSON.stringify(cookie_obj)
                        Cookies.set('favourite_list', cookie_string)
                        e.target.innerHTML = `<svg width="15" height="14"><use xlink:href="/themes/lcvgroup/img/icons/favourites-remove.svg#heart"></use></svg>`;
                        e.target.dataset.favouriteAdded = 'true';
                        alertify.confirm('Your Wishlist')
                            .setting({
                                'title': 'Your Wishlist',
                                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to wishlist
                `,
                                'labels': { ok: 'Go To Wishlist', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/wishlist" }
                            });
                    } else {
                        alertify.confirm('Your Wishlist')
                            .setting({
                                'title': 'Your Wishlist',
                                'message': `
                  <span class="semi-bold">Wishlist list full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items on your wishlist list add ${e.target.dataset.name} again.</span>
                `,
                                'labels': { ok: 'Go To Wishlist', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/wishlist" }
                            });
                    }
                } else {
                    delete cookie_obj[e.target.dataset.favourite];
                    (Object.keys(cookie_obj).length !== 0) ? Cookies.set('favourite_list', JSON.stringify(cookie_obj)) : Cookies.remove('favourite_list');
                    e.target.innerHTML = `<svg width="15" height="14"><use xlink:href="/themes/lcvgroup/img/icons/favourites-add.svg#heart"></use></svg>`;
                    e.target.dataset.favouriteAdded = 'false';
                    document.querySelector('.tools-main>.favourites') ? e.target.closest('.deal-box').remove() : null;
                    alertify.confirm('Your Wishlist')
                        .setting({
                            'title': 'Your Wishlist',
                            'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from wishlist`,
                            'labels': { ok: 'Go To Wishlist', cancel: 'Close' },
                            'onok': function(){ window.location.href = "/wishlist" }
                        });
                }
            } else {
                let cookie_obj = JSON.parse(`{"${e.target.dataset.favourite}":"${e.target.dataset.name}"}`);
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('favourite_list', cookie_string)
                e.target.innerHTML = `<svg width="15" height="14"><use xlink:href="/themes/lcvgroup/img/icons/favourites-remove.svg#heart"></use></svg>`;
                e.target.dataset.favouriteAdded = 'true';
                alertify.confirm('Your Wishlist')
                    .setting({
                        'title': 'Your Wishlist',
                        'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to wishlist`,
                        'labels': { ok: 'Go To Wishlist', cancel: 'Close' },
                        'onok': function(){ window.location.href = "/wishlist" }
                    });
            }
        })
    })
    // Add To Favourites - Van
    document.querySelectorAll('button[data-favourite][data-type="van"]').forEach((value) => {
        value.addEventListener('click', (e) => {
            e.preventDefault();
            let cookie = Cookies.get('favourite_list_vans')
            if (cookie) {
                let cookie_obj = JSON.parse(cookie);
                if (cookie_obj[e.target.dataset.favourite] === undefined) {
                    if (Object.keys(cookie_obj).length < 30) {
                        cookie_obj = {...cookie_obj, [e.target.dataset.favourite] : e.target.dataset.name};
                        let cookie_string = JSON.stringify(cookie_obj)
                        Cookies.set('favourite_list_vans', cookie_string)
                        e.target.innerHTML = `<svg width="15" height="14"><use xlink:href="/themes/lcvgroup/img/icons/favourites-remove.svg#heart"></use></svg>`;
                        e.target.dataset.favouriteAdded = 'true';
                        alertify.confirm('Your Wishlist')
                            .setting({
                                'title': 'Your Wishlist',
                                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to wishlist
                `,
                                'labels': { ok: 'Go To Wishlist', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/wishlist" }
                            });
                    } else {
                        alertify.confirm('Your Wishlist')
                            .setting({
                                'title': 'Your Wishlist',
                                'message': `
                  <span class="semi-bold">Wishlist list full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items on your wishlist list add ${e.target.dataset.name} again.</span>
                `,
                                'labels': { ok: 'Go To Wishlist', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/wishlist" }
                            });
                    }
                } else {
                    delete cookie_obj[e.target.dataset.favourite];
                    (Object.keys(cookie_obj).length !== 0) ? Cookies.set('favourite_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('favourite_list_vans');
                    e.target.innerHTML = `<svg width="15" height="14"><use xlink:href="/themes/lcvgroup/img/icons/favourites-add.svg#heart"></use></svg>`;
                    e.target.dataset.favouriteAdded = 'false';
                    document.querySelector('.tools-main>.favourites') ? e.target.closest('.deal-box').remove() : null;
                    alertify.confirm('Your Wishlist')
                        .setting({
                            'title': 'Your Wishlist',
                            'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from wishlist`,
                            'labels': { ok: 'Go To Wishlist', cancel: 'Close' },
                            'onok': function(){ window.location.href = "/wishlist" }
                        });
                }
            } else {
                let cookie_obj = JSON.parse(`{"${e.target.dataset.favourite}":"${e.target.dataset.name}"}`);
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('favourite_list_vans', cookie_string)
                e.target.innerHTML = `<svg width="15" height="14"><use xlink:href="/themes/lcvgroup/img/icons/favourites-remove.svg#heart"></use></svg>`;
                e.target.dataset.favouriteAdded = 'true';
                alertify.confirm('Your Wishlist')
                    .setting({
                        'title': 'Your Wishlist',
                        'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to wishlist`,
                        'labels': { ok: 'Go To Wishlist', cancel: 'Close' },
                        'onok': function(){ window.location.href = "/wishlist" }
                    });
            }
        })
    })
    // Compare Count - Car
    function comparisonCount() {
        let car_count = 0;
        let cookie = Cookies.get('compare_list')
        if (Cookies.get('compare_list')) {
            let cookie_obj = JSON.parse(cookie);
            car_count = Object.keys(cookie_obj).length;
        }
        document.querySelectorAll('.comparison_counter').forEach(v => { v.innerText = car_count });
        let van_count = 0;
        let van_cookie = Cookies.get('compare_list_vans')
        if (Cookies.get('compare_list_vans')) {
            let van_cookie_obj = JSON.parse(van_cookie);
            van_count = Object.keys(van_cookie_obj).length;
        }
        document.querySelectorAll('.comparison_counter_van').forEach(v => { v.innerText = van_count });
    }
    comparisonCount();
    document.querySelectorAll('div[data-car] .reset, .alertify .reset, button[data-compare]').forEach(value => {
        value.addEventListener('click', evt => {
            comparisonCount();
        })
    })
    let derivativeField = document.querySelector('#car-comparison select[name=calculator-derivative]');
    if (derivativeField) {
        derivativeField.addEventListener('change', (event) => {
            comparisonCount();
        })
    }
    document.querySelectorAll('div[data-car] .reset, button[data-compare]').forEach(value => {
        value.addEventListener('click', evt => {
            comparisonCount();
        })
    })

    // Share Button
    document.querySelectorAll('button.share-button').forEach((value) => {
        value.addEventListener('click', (e) => {
            e.preventDefault();
            alertify.alert('Share')
                .setting({
                    'title': `Share ${e.target.dataset.car}`,
                    'message': `
                <p class="share-button">
                  <a class="share-facebook" href="https://www.facebook.com/sharer/sharer.php?u=${e.target.dataset.url}" title="Share by Facebook" target="_blank">
                      <svg id="_01.facebook" data-name="01.facebook" xmlns="http://www.w3.org/2000/svg" width="29.577" height="29.577" viewBox="0 0 29.577 29.577">
                        <ellipse id="Ellipse_4401" data-name="Ellipse 4401" cx="14" cy="13.5" rx="14" ry="13.5" transform="translate(0.524 1.451)" fill="#fff"/>
                        <path id="Path_608" data-name="Path 608" d="M14.789,0A14.789,14.789,0,1,0,29.577,14.789,14.789,14.789,0,0,0,14.789,0Zm3.748,13.388-.245,2.061a.389.389,0,0,1-.389.346h-2.14V21.9a.276.276,0,0,1-.272.278H13.31a.276.276,0,0,1-.272-.28l.012-6.108H11.428a.389.389,0,0,1-.389-.389V13.347a.389.389,0,0,1,.389-.389h1.609v-2a3.213,3.213,0,0,1,3.386-3.567h1.648a.389.389,0,0,1,.389.389V9.517a.389.389,0,0,1-.389.389h-1.01c-1.094.018-1.3.541-1.3,1.323v1.722h2.4a.389.389,0,0,1,.378.436Z" fill="#405a9a"/>
                      </svg>
                      &nbsp;Share by Facebook
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-twitter" href="https://twitter.com/intent/tweet?text=${e.target.dataset.url}" title="Share by Twitter" target="_blank">
                      <svg id="Group_1789" data-name="Group 1789" xmlns="http://www.w3.org/2000/svg" width="29.535" height="29.535" viewBox="0 0 29.535 29.535">
                        <circle id="Ellipse_4400" data-name="Ellipse 4400" cx="13.5" cy="13.5" r="13.5" transform="translate(0.956 1.089)" fill="#fff"/>
                        <path id="Path_609" data-name="Path 609" d="M14.767,0A14.767,14.767,0,1,0,29.535,14.767,14.767,14.767,0,0,0,14.767,0Zm7.355,10.3a6.235,6.235,0,0,1-1.265,1.389.54.54,0,0,0-.194.422v.049a8.856,8.856,0,0,1-.571,3.082,9.026,9.026,0,0,1-1.681,2.817,8.3,8.3,0,0,1-3.643,2.407,9.113,9.113,0,0,1-2.864.445,8.743,8.743,0,0,1-4.39-1.183.253.253,0,0,1-.121-.28.243.243,0,0,1,.237-.183H8a5.889,5.889,0,0,0,3.292-1,3.2,3.2,0,0,1-2.526-2.17.167.167,0,0,1,.194-.216,2.93,2.93,0,0,0,.536.051h.068A3.191,3.191,0,0,1,7.7,12.993a.167.167,0,0,1,.247-.146,2.806,2.806,0,0,0,.727.282,3.191,3.191,0,0,1-.515-3.869.167.167,0,0,1,.274-.021A8.355,8.355,0,0,0,14.169,12.3h.016a.12.12,0,0,0,.117-.13,3.379,3.379,0,0,1,.074-1.166,3.091,3.091,0,0,1,2.079-2.223,3.418,3.418,0,0,1,1.008-.155,3.179,3.179,0,0,1,2.106.795.412.412,0,0,0,.274.1.418.418,0,0,0,.1-.014,5.888,5.888,0,0,0,1.554-.641.165.165,0,0,1,.243.194A3.154,3.154,0,0,1,20.9,10.4a5.709,5.709,0,0,0,1.018-.344.167.167,0,0,1,.2.239Z" fill="#64adf0"/>
                      </svg>
                      &nbsp;Share by Twitter
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-linkedin" href="https://www.linkedin.com/shareArticle?mini=true&url=${e.target.dataset.url}" title="Share by LinkedIn" target="_blank">
                      <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
                          <g id="Layer_1-2"><path d="m542.45,1075.59C248.67,1076.4,5.67,837.06,7,537.78,8.31,242,250.29,1.17,549.67,5.11c293.69,3.86,530.16,244.44,527.95,539.4-2.21,294.77-242.66,531.68-535.17,531.08Zm54.06-279.84v-6.2c0-66.8,0-133.6,0-200.41,0-3,.05-6,.11-8.99.42-21.18,9.69-38.17,25.37-51.72,15.66-13.53,34.22-17.08,54.27-13.95,18.91,2.95,32.2,13.53,40.36,30.67,1.64,3.44,2.99,7.05,4.18,10.68,4.25,12.96,5.56,26.38,5.58,39.9.09,64.8.04,129.61.05,194.41,0,1.92.09,3.84.13,5.58h123.27c0-2.31,0-4.28,0-6.25,0-66.3.06-132.61-.05-198.91-.02-11.48-.35-22.99-1.21-34.43-1.56-20.7-6.03-40.83-14.23-59.97-15.77-36.82-42.18-62.19-80.89-73.85-20.33-6.12-41.16-7.67-62.28-5.54-20.74,2.09-40,8.3-57.29,20.16-13.51,9.27-24.32,21.16-33.63,34.53-.96,1.38-1.6,3.12-3.74,4.19v-17.46c0-5.5.01-10.99,0-16.49-.02-5.59-.06-11.18-.09-16.69-12.71-1.03-119.67-.55-123.31.49,1.36,123.36.08,246.72-.25,370.25h123.65Zm-315.51-370.77c0,122.7,0,244.9,0,367.09,0,.99.12,1.98.21,2.96.01.15.16.29.27.41.1.12.24.21.71.62,38.76,0,77.87,0,116.99-.01,1.49,0,2.98-.15,4.46-.24.15,0,.31-.1.43-.21.12-.11.19-.27.36-.53v-370.1h-123.45Zm62.76-179.65c-5.29.54-10.63.75-15.85,1.68-35.41,6.29-54.7,33.52-54.14,64.01.48,26.14,15.67,48.46,40.02,57.9,13.05,5.06,26.54,5.85,40.28,4.35,7.31-.8,14.38-2.68,21.13-5.61,27.68-11.99,42.46-41.06,36.07-70.92-4.61-21.57-16.92-36.9-37.26-45.53-9.62-4.08-19.78-5.67-30.25-5.89Z" fill="#005983"/></g>
                      </svg>
                      &nbsp;Share by LinkedIn
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-whatsapp" href="whatsapp://send?text=I'd like to share a link with you: ${e.target.dataset.url}" data-action="share/whatsapp/share" title="Share by WhatsApp" target="_blank">
                        <svg id="_08.whatsapp" data-name="08.whatsapp" xmlns="http://www.w3.org/2000/svg" width="29.646" height="29.646" viewBox="0 0 29.646 29.646">
                          <ellipse id="Ellipse_4398" data-name="Ellipse 4398" cx="14" cy="13.5" rx="14" ry="13.5" transform="translate(1.293 1.52)" fill="#fff"/>
                          <path id="Path_611" data-name="Path 611" d="M56.371,47.966l-.029-.029a5.756,5.756,0,0,0-9.2,6.676l.254.5-.474,2.3v.029L49.2,56.9l.519.257a5.75,5.75,0,0,0,6.651-9.19Zm-.23,6.436a2.4,2.4,0,0,1-1.274,1.11c-.975.236-2.459,0-4.318-1.718l-.023-.021c-1.617-1.51-2.046-2.768-1.95-3.764A2.387,2.387,0,0,1,49.5,48.6a.529.529,0,0,1,.829.2l.6,1.365a.527.527,0,0,1-.064.538l-.3.39a.517.517,0,0,0-.041.575A5.656,5.656,0,0,0,51.547,52.8a5.967,5.967,0,0,0,1.424,1.02.515.515,0,0,0,.564-.119l.349-.353a.53.53,0,0,1,.536-.164l1.424.41a.532.532,0,0,1,.3.8Z" transform="translate(-37.452 -37.239)" fill="#4cd360"/>
                          <path id="Path_612" data-name="Path 612" d="M14.823,0A14.823,14.823,0,1,0,29.646,14.823,14.823,14.823,0,0,0,14.823,0ZM22.17,15a7.355,7.355,0,0,1-10.622,6.348l-3.706.882a.287.287,0,0,1-.3-.117.281.281,0,0,1-.045-.22l.78-3.788a7.353,7.353,0,1,1,13.9-3.1Z" fill="#4cd360"/>
                        </svg>
                      &nbsp;Share by WhatsApp
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-mail" href="mailto:?subject=I'd like to share a link with you&amp;body=${e.target.dataset.url}" title="Share by Email" target="_blank">
                      <svg id="_01.email" data-name="01.email" xmlns="http://www.w3.org/2000/svg" width="29.577" height="29.577" viewBox="0 0 29.577 29.577">
                        <path id="Path_608" data-name="Path 608" d="M14.789,0A14.789,14.789,0,1,0,29.577,14.789,14.789,14.789,0,0,0,14.789,0Z" fill="#18235b"/>
                        <g id="email_1_" data-name="email (1)" transform="translate(7.73 9.534)">
                          <g id="Group_6951" data-name="Group 6951" transform="translate(0 2.915)">
                            <g id="Group_6950" data-name="Group 6950">
                              <path id="Path_10117" data-name="Path 10117" d="M7.419,151.224a.8.8,0,0,1-.828,0L0,147.2v5.349a2.071,2.071,0,0,0,2.07,2.07h9.887a2.071,2.071,0,0,0,2.07-2.07V147.2Z" transform="translate(0 -147.2)" fill="#fff"/>
                            </g>
                          </g>
                          <g id="Group_6953" data-name="Group 6953" transform="translate(0.066)">
                            <g id="Group_6952" data-name="Group 6952" transform="translate(0 0)">
                              <path id="Path_10118" data-name="Path 10118" d="M13.938,57.088H4.052a2.058,2.058,0,0,0-2,1.623L9,62.95l6.939-4.239A2.058,2.058,0,0,0,13.938,57.088Z" transform="translate(-2.048 -57.088)" fill="#fff"/>
                            </g>
                          </g>
                        </g>
                      </svg>
                      &nbsp;Share by Email
                  </a>
                </p>`,
                    'label': 'Close'
                });
        })
    })

    // Charging Speeds
    if (document.querySelector('#charging-speeds')) {
        function isElementVisible(el) {
            let rect     = el.getBoundingClientRect(),
                vWidth   = window.innerWidth || document.documentElement.clientWidth,
                vHeight  = window.innerHeight || document.documentElement.clientHeight,
                efp      = function (x, y) { return document.elementFromPoint(x, y) };
            if (rect.right < 0 || rect.bottom < 0
                || rect.left > vWidth || rect.top > vHeight)
                return false;
            return (
                el.contains(efp(rect.left,  rect.top))
                ||  el.contains(efp(rect.right, rect.top))
                ||  el.contains(efp(rect.right, rect.bottom))
                ||  el.contains(efp(rect.left,  rect.bottom))
            );
        }
        function scrollAnimTriggerCheck() {
            if (isElementVisible(document.querySelector('#charging-speeds .deal-charging-legend'))) {
                const speedHome = parseInt(document.getElementById('progress_bar_home').getAttribute('data-speed'));
                const speedFast = parseInt(document.getElementById('progress_bar_fast').getAttribute('data-speed'));
                const speedRapid = parseInt(document.getElementById('progress_bar_rapid').getAttribute('data-speed'));
                const speedUltra = parseInt(document.getElementById('progress_bar_ultra').getAttribute('data-speed'));
                const homeWidth = (speedHome / speedHome) * 100;
                document.body.style.setProperty('--position-home', homeWidth);
                const fastWidth = (speedFast / speedHome) * 100;
                document.body.style.setProperty('--position-fast', fastWidth);
                const rapidWidth = (speedRapid / speedHome) * 100;
                document.body.style.setProperty('--position-rapid', rapidWidth);
                const ultraWidth = (speedUltra / speedHome) * 100;
                document.body.style.setProperty('--position-ultra', ultraWidth);

                document.removeEventListener("scroll", scrollAnimTriggerCheck);
            }
        }
        document.addEventListener("scroll", scrollAnimTriggerCheck);
    }
    if (document.querySelector('#charging-speeds1')) {
        function isElementVisible(el) {
            let rect     = el.getBoundingClientRect(),
                vWidth   = window.innerWidth || document.documentElement.clientWidth,
                vHeight  = window.innerHeight || document.documentElement.clientHeight,
                efp      = function (x, y) { return document.elementFromPoint(x, y) };
            if (rect.right < 0 || rect.bottom < 0
                || rect.left > vWidth || rect.top > vHeight)
                return false;
            return (
                el.contains(efp(rect.left,  rect.top))
                ||  el.contains(efp(rect.right, rect.top))
                ||  el.contains(efp(rect.right, rect.bottom))
                ||  el.contains(efp(rect.left,  rect.bottom))
            );
        }
        function scrollAnimTriggerCheck() {
            if (isElementVisible(document.querySelector('#charging-speeds1 .deal-charging-legend'))) {
                const speedHome = parseInt(document.getElementById('progress_bar_home1').getAttribute('data-speed'));
                const speedFast = parseInt(document.getElementById('progress_bar_fast1').getAttribute('data-speed'));
                const speedRapid = parseInt(document.getElementById('progress_bar_rapid1').getAttribute('data-speed'));
                const speedUltra = parseInt(document.getElementById('progress_bar_ultra1').getAttribute('data-speed'));
                const homeWidth = (speedHome / speedHome) * 100;
                document.body.style.setProperty('--position-home', homeWidth);
                const fastWidth = (speedFast / speedHome) * 100;
                document.body.style.setProperty('--position-fast', fastWidth);
                const rapidWidth = (speedRapid / speedHome) * 100;
                document.body.style.setProperty('--position-rapid', rapidWidth);
                const ultraWidth = (speedUltra / speedHome) * 100;
                document.body.style.setProperty('--position-ultra', ultraWidth);

                document.removeEventListener("scroll", scrollAnimTriggerCheck);
            }
        }
        document.addEventListener("scroll", scrollAnimTriggerCheck);
    }
    // END Charging Speeds

// Auto-slide helper function
    function sliderAuto(slider, milliseconds) {
        const slidesCount = slider.track.childElementCount;
        let slideTimeout = null;
        let nextIndex = 1;

        function slide() {
            slideTimeout = setTimeout(
                function () {
                    if (nextIndex >= slidesCount ) {
                        nextIndex = 0;
                    }
                    slider.scrollItem(nextIndex++);
                },
                milliseconds
            );
        }

        slider.ele.addEventListener('glider-animated', function() {
            window.clearInterval(slideTimeout);
            slide();
        });

        slide();
    }

    // Derivative Gallery Slider
    const dealGallerySlider = document.querySelector('.deal-gallery-track');
    if (dealGallerySlider) {
        new Glider(dealGallerySlider, {
            slidesToScroll: 1,
            slidesToShow: 1,
            draggable: true,
            scrollLock: true,
            arrows: {
                prev: '.deal-gallery-controls .glider-prev',
                next: '.deal-gallery-controls .glider-next'
            },
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 1900,
                    settings: {
                        slidesToShow: 6,
                    }
                }
            ]
        })
    }

    // Derivative Gallery Mobile Slider
    const dealGallerySliderMobile = document.querySelector('.deal-detail-mobile .deal-gallery-track');
    if (dealGallerySliderMobile) {
        new Glider(dealGallerySliderMobile, {
            slidesToScroll: 1,
            slidesToShow: 1,
            draggable: true,
            scrollLock: true,
            arrows: {
                prev: '.deal-detail-mobile .deal-gallery-controls .glider-prev',
                next: '.deal-detail-mobile .deal-gallery-controls .glider-next'
            },
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 959,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 1900,
                    settings: {
                        slidesToShow: 6,
                    }
                }
            ]
        })
    }

    let thumbs = document.querySelectorAll('.deal-gallery .gallery-thumb');
    if(thumbs){
        for (let i = 0; i < thumbs.length; i++) {
            thumbs[i].addEventListener("click", function (e) {
                e.preventDefault();
                [].forEach.call(thumbs, function (el) {
                    el.classList.remove("is-active");
                });
                this.classList.add('is-active');
                // document.getElementById("main-img").src = this.dataset.img;
                document.querySelectorAll('.deal-gallery-img').forEach((v) => { v.src = this.dataset.img })
                if(i == 0 && document.querySelector(".deal-gallery.has-video .deal-gallery-main")) {
                    document.querySelector(".deal-gallery.has-video .deal-gallery-main").classList.add('video-trigger');
                } else if(document.querySelector(".deal-gallery.has-video .deal-gallery-main")) {
                    document.querySelector(".deal-gallery.has-video .deal-gallery-main").classList.remove('video-trigger');
                }
            });
        }
    }
    // END Derivative Gallery Slider

    // Nav Slider
    // const navSlider = document.querySelector('#dropdown-navigation-slider > div:not(.glider-arrows)')
    // if (navSlider) {
    //   new Glider(navSlider, {
    //     slidesToScroll: 1,
    //     slidesToShow: 1,
    //     draggable: false,
    //     scrollLock: true,
    //     arrows: {
    //       prev: '#dropdown-navigation-slider .glider-prev',
    //       next: '#dropdown-navigation-slider .glider-next'
    //     }
    //   })
    //   const navSliderArrows = document.querySelectorAll('#dropdown-navigation-slider > div.glider-arrows > .glider-arrow')
    //   if (navSliderArrows) {
    //     navSliderArrows.forEach((value) => {
    //       value.addEventListener('click', (ev) => {
    //         document.querySelectorAll('#dropdown-navigation-slider img').forEach(e => { e.classList.remove('loaded') })
    //         setTimeout(function() {
    //           document.querySelectorAll('#dropdown-navigation-slider img').forEach(e => { e.classList.add('loaded') })
    //         }, 100)
    //       })
    //     })
    //   }
    // }
    // END Nav Slider

    // Derivative Gallery Modal
    // const galleryButton = document.querySelector('#view-gallery-button');
    // const galleryModal = new tingle.modal({
    //   footer: false,
    //   closeMethods: ['overlay', 'button', 'escape'],
    //   closeLabel: "Close",
    //   cssClass: ['gallery-modal'],
    //   onClose: function() {
    //     this.setContent('');
    //   }
    // });
    // galleryButton?.addEventListener("click", function(e){
    //   const galleryWrapper = document.querySelector('.deal-main .deal-gallery-modal');
    //   const galleryWrapperClone = galleryWrapper.cloneNode(true);
    //   if (galleryWrapperClone) {
    //     galleryModal.setContent(galleryWrapperClone);
    //
    //     galleryModal.open();
    //
    //     const modalGallerySlider = document.querySelector('.tingle-modal-box .deal-gallery-modal .deal-gallery-track');
    //     if (modalGallerySlider) {
    //       new Glider(modalGallerySlider, {
    //         slidesToScroll: 1,
    //         slidesToShow: 1,
    //         draggable: true,
    //         scrollLock: true,
    //         arrows: {
    //           prev: `.tingle-modal-box .deal-gallery-modal .deal-gallery-controls .glider-prev`,
    //           next: `.tingle-modal-box .deal-gallery-modal .deal-gallery-controls .glider-next`
    //         }
    //       })
    //     }
    //   }
    // })
    // END Derivative Gallery Modal

    // Deal Box Slider VANS
    const dealBoxSliderVans = [].slice.call(document.querySelectorAll('.latest-offers-strip-vans .latest-offers-strip-ctr'))
    if (dealBoxSliderVans) {
        dealBoxSliderVans.forEach((e) => {
            new Glider(e, {
                slidesToScroll: 1,
                slidesToShow: 1,
                draggable: true,
                dots: '.latest-offers-strip-vans .dots',
                scrollLock: true,
                arrows: {
                    prev: '.latest-offers-strip-vans .latest-offers-strip-inner .glider-prev',
                    next: '.latest-offers-strip-vans .latest-offers-strip-inner .glider-next'
                },
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 1281,
                        settings: {
                            slidesToShow: 3,
                        }
                    }
                ]
            })
        })
    }
    // END Deal Box Slider VANS

    // Deal Box Slider CARS
    const dealBoxSliderCars = [].slice.call(document.querySelectorAll('.latest-offers-strip-cars .latest-offers-strip-ctr'))
    if (dealBoxSliderCars) {
        dealBoxSliderCars.forEach((e) => {
            new Glider(e, {
                slidesToScroll: 1,
                slidesToShow: 1,
                draggable: true,
                dots: '.latest-offers-strip-cars .dots',
                scrollLock: true,
                arrows: {
                    prev: '.latest-offers-strip-cars .latest-offers-strip-inner .glider-prev',
                    next: '.latest-offers-strip-cars .latest-offers-strip-inner .glider-next'
                },
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 1281,
                        settings: {
                            slidesToShow: 3,
                        }
                    }
                ]
            })
        })
    }
    // END Deal Box Slider CARS

    // Deal Box Derivative
    const dealBoxSlider = [].slice.call(document.querySelectorAll('.latest-offers-strip-derivative .latest-offers-strip-ctr'))
    if (dealBoxSlider) {
        dealBoxSlider.forEach((e) => {
            new Glider(e, {
                slidesToScroll: 1,
                slidesToShow: 1,
                draggable: true,
                dots: '.latest-offers-strip-derivative .dots',
                scrollLock: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            })
        })
    }
    // END Deal Box Derivative CARS

    //Manufacturer Strip Slider
    const manufacturerSlider = document.querySelector('.manufacturer-track');
    if (manufacturerSlider) {
        new Glider(manufacturerSlider, {
            slidesToScroll: 2,
            slidesToShow: 2,
            draggable: true,
            dots: '.manufacturer-strip-popular .dots',
            scrollLock: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 8,
                    }
                },
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 8,
                    }
                }
            ]
        })
    }

    // Color Picker
    document.querySelectorAll('.colour-picker > span').forEach(value => {
        value.addEventListener('click', (e) => {
            (document.querySelector('.colour-picker > span.active')) ? document.querySelector('.colour-picker > span.active').classList.remove('active') : null;
            (document.querySelector('.colour-picker-text > span')) ? document.querySelector('.colour-picker-text > span').innerText = e.target.dataset.name : document.querySelector('.colour-picker-text').innerHTML = `View available colours: <span>${e.target.dataset.name}</span>`;
            e.target.classList.add('active');
            document.querySelectorAll('img[src*="imagin.studio"]').forEach(ele => {
                let url = ele.getAttribute('src');
                url = updateQueryStringParameter(url, 'paintId', e.target.dataset.paintId);
                ele.setAttribute('src',url);
            });
            document.querySelectorAll('a[data-img*="imagin.studio"]').forEach(ele => {
                let img = ele.getAttribute('data-img');
                img = updateQueryStringParameter(img, 'paintId', e.target.dataset.paintId);
                ele.setAttribute('data-img',img);
            });
        });
    })
    function updateQueryStringParameter(uri, key, value) {
        let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        let separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
            return uri + separator + key + "=" + value;
        }
    }
    // END Color Picker

    // Contact Form
    if(document.getElementById('send-contact-form')){
        // Do captcha and submit form

        let button = document.querySelector('#send-contact-form');
        let terms = document.querySelector('#contact-form [name=consent]');
        terms.onchange = function() {
            button.disabled = !this.checked;
        };

        document.getElementById('send-contact-form').addEventListener("click", function(e) {
            e.preventDefault();

            document.body.classList.remove('loaded');
            button.disabled = true;
            button.innerHTML = 'Sending...';

            grecaptcha.ready(function() {
                grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
                    document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

                    let url = '/contact';
                    let email = document.querySelector('#contact-form [name=email]').value;
                    let name = document.querySelector('#contact-form [name=name]').value;
                    let company = document.querySelector('#contact-form [name=company]').value;
                    // let surname = document.querySelector('#contact-form [name=surname]').value;
                    let telephone = document.querySelector('#contact-form [name=telephone]').value;
                    let enquiry = document.querySelector('#contact-form [name=enquiry]:checked').value;
                    let comments = document.querySelector('#contact-form [name=comments]').value;
                    let contact = document.querySelector('#contact-form [name=contact]').options[document.querySelector('#contact-form [name=contact]').selectedIndex].text;
                    let time = document.querySelector('#contact-form [name=time]').options[document.querySelector('#contact-form [name=time]').selectedIndex].text;
                    let businessType = document.querySelector('#contact-form [name=businessType]').options[document.querySelector('#contact-form [name=businessType]').selectedIndex].text;
                    // let callback = '';
                    // if (document.querySelector('#contact-form [name=date]') && document.querySelector('#contact-form [name=time]')){
                    //   callback =`${document.querySelector('#contact-form [name=date]').value} ${document.querySelector('#contact-form [name=time]').value}`;
                    // }
                    let csrf_token = document.querySelector('#contact-form [name=_token]').value;

                    let marketing_checkboxes = document.querySelectorAll('#contact-form .checkbox__input.marketing input');
                    let marketing_checkboxes_selected = '';
                    marketing_checkboxes.forEach(value => {
                        if(value.checked === true) {
                            marketing_checkboxes_selected += `${value.value}, `;
                        }
                    })

                    if (document.querySelector('#contact-form [name=subscribe]').checked) {
                        fetch('/newsletter', {
                            method: 'POST', // or 'PUT'
                            body: JSON.stringify({
                                'name': name,
                                'email': email,
                                'mail_status': 'subscribed',
                                '_token': csrf_token }),
                            headers:{
                                'Content-Type': 'application/json'
                            }}).then(function(response) {
                            if (response.status !== 200) {
                                console.warn('Looks like there was a problem. Status Code: ' + response.status);
                                return;
                            }
                            return response.json();
                        }).then(function(data) {
                            if(data.status !== 'ok'){
                                let errors = '';
                                for (let i in data.errors) {
                                    errors += data.errors[i][0]+'\n';
                                }
                                return alert('There was a problem with your sign up details\n\n'+errors);
                            }

                            // Trigger event tracking
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'Newsletter Signup'
                            });

                        }).catch(function(err) {
                            console.error('Fetch Error -', err);
                        });
                    }

                    fetch(url, {
                        method: 'POST',
                        body: JSON.stringify({
                            'name': name,
                            // 'forename': forename,
                            'company': company,
                            'email': email,
                            'telephone': telephone,
                            'comments': `HOW WOULD YOU DESCRIBE YOUR ENQUIRY?: ${enquiry} \n\r PREFERRED CONTACT METHOD: ${contact} \n\r PREFERRED CONTACT TIME: ${time} \n\r ADDITIONAL INFORMATION: ${comments} \n\r FROM URL: ${window.location.pathname} \n\r BUSINESS TYPE: ${businessType}`,
                            'time': time,
                            'contact': contact,
                            'message': comments,
                            'pageUrl': window.location.href,
                            'business_type': businessType,
                            '_token': csrf_token,
                            'g-recaptcha-response': recaptcha_token
                        }),
                        headers:{
                            'Content-Type': 'application/json'
                        }}).then(function(response) {
                        document.body.classList.add('loaded');
                        button.disabled = false;
                        button.innerHTML = 'Submit Enquiry';
                        if (response.status !== 200) {
                            console.warn('Looks like there was a problem. Status Code: ' +
                                response.status);
                            return;
                        }
                        return response.json();
                    }).then(function(data) {
                        if(data.status !== 'ok'){
                            let errors = '';
                            for (var i in data.errors) {
                                errors += data.errors[i][0]+'\n';
                            }
                            button.disabled = false;
                            button.innerHTML = 'Submit Enquiry';
                            return alert('There was a problem with your form\n\n'+errors);
                        }

                        button.disabled = false;
                        button.innerHTML = 'Submit Enquiry';
                        document.getElementsByClassName('contact-form')[0].reset();
                        document.getElementsByClassName('contact-content')[0].classList.add('hidden');
                        document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
                        document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

                        // Trigger event tracking
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'General Enquiry Received'
                        });


                    }).catch(function(err) {
                        document.body.classList.add('loaded');
                        console.error('Fetch Error -', err);
                        return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
                    });

                });
            });

        });
    }
    // END Contact Form

    // Enquiry Form
    if(document.getElementById('send-enquiry-form')){
        // Do captcha and submit form

        let button_2 = document.querySelector('#send-enquiry-form');
        let terms_2 = document.querySelector('#contact-form [name=consent]');
        terms_2.onchange = function() {
            button_2.disabled = !this.checked;
        };

        document.getElementById('send-enquiry-form').addEventListener("click", function(e) {
            e.preventDefault();

            document.body.classList.remove('loaded');
            button_2.disabled = true;
            button_2.innerHTML = 'Sending...';

            grecaptcha.ready(function() {
                grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
                    document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

                    let url = '/contact';
                    let email = document.querySelector('#contact-form [name=email]').value;
                    let name = document.querySelector('#contact-form [name=name]').value;
                    // let surname = document.querySelector('#contact-form [name=surname]').value;
                    let telephone = document.querySelector('#contact-form [name=telephone]').value;
                    let comments = document.querySelector('#contact-form [name=comments]').value;
                    let contact = document.querySelector('#contact-form [name=contact]').options[document.querySelector('#contact-form [name=contact]').selectedIndex].text;
                    let time = document.querySelector('#contact-form [name=time]').options[document.querySelector('#contact-form [name=time]').selectedIndex].text;
                    // let callback = '';
                    // if (document.querySelector('#contact-form [name=date]') && document.querySelector('#contact-form [name=time]')){
                    //   callback =`${document.querySelector('#contact-form [name=date]').value} ${document.querySelector('#contact-form [name=time]').value}`;
                    // }
                    let csrf_token = document.querySelector('#contact-form [name=_token]').value;

                    let marketing_checkboxes = document.querySelectorAll('#contact-form .checkbox__input.marketing input');
                    let marketing_checkboxes_selected = '';
                    marketing_checkboxes.forEach(value => {
                        if(value.checked === true) {
                            marketing_checkboxes_selected += `${value.value}, `;
                        }
                    })

                    if (document.querySelector('#contact-form [name=subscribe]').checked) {
                        fetch('/newsletter', {
                            method: 'POST', // or 'PUT'
                            body: JSON.stringify({
                                'name': name,
                                'email': email,
                                'mail_status': 'subscribed',
                                '_token': csrf_token }),
                            headers:{
                                'Content-Type': 'application/json'
                            }}).then(function(response) {
                            if (response.status !== 200) {
                                console.warn('Looks like there was a problem. Status Code: ' + response.status);
                                return;
                            }
                            return response.json();
                        }).then(function(data) {
                            if(data.status !== 'ok'){
                                let errors = '';
                                for (let i in data.errors) {
                                    errors += data.errors[i][0]+'\n';
                                }
                                return alert('There was a problem with your sign up details\n\n'+errors);
                            }

                            // Trigger event tracking
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'Newsletter Signup'
                            });

                        }).catch(function(err) {
                            console.error('Fetch Error -', err);
                        });
                    }

                    fetch(url, {
                        method: 'POST',
                        body: JSON.stringify({
                            'name': name,
                            // 'forename': forename,
                            // 'surname': surname,
                            'email': email,
                            'telephone': telephone,
                            'comments': `PREFERRED CONTACT METHOD: ${contact} \n\r PREFERRED CONTACT TIME: ${time} \n\r ADDITIONAL INFORMATION: ${comments}`,
                            '_token': csrf_token,
                            'g-recaptcha-response': recaptcha_token
                        }),
                        headers:{
                            'Content-Type': 'application/json'
                        }}).then(function(response) {
                        document.body.classList.add('loaded');
                        button_2.disabled = false;
                        button_2.innerHTML = 'Submit Enquiry';
                        if (response.status !== 200) {
                            console.warn('Looks like there was a problem. Status Code: ' +
                                response.status);
                            return;
                        }
                        return response.json();
                    }).then(function(data) {
                        if(data.status !== 'ok'){
                            let errors = '';
                            for (var i in data.errors) {
                                errors += data.errors[i][0]+'\n';
                            }
                            button_2.disabled = false;
                            button_2.innerHTML = 'Submit Enquiry';
                            return alert('There was a problem with your form\n\n'+errors);
                        }

                        button_2.disabled = false;
                        button_2.innerHTML = 'Submit Enquiry';
                        document.getElementsByClassName('contact-form')[0].reset();
                        document.getElementsByClassName('contact-form-header')[0].classList.add('hidden');
                        document.getElementsByClassName('contact-content')[0].classList.add('hidden');
                        document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
                        document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

                        // Trigger event tracking
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'General Enquiry Received'
                        });


                    }).catch(function(err) {
                        document.body.classList.add('loaded');
                        console.error('Fetch Error -', err);
                        return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
                    });

                });
            });

        });
    }
    // END Enquiry Form

    // Guide/Blog Filters
    if (document.querySelector('#tags-dropdown')) {
        const toggleCategory = (cat) => {
            if (cat === 'all') {
                document.querySelectorAll('.toggle-section .toggle-article').forEach(v => { v.classList.add('active') });
                document.querySelectorAll('.toggle-tags > li').forEach(v => { v.classList.remove('active') });
                document.querySelector(`.toggle-tags > li > a[data-value=all]`).parentElement.classList.add('active');
            } else {
                document.querySelectorAll('.toggle-tags > li, .toggle-section .toggle-article').forEach(v => { v.classList.remove('active') });
                document.querySelector(`.toggle-tags > li > a[data-value=${cat}]`).parentElement.classList.add('active');

                // Split the category into an array
                const catArray = cat.split(', ');

                // Iterate over each article and check if any of the tags match
                document.querySelectorAll('.toggle-section .toggle-article').forEach(v => {
                    const articleTags = v.dataset.value.split(', ');

                    // Check if any of the tags match, considering both cases of multiple and single tags
                    if (articleTags.some(tag => catArray.includes(tag)) || catArray.includes(articleTags[0])) {
                        v.classList.add('active');
                    }
                });
            }
        };

        document.querySelectorAll('.toggle-tags > li > a').forEach(v => {
            v.addEventListener('click', e => {
                toggleCategory(e.target.dataset.value);
            });
        });

        document.querySelector('#tags-dropdown').addEventListener('change', e => {
            toggleCategory(e.target.options[e.target.selectedIndex].value);
        });
    }
    // END Guide Filters



    // FAQs Filters
    if (document.querySelector('#faq-tags-dropdown')){
        const faqCategory = (cat) => {
            if (cat === 'all') {
                document.querySelectorAll('.faq-tags > li').forEach(v => { v.classList.remove('active') })
                document.querySelector(`.faq-tags > li > a[data-category=all]`).parentElement.classList.add('active')
                document.querySelectorAll('#faq-list > div').forEach(v => { v.classList.remove('visuallyhidden') })
            } else {
                document.querySelectorAll('.faq-tags > li').forEach(v => { v.classList.remove('active') })
                document.querySelector(`.faq-tags > li > a[data-category=${cat}]`).parentElement.classList.add('active')
                document.querySelectorAll('#faq-list > div').forEach(v => { v.classList.add('visuallyhidden') })
                document.querySelectorAll(`#faq-list > div[data-category=${cat}]`).forEach(v => { v.classList.remove('visuallyhidden') })
            }
        }
        document.querySelectorAll('.faq-tags > li > a').forEach(v => {
            v.addEventListener('click', e => {
                faqCategory(e.target.dataset.category)
            })
        })
        document.querySelector('#faq-tags-dropdown').addEventListener('change', e => {
            faqCategory(e.target.options[e.target.selectedIndex].value)
        })
    }
    // END FAQs Filters

    // FAQ Search
    if(document.querySelector('#faq-search')){
        var faqSearch = document.querySelector('.faq-search input');
        if(faqSearch !== null){
            faqSearch.addEventListener('keyup', function(e){
                var results = document.getElementById('faq-results');
                if(this.value.length != 0){
                    results.classList.add("active");
                } else {
                    results.classList.remove("active");
                }
            });
        }

        let search = document.querySelector('#faq-search');
        let all_data = document.querySelectorAll('#faq-list > div');
        let no_results = document.querySelector('#no-results');
        let result_list = document.querySelector('#search-results')
        search.addEventListener('input', function(e) {
            if (e.target.value !== '') {
                document.querySelector('.search-results').classList.add('active');
                result_list.innerHTML = '';
                no_results.classList.add('visuallyhidden');
                let i = 0;
                all_data.forEach((value ) => {
                    if(value.textContent.toLowerCase().includes(search.value.toLowerCase())) {
                        i++;
                        result_list.append(value.cloneNode(true));
                    }
                })
                toggleAccordions();

                if (i < 1) {
                    result_list.innerHTML = '';
                    no_results.classList.remove('visuallyhidden');
                }
            } else {
                document.querySelector('.search-results').classList.remove('active');
                result_list.innerHTML = '';
                no_results.classList.remove('visuallyhidden');
                toggleAccordions();
            }
        });
    }
    // END FAQs Search

    // Subscribe Form - Popup
    let newsletterPopup = document.querySelector('#newsletter-popup');
    if (newsletterPopup) {
        setTimeout(() => {
            document.body.classList.add('show-newsletter')
        }, parseInt(newsletterPopup.dataset.delay));
        document.querySelector('#newsletter-close').addEventListener('click', () => {
            document.body.classList.remove('show-newsletter');
            setTimeout(() => {
                newsletterPopup.classList.add('dismissed')
            }, 1000);
            writeCookie('newsletter_dismissed', 'true', newsletterPopup.dataset.expiry)
        })

        let button_popup = document.querySelector('#email-signup-popup');

        document.getElementById('email-signup-popup').addEventListener("click", function (e) {
            e.preventDefault();

            document.body.classList.remove('loaded');
            button_popup.innerHTML = 'Sending...';

            grecaptcha.ready(function () {
                grecaptcha.execute(document.getElementById('newsletter-form-popup').dataset['recaptcha'], {action: 'contact'}).then(function (recaptcha_token) {
                    document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

                    let url = '/contact';
                    let email = document.getElementById('newsletter-email-popup').value;
                    let forename = document.getElementById('newsletter-forename-popup').value;
                    let surname = document.getElementById('newsletter-surname-popup').value;
                    let token = document.getElementsByName('_token')[0].value;
                    let comments = document.getElementById('newsletter-comments-popup').value;
                    let telephone = document.getElementById('newsletter-telephone-popup').value;
                    let currentUrl = window.location.href;

                    fetch(url, {
                        method: 'POST',
                        body: JSON.stringify({
                            'first_name': forename,
                            'last_name': surname,
                            'name': forename + ' ' + surname,
                            'email': email,
                            'telephone': telephone,
                            'comments': comments,
                            'submitted_from_url': currentUrl,
                            '_token': token,
                            'g-recaptcha-response': recaptcha_token
                        }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(function (response) {
                        document.body.classList.add('loaded');
                        button_popup.disabled = false;
                        button_popup.innerHTML = 'Submit Enquiry';
                        if (response.status !== 200) {
                            console.warn('Looks like there was a problem. Status Code: ' +
                                response.status);
                            return;
                        }
                        return response.json();
                    }).then(function (data) {
                        if (data.status !== 'ok') {
                            let errors = '';
                            for (var i in data.errors) {
                                errors += data.errors[i][0] + '\n';
                            }
                            button_popup.disabled = false;
                            button_popup.innerHTML = 'Submit Enquiry';
                            return alert('There was a problem with your form\n\n' + errors);
                        }

                        button_popup.innerHTML = 'submit enquiry..';
                        newsletterPopup.querySelector('form').classList.add('visuallyhidden');
                        newsletterPopup.querySelector('.subscribe-form-content').classList.add('visuallyhidden');
                        newsletterPopup.querySelector('.thank-you').classList.add('show');
                        document.getElementsByClassName('newsletter-form-popup')[0].reset();
                        setTimeout(() => {
                            document.body.classList.remove('show-newsletter')
                        }, 1000);
                        setTimeout(() => {
                            newsletterPopup.classList.add('dismissed')
                        }, 2000);
                        writeCookie('newsletter_dismissed', 'true', newsletterPopup.dataset.expiry);

                        // Trigger event tracking
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'Popup Enquiry Received'
                        });


                    }).catch(function (err) {
                        document.body.classList.add('loaded');
                        console.error('Fetch Error -', err);
                        return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
                    });

                });
            });
        });
    }
    // END Subscribe Form - Popup

    // Subscribe Form
    if(document.getElementById('email-signup')){
        document.getElementById('email-signup').addEventListener("click", function(e) {
            e.preventDefault();

            var recaptcha_token = null;

            if(document.querySelector('input[name=g-recaptcha-response]')){
                recaptcha_token = document.querySelector('input[name=g-recaptcha-response]').value;
            } else {
                grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(token) {
                    recaptcha_token = token;
                });
            }

            document.getElementById('email-signup').classList.add('preload');
            document.getElementById('email-signup').innerText = 'please wait...';
            document.getElementById('email-signup').disabled = true;

            let url = '/newsletter';
            let email = document.getElementById('newsletter-email').value;
            let forename = document.getElementById('newsletter-forename').value;
            let surname = document.getElementById('newsletter-surname').value;
            let token = document.getElementsByName('_token')[0].value;

            fetch(url, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify({ 'first_name': forename, 'last_name': surname, 'full_name': forename + ' ' + surname, 'email': email, 'mail_status': 'subscribed', '_token': token }), // data can be `string` or {object}!
                headers:{
                    'Content-Type': 'application/json'
                }}).then(function(response) {
                if (response.status !== 200) {
                    console.warn('Looks like there was a problem. Status Code: ' +
                        response.status);
                    return;
                }
                return response.json();
            }).then(function(data) {
                document.getElementById('email-signup').classList.remove('preload');
                document.getElementById('email-signup').innerText = 'sign up now.';
                document.getElementById('email-signup').disabled = false;

                if(data.status!='ok'){
                    let errors = '';
                    for (var i in data.errors) {
                        errors += data.errors[i][0]+'\n';
                    }
                    if(typeof Swal !== 'undefined'){
                        return Swal.fire({
                            title: 'Whoops!',
                            html: ('There was a problem with your sign up details\n\n'+errors).replace(/\n/gi,'<br>'),
                            icon: 'error',
                            confirmButtonText: 'OK',
                        });
                    } else {
                        return alert('There was a problem with your sign up details\n\n'+errors);
                    }
                }

                newsletterPopup ? writeCookie('newsletter_dismissed', 'true', newsletterPopup.dataset.expiry) : null;
                document.getElementsByClassName('footer-newsletter-form')[0].reset();
                // Trigger event tracking
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'Newsletter Signup'
                });

                if(typeof Swal !== 'undefined'){
                    return Swal.fire({
                        title: 'Thank you!',
                        text: 'You\'re signed up!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                } else {
                    return alert('Thank you!');
                }

            }).catch(function(err) {
                console.error('Fetch Error -', err);
                document.getElementById('email-signup').classList.remove('preload');
                document.getElementById('email-signup').innerHTML = 'sign up now.';
                document.getElementById('email-signup').disabled = false;
            });
        });
    }

    // Uncheck compliance checkboxes
    let checkboxes = document.querySelectorAll('form [name=consent]');
    if(checkboxes.length > 0) {
        checkboxes.forEach(value => {
            value.checked = false;
        })
    }

    // Search Budget slider
    const budgetSlider = document.querySelector('#budget-slider');
    const updateResultsBtn = document.getElementById('update-results-btn');
    if(budgetSlider && updateResultsBtn){
        let initial_min = parseInt(budgetSlider.dataset.min);
        let initial_max = parseInt(budgetSlider.dataset.max);
        let updateSliderValue;
        updateSliderValue = function(slider, handle = 0) {
            let children, i, results, val, values;
            children = slider.getElementsByClassName('noUi-handle');
            values = slider.noUiSlider.get();
            i = 0;
            results = [];
            while (i < children.length) {
                if (children.length === 1) {
                    val = parseInt(values);
                } else {
                    val = parseInt(values[i]);
                }
                if(val == 1000){
                    val = 'No Max';
                }
                children[i].dataset.value = val;
                results.push(i++);
            }
            return results;
        };

        noUiSlider.create(budgetSlider, {
            start: [initial_min, initial_max],
            step: 100,
            margin: 100,
            behaviour: 'drag',
            connect: true,
            range: {
                min: 0,
                max: 1000
            },
            format: {
                to: function(value) {
                    if (value === 1000) {
                        return 'No Max';
                    }
                    return value;
                },
                from: function(value) {
                    if (value === 'No Max') {
                        return 1000;
                    }
                    return value;
                }
            }
        });
        budgetSlider.noUiSlider.on('update', function() {
            const selectedValues = budgetSlider.noUiSlider.get();
            let updated_min = parseInt(selectedValues[0]);
            let updated_max = parseInt(selectedValues[1]);

            if(isNaN(updated_max)){
                updated_max = 1000;
            }

            if(document.querySelector('.mobile-accordion[data-field="budget"]').classList.contains('active')){
                if (initial_min != updated_min || initial_max != updated_max) {
                    updateResultsBtn.classList.add('slider-moved')
                } else {
                    updateResultsBtn.classList.remove('slider-moved')
                }
            }

            if(updated_max - updated_min < 200 && updated_max - updated_min > 0){
                document.querySelector('#budget-slider .noUi-handle-lower').classList.add('min-handle');
                document.querySelector('#budget-slider .noUi-handle-upper').classList.add('max-handle');
            } else{
                document.querySelector('#budget-slider .noUi-handle-lower').classList.remove('min-handle');
                document.querySelector('#budget-slider .noUi-handle-upper').classList.remove('max-handle');
            }

            if(updated_max == 1000){
                document.querySelector('#budget-slider .noUi-handle-upper').classList.add('no-max');
            } else{
                document.querySelector('#budget-slider .noUi-handle-upper').classList.remove('no-max');
            }

            return updateSliderValue(budgetSlider);
        });

        updateResultsBtn.addEventListener('click', function(e){
            e.preventDefault();

            // Get the selected values from the slider
            const selectedValues = budgetSlider.noUiSlider.get();
            let minValue = parseInt(selectedValues[0]);
            let maxValue = parseInt(selectedValues[1]);

            document.body.classList.remove('loaded');

            if(isNaN(maxValue)){
                setUrlParams('budget', minValue + '+', document.querySelector('.search-content').dataset.module);
            } else{
                setUrlParams('budget', minValue + '-' + maxValue, document.querySelector('.search-content').dataset.module);
            }
        });
    }

    // Feefo Reviews
    const xhttp = new XMLHttpRequest();
    xhttp.onload = function() {
        let reviewsTop = document.querySelectorAll('.review-feefo');
        let response = JSON.parse(this.response);

        if(response && reviewsTop){
            let rating = response.rating.rating;
            let url = response.merchant.review_url;
            let calculatedValue = (rating / 5) * 100;
            reviewsTop.forEach(value => {
                value.querySelector('.reviews-rating > span:first-child').innerHTML = rating;
                value.querySelector('.star-rating-active').style.width = `${calculatedValue}%`;
                value.querySelector('a').setAttribute('href', url)
                value.classList.remove('visuallyhidden');
            })
        } else {
            reviewsTop.forEach(value => {
                value ? value.classList.add('visuallyhidden') : null;
            })
        }

    }
    // xhttp.open("GET", "https://api.feefo.com/api/20/reviews/summary/all?merchant_identifier=low-cost-vans&since_period=all");
    xhttp.open("GET", "https://api.feefo.com/api/20/reviews/summary/all?merchant_identifier=low-cost-vans");
    xhttp.send();

    const xhttp2 = new XMLHttpRequest();
    xhttp2.onload = function() {
        let reviewsStrip = document.querySelector('.review-strip');
        let response = JSON.parse(this.response);

        if(response && reviewsStrip){
            let counter = 0;
            response.reviews.forEach(review => {
                let reviewRating = review.service.rating ? review.service.rating.rating : 0;

                if (counter >= 8 || reviewRating < 4) {
                    return;
                }

                let reviewTitle = review.service.title ? review.service.title : '';
                let reviewText = review.service.review ? review.service.review : '';
                let reviewName = review.customer ? (review.customer.display_name ? review.customer.display_name : '') : '';
                let reviewLocation = review.customer ? (review.customer.display_location ? review.customer.display_location : '') : '';

                if(reviewRating && reviewText && reviewName) {
                    let reviewHTML = `
          <div class="review-stars-wrapper">
              <div class="review-stars star-rating"><div class="star-rating"><span class="star-rating-active" style="width:${reviewRating * 20}%"></span></div></div>
          </div>
          <p><strong>${reviewTitle}</strong><span>${reviewText}</span></p>
          <div>
              <svg width="34" height="34"><use xlink:href="/themes/lcvgroup/img/icons/heart.svg#heart"></use></svg>
              <div><p>${reviewName}</p><p>${reviewLocation}</p></div>
          </div>`;

                    let reviewNode = document.createElement('div');
                    reviewNode.classList.add('review-strip-grid-item');
                    reviewNode.innerHTML = reviewHTML;
                    reviewsStrip.querySelector('.review-strip-grid').prepend(reviewNode);

                    counter++;
                }
            })

            // Review Slider
            const reviewSlider = document.querySelector('.review-strip .review-strip-grid');
            if (reviewSlider) {
                const glider = new Glider(reviewSlider, {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    draggable: true,
                    dots: '.review-strip .dots',
                    scrollLock: true,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 1281,
                            settings: {
                                slidesToShow: 3
                            }
                        }
                    ]
                })
                sliderAuto(glider, 10000);
            }
            // END Review Slider
        } else {
            if(reviewsStrip){
                reviewsStrip.classList.add('visuallyhidden');
            }
        }

    }
    xhttp2.open("GET", "https://api.feefo.com/api/20/reviews/all?merchant_identifier=low-cost-vans");
    xhttp2.send();

    // Derivative Video
    let dealReview = document.querySelector('#review-video');
    let dealReviewVideo = document.querySelector('#review-video .embed-responsive');
    if (dealReview && dealReviewVideo){
        dealReviewVideo.addEventListener('click', () => {
            document.querySelector('#review-video .video-icon').classList.add('visuallyhidden');
        })
    }


    // Opening Times
    const openingSection = document.querySelector('.opening-times');
    const header = document.querySelector('#navbar');

    let mediaQueryList = window.matchMedia("(max-width: 1200px)");

    function updateHeight(mql) {
        if (header && openingSection) {
            if (mql.matches) {
                openingSection.setAttribute('style', `top:${header.offsetHeight}px;`);
            } else {
                openingSection.setAttribute('style', `top:0px;`);
            }
        }
    }

    if (openingSection && header) {
        updateHeight(mediaQueryList);
        mediaQueryList.addEventListener("change", () => updateHeight(mediaQueryList));
        window.addEventListener('resize', () => updateHeight(mediaQueryList));
    }

    const data = [
        {}, // Sunday - closed
        { open: 8, close: 18 }, // Monday
        { open: 8, close: 18 }, // Tuesday
        { open: 8, close: 18 }, // Wednesday
        { open: 8, close: 18 }, // Thursday
        { open: 9, close: 17 }, // Friday
        { open: 9, close: 14 }, // Saturday
    ];

    let date = new Date();
    let openingTimes = getOpeningHours(date);
    let hour = date.getHours();
    let message = '';

// Check if it's currently open
    if (isCurrentlyOpen(openingTimes, hour)) {
        message = `We're open until <span>${formatHours(openingTimes.close)}</span> ${openingTimes.close < 17 ? 'today' : 'tonight'}`;

        document.querySelector('.opening-tag').innerHTML = 'OPEN';
    } else {
        // If closed, find the next opening time
        message = getNextOpeningMessage(date, hour, openingTimes);

        document.querySelector('.opening-tag').innerHTML = 'CLOSED';
    }

    document.querySelector('.opening-text').innerHTML = message;

    function getOpeningHours(date) {
        let dayOfWeek = date.getDay(); // 0 is Sunday, 1 is Monday, etc.
        return data[dayOfWeek];
    }

    function isCurrentlyOpen(openingTimes, hour) {
        return openingTimes.open <= hour && hour < openingTimes.close;
    }

    function formatHours(hour) {
        let amPm = hour >= 12 ? 'pm' : 'am';
        let formattedHour = hour % 12 || 12; // Convert 0 to 12 for midnight
        return `${formattedHour}${amPm}`;
    }

    function getNextOpeningMessage(date, hour, openingTimes) {
        if (hour < openingTimes.open) {
            // Opens later today
            return `We're back open <span>${formatHours(openingTimes.open)}</span> today`;
        } else {
            // Find next opening day
            let nextOpenDay;
            for (let i = 1; i <= 7; i++) {
                nextOpenDay = new Date(date);
                nextOpenDay.setDate(date.getDate() + i);
                let nextOpeningTimes = getOpeningHours(nextOpenDay);

                if (nextOpeningTimes.open !== undefined) {
                    let dayName = i === 1 ? 'tomorrow' : 'on ' + formatDay(nextOpenDay);
                    return `We're back open <span>${formatHours(nextOpeningTimes.open)}</span> ${dayName}`;
                }
            }
        }
    }

    function formatDay(date) {
        let dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return dayNames[date.getDay()];
    }

// END Opening Times

});



setTimeout(function(){
    // Preloader
    document.querySelector('html').classList.add("site-loaded");
    document.body.classList.add("loaded");
    // END Preloader
}, 2000);


document.onload = (function(){
    // Preloader
    document.querySelector('html').classList.add("site-loaded");
    document.body.classList.add("loaded");
    // END Preloader
});

window.onload = (function(){
    // Preloader
    document.querySelector('html').classList.add("site-loaded");
    document.body.classList.add("loaded");
    // END Preloader

    // Load Sidebar Search
    if (document.getElementsByClassName('search-aside').length > 0) {
        updateSearchToggles();
        loadSearchTriggers();
    }

    // Load Search Form
    function loadSearchForm () {

        // Load Homepage Search Form
        if(document.getElementsByClassName('search-bar-hero').length>0){
            let hiddenField = document.querySelector('#search-type');

            loadManufacturers(hiddenField.value);
            loadBodyTypes(hiddenField.value);

            document.querySelector('.search-bar-hero [name=make]').addEventListener("change", function (e) {
                loadBodyTypes(hiddenField.value);
            });
        }
    }
    loadSearchForm();
    // END Load Search Form


    // Range/Model Filters Mobile Popup
    const rangeFilterButton = document.querySelector('.range-filters-mobile .vehicle-filters');
    const rangeTermsButton = document.querySelector('.range-filters-mobile .vehicle-terms');
    const rangeSidebar = document.querySelector('#model-table-header');
    // const updateMobileResultsBtn = document.querySelector('.update-mobile-results');
    if(rangeFilterButton && rangeSidebar){
        const modalMobileFilters = new tingle.modal({
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['mobile-sidebar'],
            beforeOpen: function () {
                rangeSidebar ? modalMobileFilters.setContent(rangeSidebar.outerHTML) : null;
                // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
            },
            onOpen: function () {
                let searchAside = document.querySelector('#model-table-header');
                searchAside.remove();
                // let headerHeight = updateMobileResultsBtn.offsetHeight;
                // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
                // loadSearchTriggers();
                // updateSearchToggles();
                // loadSearchForm();
                // resetSearch()
                rangeTable()
                // updateMobileResults();
                setTimeout(() => { toggleAccordions(); }, 1000);
            },
            onClose: function() {
                // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
                rangeFilterButton.parentElement.classList.remove('is-active');
                let searchTingle = document.querySelector('.tingle-modal-box__content #model-table-header');
                document.querySelector('.model-table').prepend(searchTingle);
                // loadSearchTriggers();
                // updateSearchToggles();
                // loadSearchForm();
                // resetSearch()
                rangeTable()
                // updateMobileResults();
                setTimeout(() => { toggleAccordions(); }, 500);
            }
        });

        rangeFilterButton.addEventListener("click", function(e){
            rangeFilterButton.parentElement.classList.toggle('is-active');
            if(rangeFilterButton.parentElement.classList.contains("is-active")) {
                modalMobileFilters.open();
            } else{
                modalMobileFilters.close();
            }
        })
    }
    if(rangeTermsButton && rangeSidebar){
        const modalMobileTerms = new tingle.modal({
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['mobile-sidebar-terms'],
            beforeOpen: function () {
                // modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
                // specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
                rangeSidebar ? modalMobileTerms.setContent(rangeSidebar.outerHTML) : null;
                // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
            },
            onOpen: function () {
                let searchAside = document.querySelector('#model-table-header');
                searchAside.remove();
                // let headerHeight = updateMobileResultsBtn.offsetHeight;
                // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
                // loadSearchTriggers();
                // updateSearchToggles();
                // loadSearchForm();
                rangeTable()
                // document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
                // document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
                // updateMobileResults();
                setTimeout(() => { toggleAccordions(); }, 1000);
                // resetSearch()
            },
            onClose: function() {
                // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
                rangeTermsButton.parentElement.classList.remove('is-active');
                let searchTingle = document.querySelector('.tingle-modal-box__content #model-table-header');
                document.querySelector('.model-table').prepend(searchTingle);
                // loadSearchTriggers();
                // updateSearchToggles();
                // loadSearchForm();
                rangeTable()
                // updateMobileResults();
                // resetSearch()
                setTimeout(() => { toggleAccordions(); }, 500);
            }
        });

        rangeTermsButton.addEventListener("click", function(e){
            rangeTermsButton.parentElement.classList.toggle('is-active');
            if(rangeTermsButton.parentElement.classList.contains("is-active")) {
                modalMobileTerms.open();
            } else{
                modalMobileTerms.close();
            }
        })
    }
    // END Range/Model Filters Mobile Popup

    // Show Only Filters
    let searchToggles = document.querySelectorAll('.search-results .search-filters input');
    if (searchToggles) {
        searchToggles.forEach(value => {
            value.addEventListener('change', (e) => {
                let searchUrl = new URL(window.location.origin + '/car-leasing');
                let vans = (window.location.pathname.includes('van-leasing') || window.location.search.includes('search-type=van')) ? '/van-leasing' : '';
                (window.location.pathname.includes('van-leasing')) ? searchUrl = new URL(window.location.origin + '/van-leasing') : null;
                (e.target.value === 'special' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/special-offers') : null;
                (e.target.value === 'stock' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
                document.body.classList.remove('loaded');
                window.location.href = searchUrl;
            })
        })
    }
    // END Show Only Filters

});
